(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("navigo"));
	else if(typeof define === 'function' && define.amd)
		define(["navigo"], factory);
	else if(typeof exports === 'object')
		exports["laxar"] = factory(require("navigo"));
	else
		root["laxar"] = factory(root["navigo"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_33__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export codeIsUnreachable */
/* unused harmony export state */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * The *assert* module provides some simple assertion methods for type checks, truthyness tests and guards
 * invalid code paths.
 * When importing the module as `default` module, it is the {@link assert} function itself.
 *
 * It can be imported as `assert` from 'laxar';
 *
 * @module assert
 */

/**
 * Constructor for an Assertion.
 *
 * @param {*} subject
 *    the object assertions are made for
 * @param {String} [optionalDetails]
 *    details that should be printed in case no specific details are given for an assertion method
 *
 * @constructor
 * @private
 */
function Assertion(subject, optionalDetails) {
   this.subject_ = subject;
   this.details_ = optionalDetails || null;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Throws an error if the subject is `null` or `undefined`.
 *
 * @param {String} [optionalDetails]
 *    details to append to the error message
 *
 * @return {Assertion}
 *    this instance
 */
Assertion.prototype.isNotNull = function isNotNull(optionalDetails) {
   if (this.subject_ == null) {
      fail('Expected value to be defined and not null.', optionalDetails || this.details_);
   }

   return this;
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Throws an error if the subject is not of the given type. No error is thrown for `null` or `undefined`.
 *
 * @param {Function} type
 *    the expected type of the subject
 * @param {String} [optionalDetails]
 *    details to append to the error message
 *
 * @return {Assertion}
 *    this instance
 */
Assertion.prototype.hasType = function hasType(type, optionalDetails) {
   if (typeof this.subject_ === 'undefined' || this.subject_ === null) {
      return this;
   }

   if (typeof type !== 'function') {
      fail('type must be a constructor function. Got ' + (typeof type === 'undefined' ? 'undefined' : _typeof(type)) + '.');
   }

   if (!checkType(this.subject_, type)) {
      var actualString = functionName(this.subject_.constructor);
      var expectedString = functionName(type);

      fail('Expected value to be an instance of "' + expectedString + '" but was "' + actualString + '".', optionalDetails || this.details_);
   }

   return this;
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Throws an error if the subject is no object or the given property is not defined on it.
 *
 * @param {String} property
 *    the property that is expected for the subject
 * @param {String} [optionalDetails]
 *    details to append to the error message
 *
 * @return {Assertion}
 *    this instance
 */
Assertion.prototype.hasProperty = function hasProperty(property, optionalDetails) {
   if (_typeof(this.subject_) !== 'object') {
      fail('value must be an object. Got ' + _typeof(this.subject_) + '.');
   }

   if (!(property in this.subject_)) {
      fail('value is missing mandatory property "' + property + '".', optionalDetails || this.details_);
   }

   return this;
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function fail(message, optionalDetails) {
   var details = '';
   if (optionalDetails) {
      var detailString = (typeof optionalDetails === 'undefined' ? 'undefined' : _typeof(optionalDetails)) === 'object' ? JSON.stringify(optionalDetails) : optionalDetails;
      details = ' Details: ' + detailString;
   }
   throw new Error('Assertion error: ' + message + details);
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

var TYPE_TO_CONSTRUCTOR = {
   'string': String,
   'number': Number,
   'boolean': Boolean,
   'function': Function
};
function checkType(subject, type) {
   if ((typeof subject === 'undefined' ? 'undefined' : _typeof(subject)) === 'object') {
      return subject instanceof type;
   }

   var actualType = TYPE_TO_CONSTRUCTOR[typeof subject === 'undefined' ? 'undefined' : _typeof(subject)];
   return actualType === type;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

var FUNCTION_NAME_MATCHER = /^function ([^(]*)\(/i;
function functionName(func) {
   var match = FUNCTION_NAME_MATCHER.exec(func.toString().trim());
   return match[1].length ? match[1] : 'n/a';
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Creates and returns a new `Assertion` instance for the given `subject`.
 *
 * **Note**: this function is no member of the module, but the module itself. Thus when using `assert` via
 * laxar, `assert` is will be no simple object, but this function having the other functions as
 * properties.
 *
 * Example:
 * ```js
 * import { assert } from 'laxar';
 * assert( assert ).hasType( Function );
 * assert.state( typeof assert.codeIsUnreachable === 'function' );
 * ```
 *
 * @param {*} subject
 *    the object assertions are made for
 * @param {String} [optionalDetails]
 *    details that should be printed in case no specific details are given when calling an assertion method
 *
 * @return {Assertion}
 *    the assertion instance
 */
function assert(subject, optionalDetails) {
   return new Assertion(subject, optionalDetails);
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Marks a code path as erroneous by throwing an error when reached.
 *
 * @param {String} [optionalDetails]
 *    details to append to the error message
 */
assert.codeIsUnreachable = function codeIsUnreachable(optionalDetails) {
   fail('Code should be unreachable!', optionalDetails);
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Throws an error if the given expression is falsy.
 *
 * @param {*} expression
 *    the expression to test for truthyness
 * @param {String} [optionalDetails]
 *    details to append to the error message
 */
assert.state = function state(expression, optionalDetails) {
   if (!expression) {
      fail('State does not hold.', optionalDetails);
   }
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/* harmony default export */ __webpack_exports__["a"] = (assert);
var codeIsUnreachable = assert.codeIsUnreachable;
var state = assert.state;

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["options"] = options;
/* harmony export (immutable) */ __webpack_exports__["forEach"] = forEach;
/* harmony export (immutable) */ __webpack_exports__["path"] = path;
/* harmony export (immutable) */ __webpack_exports__["setPath"] = setPath;
/* harmony export (immutable) */ __webpack_exports__["deepClone"] = deepClone;
/* harmony export (immutable) */ __webpack_exports__["tabulate"] = tabulate;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */

/**
 * Utilities for dealing with objects.
 *
 * It can be imported as `object` from 'laxar';
 *
 * @module object
 */

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Returns all properties from `obj` with missing properties completed from `defaults`. If `obj` is `null`
 * or `undefined`, an empty object is automatically created. `obj` and `defaults` are not modified by this
 * function. This is very useful for optional map arguments, resembling some kind of configuration.
 *
 * Example:
 * ```js
 * import { object } from 'laxar';
 * object.options( { validate: true }, {
 *    validate: false,
 *    highlight: true
 * } );
 * // =>
 * // {
 * //    validate: true,
 * //    highlight: true
 * // }
 * ```
 *
 * @param {Object} obj
 *    the options object to use as source, may be `null` or `undefined`
 * @param {Object} defaults
 *    the defaults to take missing properties from
 *
 * @return {Object}
 *    the completed options object
 */
function options(obj, defaults) {
   return Object.assign({}, defaults, obj);
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Iterates over the keys of an object and calls the given iterator function for each entry.
 * On each iteration the iterator function is passed the `value`, the `key` and the complete `object` as
 * arguments.
 * If `object` is an array, the native `Array.prototype.forEach` function is called.
 * In this case the keys are the indices of the array.
 *
 * Example:
 * ```
 * import { object } from 'laxar';
 * object.forEach( { name: Peter, age: 12 }, ( value, key ) => {
 *    console.log( `${key} = ${value}\n` );
 * } );
 * // =>
 * // name = Peter
 * // age = 12
 * ```
 *
 * @param {Object} object
 *    the object to run the iterator function on
 * @param {Function} iteratorFunction
 *    the iterator function to run on each key-value pair
 */
function forEach(object, iteratorFunction) {
   if (Array.isArray(object)) {
      object.forEach(iteratorFunction);
      return;
   }

   for (var key in object) {
      if (hasOwnProperty(object, key)) {
         iteratorFunction(object[key], key, object);
      }
   }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Finds a property in a nested object structure by a given path. A path is a string of keys, separated
 * by a dot from each other, used to traverse that object and find the value of interest. An additional
 * default is returned, if otherwise the value would yield `undefined`.
 *
 * Note that `path()` must only be used in situations where all path segments are also valid
 * JavaScript identifiers, and should never be used with user-specified paths:
 *
 *  - there is no mechanism to escape '.' in path segments; a dot always separates keys,
 *  - an empty string as a path segment will abort processing and return the entire sub-object under the
 *    respective position. For historical reasons, the path interpretation differs from that performed by
 *    {@link #setPath()}.
 *
 *
 * Example:
 *
 * ```js
 * import { object } from 'laxar';
 * object.path( { one: { two: 3 } }, 'one.two' ); // => 3
 * object.path( { one: { two: 3 } }, 'one.three' ); // => undefined
 * object.path( { one: { two: 3 } }, 'one.three', 42 ); // => 42
 * object.path( { one: { two: 3 } }, 'one.' ); // => { two: 3 }
 * object.path( { one: { two: 3 } }, '' ); // => { one: { two: 3 } }
 * object.path( { one: { two: 3 } }, '.' ); // => { one: { two: 3 } }
 * ```
 *
 * @param {Object} obj
 *    the object to traverse
 * @param {String} thePath
 *    the path to search for
 * @param {*} [optionalDefault]
 *    the value to return instead of `undefined` if nothing is found
 *
 * @return {*}
 *    the value at the given path
 */
function path(obj, thePath) {
   var optionalDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

   var pathArr = thePath.split('.');
   var node = obj;
   var key = pathArr.shift();

   while (key) {
      if (node && (typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object' && hasOwnProperty(node, key)) {
         node = node[key];
         key = pathArr.shift();
      } else {
         return optionalDefault;
      }
   }

   return node;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Sets a property in a nested object structure at a given path to a given value. A path is a string of
 * keys, separated by a dot from each other, used to traverse that object and find the place where the
 * value should be set. Any missing subtrees along the path are created.
 *
 * Note that `setPath()` must only be used in situations where all path segments are also valid
 * JavaScript identifiers, and should never be used with user-specified paths:
 *
 *  - there is no mechanism to escape '.' in path segments; a dot will always create separate keys,
 *  - an empty string as a path segment will create an empty string key in the object graph where missing.
 *    For historical reasons, this path interpretation differs from that performed by #path (see there).
 *
 *
 * Example:
 *
 * ```js
 * import { object } from 'laxar';
 * object.setPath( {}, 'name.first', 'Peter' ); // => { name: { first: 'Peter' } }
 * object.setPath( {}, 'pets.1', 'Hamster' ); // => { pets: [ null, 'Hamster' ] }
 * object.setPath( {}, '', 'Hamster' ); // => { '': 'Hamster' } }
 * object.setPath( {}, '.', 'Hamster' ); // => { '': { '': 'Hamster' } } }
 * ```
 *
 * @param {Object} obj
 *    the object to modify
 * @param {String} path
 *    the path to set a value at
 * @param {*} value
 *    the value to set at the given path
 *
 * @return {*}
 *    the full object (for chaining)
 */
function setPath(obj, path, value) {
   var node = obj;
   var pathArr = path.split('.');
   var last = pathArr.pop();

   pathArr.forEach(function (pathFragment, index) {
      if (!node[pathFragment] || _typeof(node[pathFragment]) !== 'object') {
         var lookAheadFragment = pathArr[index + 1] || last;
         if (lookAheadFragment.match(/^[0-9]+$/)) {
            node[pathFragment] = [];
            fillArrayWithNull(node[pathFragment], parseInt(lookAheadFragment, 10));
         } else {
            node[pathFragment] = {};
         }
      }

      node = node[pathFragment];
   });

   if (Array.isArray(node) && last > node.length) {
      fillArrayWithNull(node, last);
   }

   node[last] = value;

   return obj;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Returns a deep clone of the given object. Note that the current implementation is intended to be used
 * for simple object literals only. There is no guarantee that cloning objects instantiated via
 * constructor function works and cyclic references will lead to endless recursion.
 *
 * @param {*} object
 *    the object to clone
 *
 * @return {*}
 *    the clone
 */
function deepClone(object) {
   if (!object || (typeof object === 'undefined' ? 'undefined' : _typeof(object)) !== 'object') {
      return object;
   }

   // Using plain for-loops here for performance-reasons.
   var result = void 0;
   if (Array.isArray(object)) {
      result = [];
      for (var i = 0, length = object.length; i < length; ++i) {
         result[i] = deepClone(object[i]);
      }
   } else {
      result = {};
      for (var key in object) {
         if (hasOwnProperty(object, key)) {
            result[key] = deepClone(object[key]);
         }
      }
   }

   return result;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Creates a lookup table from a function and a list of inputs to the function.
 *
 * @param {Function} fn
 *    The callback to apply to all inputs
 * @param {String[]|Number[]|Boolean[]} keys
 *    The keys for the lookup table, and inputs to the function.
 *
 * @return {Object}
 *    An object mapping the given keys to their values under `fn`.
 */
function tabulate(fn, keys) {
   return keys.reduce(function (table, k) {
      table[k] = fn(k);return table;
   }, {});
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

// eslint-disable-next-line valid-jsdoc
/**
 * Sets all entries of the given array to `null`.
 *
 * @private
 */
function fillArrayWithNull(arr, toIndex) {
   for (var i = arr.length; i < toIndex; ++i) {
      arr[i] = null;
   }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

var hasOwnProp = Object.prototype.hasOwnProperty;
// eslint-disable-next-line valid-jsdoc
/**
 * @private
 */
function hasOwnProperty(object, property) {
   return hasOwnProp.call(object, property);
}

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_FORMATTERS", function() { return DEFAULT_FORMATTERS; });
/* harmony export (immutable) */ __webpack_exports__["format"] = format;
/* harmony export (immutable) */ __webpack_exports__["createFormatter"] = createFormatter;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * Utilities for dealing with strings.
 *
 * It can be imported as `string` from 'laxar';
 *
 * @module string
 */

//
var BACKSLASH = '\\';
var OPENING_BRACKET = '[';
var CLOSING_BRACKET = ']';
var INTEGER_MATCHER = /^[0-9]+$/;

/**
 * A map of all available default format specifiers to their respective formatter function.
 * The following specifiers are available:
 *
 * - `%d` / `%i`: Format the given numeric value as integer. Decimal places are removed
 * - `%f`: Format the given numeric value as floating point value. This specifier supports precision as
 *   sub-specifier (e.g. `%.2f` for 2 decimal places)
 * - `%s`: use simple string serialization using `toString`
 * - `%o`: Format complex objects using `JSON.stringify`
 *
 * @type {Object}
 * @name DEFAULT_FORMATTERS
 */
var DEFAULT_FORMATTERS = Object.freeze({
   's': function s(input) {
      return '' + input;
   },
   'd': function d(input) {
      return input.toFixed(0);
   },
   'i': function i(input, subSpecifierString) {
      return DEFAULT_FORMATTERS.d(input, subSpecifierString);
   },
   'f': function f(input, subSpecifierString) {
      var precision = subSpecifierString.match(/^\.(\d)$/);
      if (precision) {
         return input.toFixed(precision[1]);
      }

      return '' + input;
   },
   'o': function o(input) {
      return JSON.stringify(input);
   },
   'default': function _default(input, subSpecifierString) {
      return DEFAULT_FORMATTERS.s(input, subSpecifierString);
   }
});

var DEFAULT_FORMATTER = createFormatter(DEFAULT_FORMATTERS);

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Substitutes all unescaped placeholders in the given string for a given indexed or named value.
 * A placeholder is written as a pair of brackets around the key of the placeholder. An example of an
 * indexed placeholder is `[0]` and a named placeholder would look like this `[replaceMe]`. If no
 * replacement for a key exists, the placeholder will simply not be substituted.
 *
 * Some examples:
 * ```js
 * import { string } from 'laxar';
 * string.format( 'Hello [0], how do you like [1]?', [ 'Peter', 'Cheeseburgers' ] );
 * // => 'Hello Peter, how do you like Cheeseburgers?'
 *
 * string.format( 'Hello [name] and [partner], how do you like [0]?', [ 'Pizza' ], {
 *    name: 'Hans',
 *    partner: 'Roswita'
 * } );
 * // => 'Hello Hans and Roswita, how do you like Pizza?'
 * ```
 *
 * If a pair of brackets should not be treated as a placeholder, the opening bracket must be escaped by
 * backslashes. To get an actual backslash in a JavaScript string literal, which is then treated as
 * an escape symbol, it needs to be written as double backslash:
 *
 * ```js
 * import { string } from 'laxar';
 * string.format( 'A [something] should eventually only have \\[x].', {
 *    something: 'checklist'
 * } );
 * // => 'A checklist should eventually only have [x].'
 * ```
 *
 * A placeholder key can be any character string besides `[`, `]` and `:` to keep parsing simple and fast.
 * By using `:` as separator it is possible to provide a type specifier for string serialization or to add
 * a custom mapping function. Type specifiers always begin with `%` and end with the specifier type.
 * Builtin specifiers and their corresponding formatter functions are defined as {@link DEFAULT_FORMATTERS}.
 *
 * When no specifier is provided, by default `%s` is assumed.
 *
 * Example:
 * ```js
 * import { string } from 'laxar';
 * string.format( 'Hello [0:%s], you owe me [1:%.2f] euros.', [ 'Peter', 12.1243 ] );
 * // => 'Hello Peter, you owe me 12.12 euros.'
 * ```
 *
 * Mapping function names should be composed from alphanumeric characters, like regular JavaScript
 * identifiers. They can be registered using {@link #createFormatter()}:
 * ```js
 * import { string } from 'laxar';
 * const format = string.createFormatter( null, {
 *    double: x => 2*x,
 *    flip: s => s.split( '' ).reverse().join( '' )
 * } );
 * format( 'Hello [0:%s:flip], you owe me [1:double:%.2f] euros.', [ 'Peter', 12 ] );
 * // => 'Hello reteP, you owe me 24.00 euros.'
 * ```
 *
 * Currently there are no builtin mapping functions.
 *
 * If a type specifier is used that does not exist, an exception is thrown. In contrast to that the use of
 * an unknown mapping function results in a no-op. This allows to use filter-like functions that transform
 * marked values within a specific context (for example, performing anonymization during analytics logging),
 * without modifying the value in other contexts (local debug loggign).
 *
 * @param {String} string
 *    the string to replace placeholders in
 * @param {Array} [optionalIndexedReplacements]
 *    an optional array of indexed replacements
 * @param {Object} [optionalNamedReplacements]
 *    an optional map of named replacements
 *
 * @return {String}
 *    the string with placeholders substituted for their according replacements
 */
function format(string, optionalIndexedReplacements, optionalNamedReplacements) {
   return DEFAULT_FORMATTER(string, optionalIndexedReplacements, optionalNamedReplacements);
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Creates a new format function having the same api as {@link #format()}. If the first argument is
 * omitted or `null`, the default formatters for type specifiers are used. Otherwise only the provided map
 * of specifiers is available to the returned format function. Each key of the map is a specifier character
 * where the `%` is omitted and the value is the formatting function. A formatting function receives the
 * value to format (i.e. serialize) and the sub-specifier (if any) as arguments. For example for the format
 * specifier `%.2f` the sub-specifier would be `.2` where for `%s` it would simply be the empty string.
 *
 * Example:
 * ```js
 * const format = string.createFormatter( {
 *    'm': function( value ) {
 *       return value.amount + ' ' + value.currency;
 *    },
 *    'p': function( value, subSpecifier ) {
 *       return Math.pow( value, parseInt( subSpecifier, 10 ) );
 *    }
 * } );
 *
 * format( 'You owe me [0:%m].', [ { amount: 12, currency: 'EUR' } ] );
 * // => 'You owe me 12 EUR.'
 *
 * format( '[0]^3 = [0:%3p]', [ 2 ] );
 * // => '2^3 = 8'
 * ```
 *
 * The second argument is completely additional to the behavior of the default {@link #format()}
 * function. Here a map from mapping function id to actual mapping function can be passed in. Whenever the
 * id of a mapping function is found within the placeholder, that mapping function is called with the
 * current value and its return value is either passed to the next mapping function or rendered
 * instead of the placeholder if there are no more mapping function ids or type specifiers within the
 * placeholder string.
 *
 * ```js
 * const format = string.createFormatter( null, {
 *    flip: function( value ) {
 *       return ( '' + s ).split( '' ).reverse().join( '' );
 *    },
 *    double: function( value ) {
 *       return value * 2;
 *    }
 * } );
 *
 * format( 'Hello [0:%s:flip], you owe me [1:double:%.2f] euros.', [ 'Peter', 12 ] );
 * // => 'Hello reteP, you owe me 24.00 euros.'
 * ```
 *
 * @param {Object} typeFormatters
 *    map from format specifier (single letter without leading `%`) to formatting function
 * @param {Object} [optionalValueMappers]
 *    map from mapping identifier to mapping function
 *
 * @return {Function}
 *    a function having the same api as {@link #format()}
 */
function createFormatter() {
   var typeFormatters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FORMATTERS;
   var optionalValueMappers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


   function format(string, optionalIndexedReplacements, optionalNamedReplacements) {
      if (typeof string !== 'string') {
         return defaultTypeFormatter(typeFormatters)(string);
      }

      var indexed = Array.isArray(optionalIndexedReplacements) ? optionalIndexedReplacements : [];
      var named = {};
      if (optionalNamedReplacements) {
         named = optionalNamedReplacements || {};
      } else if (!Array.isArray(optionalIndexedReplacements)) {
         named = optionalIndexedReplacements || {};
      }

      var chars = string.split('');
      var output = '';
      for (var i = 0, len = chars.length; i < len; ++i) {
         if (chars[i] === BACKSLASH) {
            if (i + 1 === len) {
               throw new Error('Unterminated escaping sequence at index ' + i + ' of string: "' + string + '".');
            }

            output += chars[++i];
         } else if (chars[i] === OPENING_BRACKET) {
            var closingIndex = string.indexOf(CLOSING_BRACKET, i + 1);
            if (closingIndex === -1) {
               throw new Error('Unterminated placeholder at index ' + i + ' of string: "' + string + '".');
            }

            var key = string.substring(i + 1, closingIndex);

            output += replacePlaceholder(key, named, indexed, { string: string, index: i });

            i = closingIndex;
         } else {
            output += chars[i];
         }
      }
      return output;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function replacePlaceholder(placeholder, named, indexed, context) {
      var specifier = '';
      var subSpecifierString = '';
      var placeholderParts = placeholder.split(':');
      var key = placeholderParts[0];

      var value = void 0;
      if (INTEGER_MATCHER.test(key) && key < indexed.length) {
         value = indexed[key];
      } else if (key in named) {
         value = named[key];
      } else {
         return OPENING_BRACKET + placeholder + CLOSING_BRACKET;
      }

      if (placeholderParts.length > 1) {

         if (placeholderParts[1].charAt(0) !== '%') {
            value = defaultTypeFormatter(typeFormatters)(value);
         }

         return placeholderParts.slice(1).reduce(function (value, part) {
            if (part.indexOf('%') === 0) {
               var specifierMatch = part.match(/^%(.*)(\w)$/);
               specifier = specifierMatch ? specifierMatch[2] : '';
               subSpecifierString = specifierMatch ? specifierMatch[1] : '';
               if (specifier in typeFormatters) {
                  return typeFormatters[specifier](value, subSpecifierString);
               }
               var knownSpecifiers = Object.keys(typeFormatters).filter(function (_) {
                  return _ !== 'default';
               }).map(function (_) {
                  return '%' + _;
               }).join(', ');

               throw new Error('Unknown format specifier "%' + specifier + '" for placeholder' + (' at index ' + context.index + ' of string: "' + context.string + '"') + (' (Known specifiers are: ' + knownSpecifiers + ').'));
            }
            if (part in optionalValueMappers) {
               return optionalValueMappers[part](value);
            }

            return value;
         }, value);
      }

      return defaultTypeFormatter(typeFormatters)(value);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   return format;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function defaultTypeFormatter(typeFormatters) {
   if ('default' in typeFormatters) {
      return typeFormatters['default'];
   }

   return DEFAULT_FORMATTERS['default'];
}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_assert__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_object__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["a"] = createLogErrorHandler;
/* harmony export (immutable) */ __webpack_exports__["b"] = create;
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * Module providing the EventBus factory.
 *
 * To use the EventBus in a widget, request the {@link widget_services#axEventBus axEventBus} injection, or
 * use the `eventBus` property on the {@link widget_services#axContext axContext} injection.
 * In some cases, it may be useful to inject the global EventBus instance backing all widget instances of the
 * same bootstrapping context, by requesting the {@link widget_services#axGlobalEventBus axGlobalEventBus}
 * injection.
 *
 * @module event_bus
 */



var WILDCARD = '*';
var SUBSCRIBER_FIELD = '.';

var TOPIC_SEPARATOR = '.';
var SUB_TOPIC_SEPARATOR = '-';
var REQUEST_MATCHER = /^([^.])([^.]*)Request(\..+)?$/;

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * @param {Object} configuration
 *    configuration for the event bus instance.
 *    The key `eventBusTimeoutMs` is used to determine the will/did timeout.
 * @param {Function} nextTick
 *    a next tick function like `process.nextTick`, `setImmediate` or AngularJS' `$timeout`
 * @param {Function} timeoutFunction
 *    a timeout function like `window.setTimeout` or AngularJS' `$timeout`
 * @param {Function} [errorHandler]
 *    a custom handler for thrown exceptions.
 *
 * @constructor
 * @private
 */
function EventBus(configuration, nextTick, timeoutFunction, errorHandler) {
   this.nextTick_ = function (f) {
      return nextTick(f);
   };
   this.timeoutFunction_ = function (f, ms) {
      return timeoutFunction(f, ms);
   };
   this.timeoutMs_ = configuration.ensure('eventBusTimeoutMs');
   this.errorHandler_ = errorHandler;

   this.cycleCounter_ = 0;
   this.eventQueue_ = [];
   this.subscriberTree_ = {};

   this.waitingPromiseResolves_ = [];
   this.currentCycle_ = -1;
   this.inspectors_ = [];
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Adds an inspector, that gets notified when certain actions within the event bus take place. Currently
 * these actions may occur:
 *
 * - `subscribe`: a new subscriber registered for an event
 * - `publish`: an event is published but not yet delivered
 * - `deliver`: an event is actually delivered to a subscriber
 *
 * An inspector receives a map with the following properties:
 *
 * - `action`: one of the actions from above
 * - `source`: the origin of the `action`
 * - `target`: the name of the event subscriber (`deliver` action only)
 * - `event`: the full name of the event or the subscribed event (`subscribe` action only)
 * - `eventObject`: the published event item (`publish` action only)
 * - `subscribedTo`: the event, possibly with omissions, the subscriber subscribed to (`deliver` action only)
 * - `cycleId`: the id of the event cycle
 *
 * The function returned by this method can be called to remove the inspector again and prevent it from
 * being called for future event bus actions.
 *
 * @param {Function} inspector
 *    the inspector function to add
 *
 * @return {Function}
 *    a function to remove the inspector
 */
EventBus.prototype.addInspector = function (inspector) {
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(inspector).hasType(Function).isNotNull();

   this.inspectors_.push(inspector);
   return function () {
      var index = this.inspectors_.indexOf(inspector);
      if (index !== -1) {
         this.inspectors_.splice(index, 1);
      }
   }.bind(this);
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Subscribes to an event by name. An event name consists of so called *topics*, where each topic is
 * separated from another by dots (`.`). If a topic is omitted, this is treated as a wildcard. Note that
 * two dots in the middle or one dot at the beginning of an event name must remain, whereas a dot at the
 * end may be omitted. As such every event name has an intrinsic wildcard at its end. For example these are
 * all valid event names:
 *
 * - `some.event`: matches `some.event`, `some.event.again`
 * - `.event`: matches `some.event`, `any.event`, `any.event.again`
 * - `some..event`: matches `some.fancy.event`, `some.special.event`
 *
 * Additionally *subtopics* are supported. Subtopics are fragments of a topic, separated from another by
 * simple dashes (`-`). Here only suffixes of subtopics may be omitted when subscribing. Thus subscribing
 * to `some.event` would match an event published with name `some.event-again` or even
 * `some.event-another.again`.
 *
 * **The subscriber function**
 *
 * When an event is delivered, the subscriber function receives two arguments:
 * The first one is the event object as it was published. If `optionalOptions.clone` yields `true` this is a
 * simple deep copy of the object (note that only properties passing a JSON-(de)serialization remain). If
 * `false` the object is frozen using `Object.freeze` recursively.
 *
 * The second one is a meta object with these properties:
 *
 * - `name`: The name of the event as it actually was published (i.e. without wildcards).
 * - `cycleId`: The id of the cycle the event was published (and delivered) in
 * - `sender`: The id of the event sender, may be `null`.
 * - `initiator`: The id of the initiator of the cycle. Currently not implemented, thus always `null`.
 * - `options`: The options that were passed to `publish` or `publishAndGatherReplies` respectively.
 *
 * @param {String} eventName
 *    the name of the event to subscribe to
 * @param {Function} subscriber
 *    a function to call whenever an event matching `eventName` is published
 * @param {Object} [optionalOptions]
 *    additional options for the subscribe action
 * @param {String} [optionalOptions.subscriber=null]
 *    the id of the subscriber. Default is `null`
 * @param {Boolean} [optionalOptions.clone=true]
 *    if `false` the event will be send frozen to the subscriber, otherwise it will receive a deep copy.
 *    Default is `true`
 *
 * @return {Function}
 *    a function that when called unsubscribes from this subscription again
 */
EventBus.prototype.subscribe = function (eventName, subscriber, optionalOptions) {
   var _this = this;

   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(eventName).hasType(String).isNotNull();
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(subscriber).hasType(Function).isNotNull();

   var options = __WEBPACK_IMPORTED_MODULE_1__utilities_object__["options"](optionalOptions, {
      subscriber: null,
      clone: true
   });
   var subscriberItem = {
      name: eventName,
      subscriber: subscriber,
      subscriberName: options.subscriber,
      subscriptionWeight: calculateSubscriptionWeight(eventName),
      options: options
   };

   var eventNameParts = eventName.split(TOPIC_SEPARATOR);
   var node = eventNameParts.reduce(function (node, eventNamePart) {
      var bucketName = eventNamePart || WILDCARD;
      if (!(bucketName in node)) {
         node[bucketName] = {};
      }
      return node[bucketName];
   }, this.subscriberTree_);

   if (!(SUBSCRIBER_FIELD in node)) {
      node[SUBSCRIBER_FIELD] = [];
   }
   node[SUBSCRIBER_FIELD].push(subscriberItem);

   notifyInspectors(this, {
      action: 'subscribe',
      source: options.subscriber,
      target: '-',
      event: eventName,
      cycleId: this.currentCycle_
   });

   return function () {
      unsubscribeRecursively(_this, _this.subscriberTree_, eventNameParts, subscriber);
   };
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Asynchronously publishes an event on the event bus. The returned promise will be enqueued as soon as this
 * event is delivered and, if during delivery a new event was enqueued, resolved after that new event was
 * delivered. If no new event is published during delivery of this event, the promise is instantly resolved.
 * To make this a bit clearer, lets assume we publish and thus enqueue an event at time `t`. It then will
 * be delivered at time `t+1`. At that precise moment the promise is enqueued to be resolved soon. We then
 * distinguish between two cases:
 *
 * - At time `t+1` no subscriber publishes (i.e. enqueues) an event: Thus there is no event in the same
 *   cycle and the promise is also resolved at time `t+1`.
 * - At least one subscriber publishes an event at time `t+1`: The promise is then scheduled to be resolved
 *   as soon as this event is delivered at time `t+2`.
 *
 * The implication of this is the following:
 *
 * We have two collaborators, A and B. A listens to event b and B listens to event a.
 * Whenever A publishes a and B than instantly (i.e. in the same event cycle of the JavaScript runtime
 * where its subscriber function was called) *responds* by publishing b, b arrives at the subscriber
 * function of A, before the promise of A's publish action is resolved.
 * It is hence possible to observe possible effects of an event sent by oneself, under the conditions
 * mentioned above. Practically this is used internally for the implementation of
 * {@link #EventBus.publishAndGatherReplies()}.
 *
 * @param {String} eventName
 *    the name of the event to publish
 * @param {Object} [optionalEvent]
 *    the event to publish
 * @param {Object} [optionalOptions]
 *    additional options for the publish action
 * @param {String} [optionalOptions.sender=null]
 *    the id of the event sender. Default is `null`
 * @param {Boolean} [optionalOptions.deliverToSender=true]
 *    if `false` the event will not be send to subscribers whose subscriber name matches
 *    `optionalOptions.sender`, else all subscribers will receive the event. Default is `true`
 *
 * @return {Promise}
  *   the delivery promise
 */
EventBus.prototype.publish = function (eventName) {
   var _this2 = this;

   var optionalEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
   var optionalOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(eventName).hasType(String).isNotNull();

   var event = JSON.parse(JSON.stringify(optionalEvent));
   var options = Object.assign({ deliverToSender: true, sender: null }, optionalOptions);

   return new Promise(function (resolve) {
      var eventItem = {
         meta: {
            name: eventName,
            cycleId: _this2.currentCycle_ > -1 ? _this2.currentCycle_ : _this2.cycleCounter_++,
            sender: options.sender,
            initiator: null,
            options: options
         },
         event: event,
         resolvePublish: resolve
      };
      enqueueEvent(_this2, eventItem);

      notifyInspectors(_this2, {
         action: 'publish',
         source: options.sender,
         target: '-',
         event: eventName,
         eventObject: event,
         cycleId: eventItem.meta.cycleId
      });
   });
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Publishes an event that follows the *request-will-did pattern* and awaits all replies. This pattern has
 * evolved over time and is of great use when handling the asynchronous nature of event bus events.
 *
 * Certain rules need to be fulfilled: First the initiator needs to call this method with an event whose
 * name has the suffix `Request`, e.g. `takeActionRequest`. All collaborators that want to react to this
 * event then either do so in the same event cycle by sending a `didTakeAction` event or announce that they
 * will do something asynchronously by publishing a `willTakeAction` event. In the latter case they need to
 * broadcast the fulfillment of their action some time later by sending a `didTakeAction` event. Note that for
 * both events the same sender name needs to be given. Otherwise they cannot be mapped and the event bus
 * doesn't know if all asynchronous replies were already received.
 *
 * Additionally a timer is started using either the globally configured `pendingDidTimeout` ms value or the
 * value provided as option to this method. If that timer expires before all `did*` events to all given
 * `will*` events were received, the error handler is called to handle the incident and the promise is
 * rejected with all responses received up to now.
 *
 * @param {String} eventName
 *    the name of the event to publish
 * @param {Object} [optionalEvent]
 *    the event to publish
 * @param {Object} [optionalOptions]
 *    additional options for the publish action
 * @param {String} [optionalOptions.sender=null]
 *    the id of the event sender. Default is `null`
 * @param {Number} [optionalOptions.pendingDidTimeout]
 *    the timeout in milliseconds for pending did* events. Default is the timeout option used when the
 *    event bus instance was created
 *
 * @return {Promise}
 *   the delivery promise. It receives a list of all collected `did*` events and according meta information
 */
EventBus.prototype.publishAndGatherReplies = function (eventName, optionalEvent, optionalOptions) {
   var _this3 = this;

   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(eventName).hasType(String).isNotNull();

   var matches = REQUEST_MATCHER.exec(eventName);
   __WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */].state(!!matches, 'Expected eventName to end with "Request" but got ' + eventName);

   var options = Object.assign({ pendingDidTimeout: this.timeoutMs_ }, optionalOptions);

   var eventNameSuffix = matches[1].toUpperCase() + matches[2];
   if (matches[3]) {
      eventNameSuffix += matches[3];
   }
   var deferred = {};
   deferred.promise = new Promise(function (resolve, reject) {
      deferred.resolve = resolve;
      deferred.reject = reject;
   });
   var willWaitingForDid = [];
   var givenDidResponses = [];
   var cycleFinished = false;

   var unsubscribeWillCollector = this.subscribe('will' + eventNameSuffix, function (event, meta) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(meta.sender).hasType(String).isNotNull('A response with will to a request-event must contain a sender.');

      willWaitingForDid.push(meta.sender);
   }, { subscriber: options.sender });

   var unsubscribeDidCollector = this.subscribe('did' + eventNameSuffix, function (event, meta) {
      givenDidResponses.push({ event: event, meta: meta });
      var senderIndex = void 0;
      do {
         senderIndex = willWaitingForDid.indexOf(meta.sender);
         if (senderIndex !== -1) {
            willWaitingForDid.splice(senderIndex, 1);
         }
      } while (senderIndex !== -1);

      if (willWaitingForDid.length === 0 && cycleFinished) {
         finish();
      }
   }, { subscriber: options.sender });

   var timeoutRef = this.timeoutFunction_(function () {
      if (willWaitingForDid.length > 0) {
         var message = 'Timeout while waiting for pending did' + eventNameSuffix + ' on ' + eventName + '.';
         _this3.errorHandler_(message, {
            'Sender': options.sender,
            'After ms timeout': options.pendingDidTimeout,
            'Responses missing from': willWaitingForDid.join(', ')
         });
         finish(true);
      }
   }, options.pendingDidTimeout);

   this.publish(eventName, optionalEvent, options).then(function () {
      unsubscribeWillCollector();
      if (willWaitingForDid.length === 0) {
         // either there was no will or all did responses were already given in the same cycle as the will
         finish();
         return;
      }
      cycleFinished = true;
   });

   function finish(wasCanceled) {
      clearTimeout(timeoutRef);
      unsubscribeDidCollector();
      (wasCanceled ? deferred.reject : deferred.resolve)(givenDidResponses);
   }

   return deferred.promise;
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function enqueueEvent(self, eventItem) {
   if (self.eventQueue_.length === 0) {
      self.nextTick_(function () {
         var queuedEvents = self.eventQueue_;

         self.eventQueue_ = [];

         processWaitingPublishPromises(self, processQueue(self, queuedEvents));
      });
   }
   self.eventQueue_.push(eventItem);
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function processQueue(self, queuedEvents) {
   return queuedEvents.map(function (eventItem) {
      var meta = eventItem.meta;
      self.currentCycle_ = meta.cycleId;

      var subscribers = findSubscribers(self, meta.name);
      if (subscribers.length === 0) {
         self.currentCycle_ = -1;
         return eventItem.resolvePublish;
      }

      var serializedEvent = null;
      if (subscribers.length > 1) {
         serializedEvent = JSON.stringify(eventItem.event);
      }

      var senderName = meta.sender;
      var options = meta.options;

      subscribers.forEach(function (subscriberItem) {
         var subscriberName = subscriberItem.subscriberName;
         if (!options.deliverToSender && senderName && senderName === subscriberName) {
            return;
         }

         try {
            var event = void 0;
            if (subscriberItem.options.clone) {
               event = serializedEvent ? JSON.parse(serializedEvent) : eventItem.event;
            } else {
               event = eventItem.event;
            }
            subscriberItem.subscriber(event, meta);
         } catch (e) {
            var message = 'error while calling subscriber "' + subscriberName + '"' + (' for event ' + meta.name) + (' published by "' + senderName + '" (subscribed to: ' + subscriberItem.name + ')');
            self.errorHandler_(message, {
               'Exception': e,
               'Published event': eventItem.event,
               'Event meta information': meta,
               'Caused by Subscriber': subscriberItem
            });
         }

         notifyInspectors(self, {
            action: 'deliver',
            source: senderName,
            target: subscriberName,
            event: meta.name,
            eventObject: eventItem.event,
            subscribedTo: subscriberItem.name,
            cycleId: meta.cycleId
         });
      });

      self.currentCycle_ = -1;

      return eventItem.resolvePublish;
   });
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function processWaitingPublishPromises(self, newPromiseResolves) {
   var waitingResolves = self.waitingPromiseResolves_;
   self.waitingPromiseResolves_ = newPromiseResolves;

   waitingResolves.forEach(function (resolve) {
      return resolve();
   });

   if (self.eventQueue_.length === 0) {
      // nothing was queued by any subscriber. The publishers can instantly be notified of delivery.
      newPromiseResolves.forEach(function (resolve) {
         return resolve();
      });
      self.waitingPromiseResolves_ = [];
   }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function unsubscribeRecursively(self, node, parts, subscriber) {
   if (parts.length === 0 && Array.isArray(node[SUBSCRIBER_FIELD])) {
      var subscribers = node[SUBSCRIBER_FIELD];
      for (var i = subscribers.length - 1; i >= 0; --i) {
         if (subscribers[i].subscriber === subscriber) {
            notifyInspectors(self, {
               action: 'unsubscribe',
               source: subscribers[i].subscriberName,
               target: '-',
               event: subscribers[i].name,
               cycleId: self.currentCycle_
            });
            subscribers.splice(i, 1);
         }
      }
   }

   var _parts = _toArray(parts),
       part = _parts[0],
       rest = _parts.slice(1);

   var searchPart = part || WILDCARD;
   if (searchPart in node) {
      unsubscribeRecursively(self, node[searchPart], rest, subscriber);
   }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function findSubscribers(self, eventName) {
   var subscribers = [];
   var parts = eventName.split(TOPIC_SEPARATOR);
   var node = self.subscriberTree_;

   findSubscribersRecursively(node, parts, subscribers);
   subscribers.sort(function (a, b) {
      var aWeight = a.subscriptionWeight;
      var bWeight = b.subscriptionWeight;
      if (aWeight[0] === bWeight[0]) {
         return bWeight[1] - aWeight[1];
      }

      return bWeight[0] - aWeight[0];
   });

   return subscribers;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function findSubscribersRecursively(node, parts, subscribers) {
   if (Array.isArray(node[SUBSCRIBER_FIELD])) {
      subscribers.push.apply(subscribers, _toConsumableArray(node[SUBSCRIBER_FIELD]));
   }

   if (parts.length === 0) {
      return;
   }

   var _parts2 = _toArray(parts),
       part = _parts2[0],
       remainder = _parts2.slice(1);

   if (part.indexOf(SUB_TOPIC_SEPARATOR) !== -1) {
      var index = part.length;
      var currentPart = part;
      do {
         currentPart = currentPart.substring(0, index);
         if (currentPart in node) {
            findSubscribersRecursively(node[currentPart], remainder, subscribers);
         }
         index = currentPart.lastIndexOf(SUB_TOPIC_SEPARATOR);
      } while (index !== -1);
   } else if (part in node) {
      findSubscribersRecursively(node[part], remainder, subscribers);
   }

   if (WILDCARD in node) {
      findSubscribersRecursively(node[WILDCARD], remainder, subscribers);
   }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function calculateSubscriptionWeight(eventName) {
   var parts = eventName.split(TOPIC_SEPARATOR);
   var weight = [0, 0];
   parts.forEach(function (part) {
      if (part.length > 0) {
         weight[0]++;
         weight[1] += part.split(SUB_TOPIC_SEPARATOR).length - 1;
      }
   });
   return weight;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function notifyInspectors(self, infoObject) {
   self.inspectors_.forEach(function (inspector) {
      inspector(infoObject);
   });
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function createLogErrorHandler(log) {
   return function (message, optionalErrorInformation) {
      var sensitiveData = ['Published event'];

      log.error('EventBus: ' + message);

      if (optionalErrorInformation) {
         __WEBPACK_IMPORTED_MODULE_1__utilities_object__["forEach"](optionalErrorInformation, function (info, title) {
            var formatString = '   - [0]: [1:%o]';
            if (sensitiveData.indexOf(title) !== -1) {
               formatString = '   - [0]: [1:%o:anonymize]';
            }

            log.error(formatString, title, info);

            if (info instanceof Error && info.stack) {
               log.error('   - Stacktrace: ' + info.stack);
            }
         });
      }
   };
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Creates and returns a new event bus instance using the given configuration.
 *
 * @param {Object} configuration
 *    configuration for the event bus instance.
 *    The key `eventBusTimeoutMs` is used to determine the will/did timeout.
 * @param {Function} nextTick
 *    a next tick function like `process.nextTick` or AngularJS' `$timeout`
 * @param {Function} timeoutFunction
 *    a timeout function like `window.setTimeout` or AngularJS' `$timeout`
 * @param {Function} [errorHandler]
 *    a custom handler for thrown exceptions.
 *
 * @return {EventBus}
 *    an event bus instance
 *
 * @private
 */
function create(configuration, nextTick, timeoutFunction, errorHandler) {
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(configuration.ensure).hasType(Function).isNotNull();
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(nextTick).hasType(Function).isNotNull();
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(timeoutFunction).hasType(Function).isNotNull();
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(errorHandler).hasType(Function);

   return new EventBus(configuration, nextTick, timeoutFunction, errorHandler);
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_object__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* harmony export (immutable) */ __webpack_exports__["b"] = findWidgetAreas;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */


/**
 * The area helper manages widget areas, their DOM representation and their nesting structure.
 *
 * It tracks widget area visibility in order to compile widgets and to attach them to their areas when
 * these become visible.
 * It does not interact with the event bus directly, but is consulted by the visibility event manager to
 * determine area nesting for visibility events.
 */

function create(page, log) {

   var exports = {
      isVisible: isVisible,
      setVisibility: setVisibility,
      areasInArea: areasInArea,
      areasInWidget: areasInWidget,
      register: register,
      exists: exists,
      attachWidgets: attachWidgets
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   // all initially visible widgets should be attached together, to reduce jitter and unnecessary DOM ops
   var freeToAttach = false;

   // keep the dom element for each area, to attach widgets to
   var areaToElement = {};

   // track widget adapters waiting for their area to become available so that they may attach to its DOM
   var areaToWaitingAdapters = {};

   // track the visibility status of all areas
   var knownVisibilityState = {};

   // the containing area name for each widget
   var widgetIdToArea = {};
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_object__["forEach"])(page.areas, function (widgets, areaName) {
      widgets.forEach(function (widget) {
         widgetIdToArea[widget.id] = areaName;
      });
   });

   // for each widget with children, and each widget area with nested areas, store a list of child names
   var areasInAreaMap = {};
   var areasInWidgetMap = {};
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_object__["forEach"])(page.areas, function (widgetEntries, areaName) {
      var containerName = '';
      if (areaName.indexOf('.') !== -1) {
         var widgetId = areaName.split('.')[0];
         areasInWidgetMap[widgetId] = areasInWidgetMap[widgetId] || [];
         areasInWidgetMap[widgetId].push(areaName);
         containerName = widgetIdToArea[widgetId];
      }
      areasInAreaMap[containerName] = areasInAreaMap[containerName] || [];
      areasInAreaMap[containerName].push(areaName);
   });

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function isVisible(areaName) {
      return knownVisibilityState[areaName] || false;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function setVisibility(areaName, visible) {
      if (visible && freeToAttach) {
         attachWaitingAdapters(areaName);
      }
      knownVisibilityState[areaName] = visible;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function areasInArea(containerName) {
      return areasInAreaMap[containerName];
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function areasInWidget(widgetId) {
      return areasInWidgetMap[widgetId];
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Register a widget area
    *
    * @param {String} name
    *    the area name as used in the page definition
    * @param {HTMLElement} element
    *    an HTML element representing the widget area
    * @param {String} [localName]
    *    the area name as used within the widget. Defaults to the qualified `name`
    *
    * @return {Function}
    *    removes the according area from the registry again
    */
   function register(name, element, localName) {
      if (name in areaToElement) {
         throw new Error('The area "' + name + '" is defined twice.');
      }

      if (!element.hasAttribute('data-ax-widget-area') && !element.hasAttribute('ax-widget-area')) {
         element.setAttribute('data-ax-widget-area', localName || name);
      }
      areaToElement[name] = element;
      if (freeToAttach && isVisible(name)) {
         attachWaitingAdapters(name);
      }

      return function () {
         delete areaToElement[name];
      };
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function exists(name) {
      return name in areaToElement;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function attachWidgets(widgetAdapters) {
      freeToAttach = true;
      widgetAdapters.forEach(function (adapterRef) {
         var areaName = widgetIdToArea[adapterRef.id];
         areaToWaitingAdapters[areaName] = areaToWaitingAdapters[areaName] || [];
         areaToWaitingAdapters[areaName].push(adapterRef);
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_object__["forEach"])(page.areas, function (widgets, areaName) {
         if (isVisible(areaName)) {
            attachWaitingAdapters(areaName);
         }
      });
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   // eslint-disable-next-line valid-jsdoc
   /** @private */
   function attachWaitingAdapters(areaName) {
      var waitingAdapters = areaToWaitingAdapters[areaName];
      if (!waitingAdapters || !waitingAdapters.length) {
         return;
      }

      var element = areaToElement[areaName];
      if (!element) {
         return;
      }

      // Only to have the context for error logging
      var currentAdapterRef = null;
      // Make sure that all assets are available before proceeding, so that DOM update happens en bloc.
      Promise.all(waitingAdapters.map(function (adapterRef) {
         return adapterRef.templatePromise;
      })).then(function (htmlTemplates) {
         waitingAdapters.forEach(function (adapterRef, i) {
            currentAdapterRef = adapterRef;
            adapterRef.adapter.domAttachTo(element, htmlTemplates[i]);
         });
      }).catch(function (err) {
         log.error('An error occured while attaching some widgets to the DOM:');
         log.error('  - Widget ID: ' + currentAdapterRef.id);
         log.error('  - Widget Area: ' + areaName);
         log.error('  - Original error: [0]', err);
      });

      delete areaToWaitingAdapters[areaName];
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   return exports;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function findWidgetAreas(rootElement) {
   var areas = {};
   Array.from(rootElement.querySelectorAll('[ax-widget-area],[data-ax-widget-area]')).forEach(function (elem) {
      var name = elem.getAttribute('ax-widget-area') || elem.getAttribute('data-ax-widget-area');

      areas[name] = elem;
   });
   return areas;
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_assert__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_object__ = __webpack_require__(1);
/* unused harmony export levels */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BLACKBOX; });
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/* unused harmony export createConsoleChannel */
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * Module providing the Logger factory.
 *
 * To use the Log service in a widget, request the {@link widget_services#axLog axLog} injection.
 *
 * @module log
 */



/**
 * Log levels that are available by default, sorted by increasing severity:
 *
 * - TRACE (level 100)
 * - DEBUG (level 200)
 * - INFO (level 300)
 * - WARN (level 400)
 * - ERROR (level 500)
 * - FATAL (level 600)
 *
 * @type {Object}
 * @name levels
 */
var levels = {
   TRACE: 100,
   DEBUG: 200,
   INFO: 300,
   WARN: 400,
   ERROR: 500,
   FATAL: 600
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Pass this as an additional replacement parameter to a log-method, in order to blackbox your logging call.
 * Blackboxed callers are ignored when logging the source information (file, line).
 *
 * @type {Object}
 * @name BLACKBOX
 */
var BLACKBOX = {};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function create(configuration, optionalBrowser) {
   var startChannels = optionalBrowser ? [createConsoleChannel(optionalBrowser)] : [];
   return new Logger(configuration, startChannels);
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

// eslint-disable-next-line valid-jsdoc
/**
 * A flexible logger.
 *
 * It is recommended to prefer this logger over `console.log` and friends, at least for any log messages that
 * might make their way into production code. For once, this logger is safe to use across browsers and allows
 * to attach additional channels for routing messages to (i.e. to send them to a server process for
 * persistence). If a browser console is available, messages will be logged to that console using the builtin
 * console channel.
 * For testing, a silent mock for this logger is used, making it simple to test the logging behavior of
 * widgets and activities, while avoiding noisy log messages in the test runner output.
 *
 * All messages produced
 *
 * @constructor
 * @private
 */
function Logger(configuration) {
   var _this = this;

   var channels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

   this.levels = Object.assign({}, levels, configuration.get('logging.levels'));

   this.queueSize_ = 100;
   this.channels_ = channels;
   this.counter_ = 0;
   this.messageQueue_ = [];
   this.threshold_ = 0;
   this.tags_ = {};

   this.levelToName_ = function (levels) {
      var result = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_object__["forEach"])(levels, function (level, levelName) {
         _this[levelName.toLowerCase()] = function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
               args[_key] = arguments[_key];
            }

            _this.log.apply(_this, [level].concat(args, [BLACKBOX]));
         };
         result[level] = levelName;
      });
      return result;
   }(this.levels);

   this.setLogThreshold(configuration.ensure('logging.threshold'));
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Logs a message. A message may contain placeholders in the form `[#]` where `#` resembles the index
 * within the list of `replacements`. `replacements` are incrementally counted starting at `0`. If the
 * log level is below the configured log threshold, the message is simply discarded.
 *
 * It is recommended not to use this method directly, but instead one of the short cut methods for the
 * according log level.
 *
 * @param {Number} level
 *    the level for this message
 * @param {String} message
 *    the message to log
 * @param {...*} replacements
 *    objects that should replace placeholders within the message
 */
Logger.prototype.log = function (level, message) {
   for (var _len2 = arguments.length, replacements = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      replacements[_key2 - 2] = arguments[_key2];
   }

   if (level < this.threshold_) {
      return;
   }

   var blackboxDepth = 0;
   while (replacements[replacements.length - 1] === BLACKBOX) {
      ++blackboxDepth;
      replacements.pop();
   }

   var messageObject = {
      id: this.counter_++,
      level: this.levelToName_[level],
      text: message,
      replacements: replacements,
      time: new Date(),
      tags: this.gatherTags(),
      sourceInfo: gatherSourceInformation(blackboxDepth + 1) // add 1 depth to exclude this function
   };

   this.channels_.forEach(function (channel) {
      channel(messageObject);
   });

   if (this.messageQueue_.length === this.queueSize_) {
      this.messageQueue_.shift();
   }
   this.messageQueue_.push(messageObject);
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Logs a message in log level `TRACE`. See {@link Logger#log} for further information.
 *
 * *Important note*: This method is only available, if no custom log levels were defined via
 * configuration or custom log levels include this method as well.
 *
 * @param {String} message
 *    the message to log
 * @param {...*} replacements
 *    objects that should replace placeholders within the message
 */
Logger.prototype.trace = function () {};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Logs a message in log level `DEBUG`. See {@link Logger#log} for further information.
 *
 * *Important note*: This method is only available, if no custom log levels were defined via
 * configuration or custom log levels include this method as well.
 *
 * @param {String} message
 *    the message to log
 * @param {...*} replacements
 *    objects that should replace placeholders within the message
 */
Logger.prototype.debug = function () {};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Logs a message in log level `INFO`. See {@link Logger#log} for further information.
 *
 * *Important note*: This method is only available, if no custom log levels were defined via
 * configuration or custom log levels include this method as well.
 *
 * @param {String} message
 *    the message to log
 * @param {...*} replacements
 *    objects that should replace placeholders within the message
 */
Logger.prototype.info = function () {};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Logs a message in log level `WARN`. See {@link Logger#log} for further information.
 *
 * *Important note*: This method is only available, if no custom log levels were defined via
 * configuration or custom log levels include this method as well.
 *
 * @param {String} message
 *    the message to log
 * @param {...*} replacements
 *    objects that should replace placeholders within the message
 */
Logger.prototype.warn = function () {};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Logs a message in log level `ERROR`. See {@link Logger#log} for further information.
 *
 * *Important note*: This method is only available, if no custom log levels were defined via
 * configuration or custom log levels include this method as well.
 *
 * @param {String} message
 *    the message to log
 * @param {...*} replacements
 *    objects that should replace placeholders within the message
 */
Logger.prototype.error = function () {};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Logs a message in log level `FATAL`. See {@link Logger#log} for further information.
 *
 * *Important note*: This method is only available, if no custom log levels were defined via
 * configuration or custom log levels include this method as well.
 *
 * @param {String} message
 *    the message to log
 * @param {...*} replacements
 *    objects that should replace placeholders within the message
 */
Logger.prototype.fatal = function () {};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Adds a new channel to forward log messages to. A channel is called synchronously for every log message
 * and can do whatever necessary to handle the message according to its task. Note that blocking or
 * performance critical actions within a channel should always take place asynchronously to prevent from
 * blocking the application. Ideally a web worker is used for heavier background tasks.
 *
 * Each message is an object having the following properties:
 * - `id`: the unique, ascending id of the log message
 * - `level`: the log level of the message in string representation
 * - `text`: the actual message that was logged
 * - `replacements`: the raw list of replacements passed along the message
 * - `time`: JavaScript Date instance when the message was logged
 * - `tags`: A map of all log tags currently set for the logger
 * - `sourceInfo`: if supported, a map containing `file`, `line` and `char` where the logging took place
 *
 * @param {Function} channel
 *    the log channel to add
 */
Logger.prototype.addLogChannel = function (channel) {
   this.channels_.push(channel);
   this.messageQueue_.forEach(function (entry) {
      channel(entry);
   });
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Removes a log channel and thus stops sending further messages to it.
 *
 * @param {Function} channel
 *    the log channel to remove
 */
Logger.prototype.removeLogChannel = function (channel) {
   var channelIndex = this.channels_.indexOf(channel);
   if (channelIndex > -1) {
      this.channels_.splice(channelIndex, 1);
   }
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Adds a value for a log tag. If a tag is already known, the value is appended to the existing one using a
 * `;` as separator. Note that no formatting of the value takes place and a non-string value will just have
 * its appropriate `toString` method called.
 *
 * Log tags can be used to mark a set of log messages with a value giving further information on the
 * current logging context. For example laxar sets a tag `'INST'` with a unique-like identifier for the
 * current browser client. If then for example log messages are persisted on a server, messages belonging
 * to the same client can be accumulated.
 *
 * @param {String} tag
 *    the id of the tag to add a value for
 * @param {String} value
 *    the value to add
 */
Logger.prototype.addTag = function (tag, value) {
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(tag).hasType(String).isNotNull();

   if (!this.tags_[tag]) {
      this.tags_[tag] = [value];
   } else {
      this.tags_[tag].push(value);
   }
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Sets a value for a log tag. If a tag is already known, the value is overwritten by the given one. Note
 * that no formatting of the value takes place and a non-string value will just have its appropriate
 * `toString` method called. For further information on log tags, see {@link Logger#addTag}.
 *
 * @param {String} tag
 *    the id of the tag to set a value for
 * @param {String} value
 *    the value to set
 */
Logger.prototype.setTag = function (tag, value) {
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(tag).hasType(String).isNotNull();

   this.tags_[tag] = [value];
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Removes a log tag. For further information on log tags, see {@link Logger#addTag}.
 *
 * @param {String} tag
 *    the id of the tag to set a value for
 */
Logger.prototype.removeTag = function (tag) {
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(tag).hasType(String).isNotNull();

   delete this.tags_[tag];
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Returns a map of all tags. If there are multiple values for the same tag, their values are concatenated
 * using a `;` as separator. For further information on log tags, see {@link Logger#addTag}.
 *
 * @return {Object}
 *    a mapping from tag to its value(s)
 */
Logger.prototype.gatherTags = function () {
   var tags = {};
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_object__["forEach"])(this.tags_, function (values, tag) {
      tags[tag] = values.join(';');
   });
   return tags;
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Sets the threshold for log messages. Log messages with a lower level will be discarded upon logging.
 *
 * @param {String|Number} threshold
 *    the numeric or the string value of the log level to use as threshold
 */
Logger.prototype.setLogThreshold = function (threshold) {
   if (typeof threshold === 'string') {
      __WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */].state(threshold.toUpperCase() in this.levels, 'Unsupported log threshold "' + threshold + '".');
      this.threshold_ = this.levels[threshold.toUpperCase()];
   } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(threshold).hasType(Number);
      this.threshold_ = threshold;
   }
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

var EMPTY_CALL_INFORMATION = { file: '?', line: -1, char: -1 };

function gatherSourceInformation(blackboxDepth) {
   var e = new Error();

   if (!e.stack) {
      try {
         // IE >= 10 only generates a stack if the error object is really thrown
         throw new Error();
      } catch (err) {
         e = err;
      }
      if (!e.stack) {
         return EMPTY_CALL_INFORMATION;
      }
   }

   var rows = e.stack.split(/[\n]/);
   var interpret = void 0;
   if (rows[0] === 'Error') {
      rows.shift();
      interpret = chromeStackInterpreter;
   } else if (rows[0].indexOf('@') !== -1) {
      interpret = firefoxStackInterpreter;
   } else {
      return EMPTY_CALL_INFORMATION;
   }

   var row = rows[blackboxDepth + 1]; // add 1 depth to exclude this function
   return row ? interpret(row) : EMPTY_CALL_INFORMATION;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

var CHROME_AND_IE_STACK_MATCHER = /\(?([^( ]+):(\d+):(\d+)\)?$/;

function chromeStackInterpreter(row) {
   var match = CHROME_AND_IE_STACK_MATCHER.exec(row);
   return {
      file: match ? match[1] : '?',
      line: match ? match[2] : -1,
      char: match ? match[3] : -1
   };
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

var FIREFOX_STACK_MATCHER = /@(.+):(\d+)$/;

function firefoxStackInterpreter(row) {
   var match = FIREFOX_STACK_MATCHER.exec(row);
   return {
      file: match ? match[1] : '?',
      line: match ? match[2] : -1,
      char: -1
   };
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function createConsoleChannel(browser) {

   return function log(messageObject) {
      var browserConsole = browser.console();
      if (!browserConsole) {
         return;
      }

      var level = messageObject.level,
          text = messageObject.text,
          replacements = messageObject.replacements,
          _messageObject$source = messageObject.sourceInfo,
          file = _messageObject$source.file,
          line = _messageObject$source.line;


      var logMethod = level.toLowerCase();
      if (logMethod === 'fatal') {
         // console.fatal does not exist
         logMethod = 'error';
      } else if (logMethod === 'trace' || !(logMethod in browserConsole)) {
         // In console objects trace doesn't define a valid log level but is used to print stack traces. We
         // thus need to change it something different.
         logMethod = 'log';
      }

      if (!(logMethod in browserConsole)) {
         return;
      }

      var _mergeTextAndReplacem = mergeTextAndReplacements(text, replacements),
          _mergeTextAndReplacem2 = _toArray(_mergeTextAndReplacem),
          message = _mergeTextAndReplacem2[0],
          interpolations = _mergeTextAndReplacem2.slice(1);

      browserConsole[logMethod].apply(browserConsole, [level + ': ' + message + ' (@ ' + file + ':' + line + ')'].concat(_toConsumableArray(interpolations)));
   };
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

var CONSOLE_COMPATIBLE_FORMAT_MATCHER = /^[%](\.\d+f|[dios])$/;

function guessFormatSpecifier(object) {
   if (typeof object === 'string') {
      return '%s';
   } else if (typeof object === 'number') {
      return '%f';
   }
   return '%o';
}

function mergeTextAndReplacements(text, replacements) {
   var parts = [];
   var pos = 0;
   var buffer = '';

   while (pos < text.length) {
      var character = text.charAt(pos);

      switch (character) {
         case '\\':
            {
               ++pos;
               if (pos === text.length) {
                  throw new Error('Unterminated string: "' + text + '"');
               }

               buffer += text.charAt(pos);
               break;
            }
         case '%':
            {
               ++pos;
               buffer += '\\%';
               break;
            }
         case '[':
            {
               var end = text.indexOf(']', pos);
               if (end === -1) {
                  throw new Error('Unterminated replacement at character ' + pos + ': "' + text + '"');
               }

               var replacementString = text.substring(pos + 1, end);
               var replacementIndex = parseInt(replacementString, 10);
               var replacement = replacements[replacementIndex];

               var formatSpecifier = replacementString.split(':').slice(1).filter(function (_) {
                  return CONSOLE_COMPATIBLE_FORMAT_MATCHER.test(_);
               }).pop();

               buffer += formatSpecifier || guessFormatSpecifier(replacement);
               parts.push(replacements[replacementIndex]);
               pos = end;

               break;
            }
         default:
            {
               buffer += character;
               break;
            }
      }

      ++pos;
   }

   parts.unshift(buffer);

   return parts;
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "technology", function() { return technology; });
/* harmony export (immutable) */ __webpack_exports__["bootstrap"] = bootstrap;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * Module for the plain widget adapter factory.
 * In LaxarJS _plain_ widgets are defined as widgets without dependency to a specific view library or
 * framwork, and instead would be implemented using simple DOM access and manipulation.
 *
 * A developer will never call any of the API of this module.
 * The documentation solely exists as a blueprint for custom widget adapters and to explain certain concepts.
 *
 * @module plain_adapter
 */

var technology = 'plain';

var noOp = function noOp() {};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Initializes the adapter module and returns a factory for plain widgets.
 * Note that the plain adapter doesn't need all the provided arguments, but they are listed here for
 * documentation purposes.
 *
 * @param {Object} artifacts
 *    the artifacts available to this adapter factory
 * @param {Object} artifacts.widgets
 *    all widgets, that are implemented in the adapter's technology
 * @param {Object} artifacts.controls
 *    all controls, that are implemented in the adapter's technology
 * @param {Object} services
 *    a selection of services adapter implementations may need to fulfill their task
 * @param {AdapterUtilities} services.adapterUtilities
 *    common utilities, that may be useful to a widget adapter
 * @param {ArtifactProvider} services.artifactProvider
 *    the artifact provider instance
 * @param {Configuration} services.configuration
 *    access to the application configuration
 * @param {EventBus} services.globalEventBus
 *    the global event bus.
 *    Note that an adapter should not sent any events by itself.
 *    It may instead be necessary that the adapter makes the event bus globally available to its widgets (for
 *    example like the AngularJS 1.x adapter), or that it registers an inspector
 * @param {Heartbeat} services.heartbeat
 *    the heartbeat instance.
 *    Depending on the underlying view technology (like AngularJS 1.x) it may be important to get notified
 *    when to re-render the user interface.
 *    For that reason an adapter can register a callback at the heartbeat, that gets called after all events
 *    of the current cycle were processed
 * @param {Log} services.log
 *    the global log instance
 * @param {StorageFactory} services.storage
 *    the global storage factory api
 * @param {Tooling} services.tooling
 *    access to the tooling api
 * @param {HTMLElement} anchorElement
 *    the DOM node the laxar application is bootstrapped on.
 *    An adapter should never try to access DOM nodes that are not the `anchorElement` or any of its children,
 *    since they are not under control of this LaxarJS application.
 *
 * @return {PlainAdapterFactory}
 *    the factory for plain widget adapters
 */
function bootstrap(artifacts, _ref) {
   var artifactProvider = _ref.artifactProvider,
       adapterUtilities = _ref.adapterUtilities;


   /**
    * A factory for plain widget adapters.
    *
    * @constructor
    * @name PlainAdapterFactory
    */
   return {
      create: create
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Creates a new adapter instance for the given widget environment.
    *
    * @param {Object} environment
    *    the environment for the widget to create and manage
    * @param {HTMLElement} environment.anchorElement
    *    the DOM node that the widget's DOM fragment should be inserted into
    * @param {String} environment.name
    *    the name of the widget to load, exactly as specified by the widget descriptor
    * @param {widget_services} environment.services
    *    the services for this widget instance
    * @param {Function} environment.provideServices
    *    a function that the adapter must call with a map of all to-be-injected services, just before
    *    creating the controller
    *
    * @return {Object}
    *    the adapter instance
    *
    * @memberof PlainAdapterFactory
    */
   function create(_ref2) {
      var widgetName = _ref2.widgetName,
          anchorElement = _ref2.anchorElement,
          services = _ref2.services,
          provideServices = _ref2.provideServices;


      var onDomAvailable = null;
      var domAttached = false;

      var provider = artifactProvider.forWidget(widgetName);

      return Promise.all([provider.descriptor(), provider.module()]).then(createController, function () {
         return adapterUtilities.unknownWidget({ technology: technology, widgetName: widgetName });
      }).then(function () {
         return {
            domAttachTo: domAttachTo,
            domDetach: domDetach
         };
      });

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function createController(_ref3) {
         var _ref4 = _slicedToArray(_ref3, 2),
             descriptor = _ref4[0],
             module = _ref4[1];

         services.axWithDom = function (callback) {
            if (domAttached) {
               callback(anchorElement);
            }
         };
         var injections = (module.injections || []).map(function (injection) {
            if (!(injection in services)) {
               throw adapterUtilities.unknownInjection({ technology: technology, injection: injection, widgetName: widgetName });
            }
            if (injection === 'axWithDom' && descriptor.integration.type === 'activity') {
               throw adapterUtilities.activityAccessingDom({ technology: technology, injection: injection, widgetName: widgetName });
            }
            return services[injection];
         });

         provideServices(services);

         var _ref5 = module.create.apply(module, _toConsumableArray(injections)) || {};

         var _ref5$onDomAvailable = _ref5.onDomAvailable;
         onDomAvailable = _ref5$onDomAvailable === undefined ? noOp : _ref5$onDomAvailable;
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function domAttachTo(areaElement, htmlTemplate) {
         if (htmlTemplate === null) {
            return;
         }
         anchorElement.innerHTML = htmlTemplate;
         areaElement.appendChild(anchorElement);
         domAttached = true;
         onDomAvailable(anchorElement);
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function domDetach() {
         var parent = anchorElement.parentNode;
         if (parent) {
            parent.removeChild(anchorElement);
         }
         domAttached = false;
      }
   }
}

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_assert__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configuration__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__browser__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__runtime_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__adapter_utilities__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__artifact_provider__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__loaders_control_loader__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__loaders_layout_loader__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__loaders_page_loader__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__loaders_widget_loader__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__storage__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__timer__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__flow_controller__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__flow_service__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__heartbeat__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__navigo_router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__page_service__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__locale_event_manager__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__visibility_event_manager__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__widget_services__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__tooling_tooling__ = __webpack_require__(32);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */























function create(configurationSource, assets, optionalDebugEventBus) {

   var configurationDefaults = {
      baseHref: undefined,
      eventBusTimeoutMs: 120 * 1000,
      router: {
         query: {
            enabled: false
         }
         // 'navigo' is not configured here:
         // any deviation from the Navigo library defaults must be set by the application
      },
      flow: {
         entryPoint: {
            target: 'default',
            parameters: {}
         }
      },
      i18n: {
         fallback: 'en',
         strict: false,
         locales: {
            'default': 'en'
         }
      },
      logging: {
         levels: {},
         threshold: 'INFO'
      },
      name: 'unnamed',
      theme: 'default',
      storagePrefix: undefined
   };

   var adapterUtilities = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__adapter_utilities__["a" /* create */])();

   var configuration = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__configuration__["a" /* create */])(configurationSource, configurationDefaults);

   var browser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__browser__["a" /* create */])();
   var log = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__log__["a" /* create */])(configuration, browser);

   var storage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__storage__["a" /* create */])(configuration, browser);
   var timer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__timer__["a" /* create */])(log, storage);

   var artifactProvider = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__artifact_provider__["a" /* create */])(assets, browser, configuration, log);

   var heartbeat = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__heartbeat__["a" /* create */])();

   // MSIE Bug we have to wrap setTimeout to pass assertion
   var timeoutFn = function timeoutFn(f, t) {
      return setTimeout(f, t);
   };
   var debugEventBus = optionalDebugEventBus || {
      publish: function publish() {},
      subscribe: function subscribe() {}
   };
   var errorHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__runtime_event_bus__["a" /* createLogErrorHandler */])(log);
   var globalEventBus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__runtime_event_bus__["b" /* create */])(configuration, heartbeat.onNext, timeoutFn, errorHandler);

   var layoutLoader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__loaders_layout_loader__["a" /* create */])(artifactProvider, debugEventBus);
   var pageLoader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__loaders_page_loader__["a" /* create */])(artifactProvider, debugEventBus);
   var controlLoader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__loaders_control_loader__["a" /* create */])(artifactProvider, debugEventBus);
   var widgetServices = {
      forWidget: function forWidget() {
         __WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */].codeIsUnreachable('Using widget services before they are available');
      }
   };
   var widgetLoader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__loaders_widget_loader__["a" /* create */])(log, artifactProvider, debugEventBus, controlLoader, function () {
      var _widgetServices;

      return (_widgetServices = widgetServices).forWidget.apply(_widgetServices, arguments);
   });

   var localeManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__locale_event_manager__["a" /* create */])(globalEventBus, configuration);
   var visibilityManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__visibility_event_manager__["a" /* create */])(globalEventBus);
   var pageService = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__page_service__["a" /* create */])(globalEventBus, pageLoader, layoutLoader, widgetLoader, localeManager, visibilityManager, log, debugEventBus);

   var router = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__navigo_router__["a" /* create */])(browser, configuration);

   var flowController = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__flow_controller__["a" /* create */])(artifactProvider, configuration, globalEventBus, log, pageService, router, timer);
   var flowService = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__flow_service__["a" /* create */])(flowController);

   var tooling = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__tooling_tooling__["a" /* create */])(debugEventBus, log);

   widgetServices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__widget_services__["a" /* create */])(artifactProvider, configuration, controlLoader, debugEventBus, globalEventBus, flowService, log, heartbeat, pageService, storage, tooling);

   return {
      adapterUtilities: adapterUtilities,
      artifactProvider: artifactProvider,
      configuration: configuration,
      flowController: flowController,
      flowService: flowService,
      debugEventBus: debugEventBus,
      globalEventBus: globalEventBus,
      heartbeat: heartbeat,
      layoutLoader: layoutLoader,
      log: log,
      pageService: pageService,
      storage: storage,
      timer: timer,
      tooling: tooling,
      widgetLoader: widgetLoader
   };
}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_object__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */



/**
 * This is used to create external tooling hooks (for the LaxarJS developer tools extension) if `.tooling()`
 * was called on the bootstrapping instance.
 */
function create(_ref) {
   var configuration = _ref.configuration,
       eventBus = _ref.globalEventBus,
       log = _ref.log,
       tooling = _ref.tooling;

   var CLEAR_BUFFER_DELAY_MS = 5000;
   var lastAccess = null;
   var clearBufferInterval = void 0;

   tooling.pages.addListener(onPageChange);
   var bufferSize = configuration.get('tooling.bufferSize', 2500);

   var developerHooks = window.laxarDeveloperToolsApi = window.laxarDeveloperToolsApi || {};
   developerHooks.buffers = { events: [], log: [] };
   developerHooks.eventCounter = Date.now();
   developerHooks.logCounter = Date.now();
   developerHooks.pageInfo = tooling.pages.current();
   developerHooks.pageInfoVersion = Date.now();
   developerHooks.gridSettings = configuration.get('tooling.grid', null);

   log.addLogChannel(logChannel);
   var cleanupInspector = eventBus.addInspector(inspector);

   window.addEventListener('beforeunload', function () {
      log.removeLogChannel(logChannel);
      cleanupInspector();
   });

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function logChannel(messageObject) {
      var timeStamp = Date.now();
      var index = developerHooks.logCounter++;
      var json = JSON.stringify(messageObject);
      pushIntoStore('log', { index: index, json: json, timeStamp: timeStamp });
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function inspector(item) {
      var timeStamp = Date.now();
      var index = developerHooks.eventCounter++;
      var json = JSON.stringify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_object__["options"])({ time: timeStamp }, item));
      pushIntoStore('events', { index: index, json: json, timeStamp: timeStamp });
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function onPageChange(pageInfo) {
      developerHooks.pageInfo = pageInfo;
      ++developerHooks.pageInfoVersion;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function clearBuffer() {
      var currentLastAccess = readLastAccess();
      if (currentLastAccess === lastAccess || currentLastAccess === null) {
         return;
      }
      lastAccess = currentLastAccess;
      var logItems = developerHooks.buffers.log;
      while (logItems[0] && logItems[0].timeStamp < lastAccess) {
         logItems.shift();
      }
      var eventItems = developerHooks.buffers.events;
      while (eventItems[0] && eventItems[0].timeStamp < lastAccess) {
         eventItems.shift();
      }
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function readLastAccess() {
      return document.documentElement.hasAttribute('data-laxar-developer-tools-extension') ? document.documentElement.getAttribute('data-laxar-developer-tools-extension') : null;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function pushIntoStore(storeName, item) {
      window.clearInterval(clearBufferInterval);
      clearBuffer();
      var buffer = developerHooks.buffers[storeName];
      while (buffer.length >= bufferSize) {
         buffer.shift();
      }
      buffer.push(item);
      clearBufferInterval = window.setInterval(function () {
         clearBuffer();
      }, CLEAR_BUFFER_DELAY_MS);
   }
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utilities_object__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utilities_string__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_runtime_event_bus__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_tooling_external_api__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_runtime_services__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_runtime_plain_adapter__ = __webpack_require__(6);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "assert", function() { return __WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a"]; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "object", function() { return __WEBPACK_IMPORTED_MODULE_1__lib_utilities_object__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "string", function() { return __WEBPACK_IMPORTED_MODULE_2__lib_utilities_string__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "plainAdapter", function() { return __WEBPACK_IMPORTED_MODULE_6__lib_runtime_plain_adapter__; });
/* harmony export (immutable) */ __webpack_exports__["create"] = create;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "instances", function() { return instances; });
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */

/**
 * The API entry point for boostrapping LaxarJS applications.
 * Also, provides a couple of utilities to deal with assertions, objects and strings.
 *
 * @module laxar
 */










// Get a reference to the global object of the JS environment.
// See http://stackoverflow.com/a/6930376 for details
var global = void 0;
try {
   // eslint-disable-next-line no-new-func, no-eval
   global = Function('return this')() || (1, eval)('this');
} catch (_) {
   // if it forbids eval, it's probably a browser
   global = window;
}

var MESSAGE_ADAPTERS = 'laxar.create: `adapters` must be an array';
var MESSAGE_ARTIFACTS = 'laxar.create: `artifacts` object must have at least: aliases, themes, widgets';
var MESSAGE_CONFIGURATION = 'laxar.create: `configuration` must be an object';

var TOPIC_SEGMENTS_MATCHER = /[^+a-z0-9]+/g;
var TOPIC_SEGMENTS_REPLACER = function TOPIC_SEGMENTS_REPLACER() {
   return '+';
};

/**
 * Prepares a LaxarJS application instance from a list of adapters, a bundle of artifacts, and application
 * configuration. The instance then allows to configure which DOM node should receive an application flow.
 * Running this has no effect until `.bootstrap()` is called on the returned instance API.
 *
 * @param {Array} adapters
 *    widget adapters to use in this bootstrapping instance
 * @param {Object} artifacts
 *    an artifact listing for the application, generated by the utilized built tool (e.g. webpack)
 * @param {Object} configuration
 *    application-wide LaxarJS configuration. See http://laxarjs.org/docs/laxar-latest/manuals/configuration/
 *    for further information on available properties
 *
 * @return {BootstrappingInstance}
 *    a handle on the bootstrapping instance, to load and bootstrap a flow
 *
 * @memberof laxar
 */
function create(adapters, artifacts, configuration) {
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */])(adapters).hasType(Array).isNotNull(MESSAGE_ADAPTERS);
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */])(artifacts).hasType(Object).isNotNull(MESSAGE_ARTIFACTS);
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */])(artifacts.aliases).hasType(Object).isNotNull(MESSAGE_ARTIFACTS);
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */])(artifacts.themes).hasType(Array).isNotNull(MESSAGE_ARTIFACTS);
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */])(artifacts.widgets).hasType(Array).isNotNull(MESSAGE_ARTIFACTS);
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */])(configuration).hasType(Object).isNotNull(MESSAGE_CONFIGURATION);

   var bootstrappingSchedule = {
      items: [],
      testing: false,
      tooling: null
   };

   var idCounter = 0;

   /**
    * Handle on a LaxarJS bootstrapping instance.
    *
    * @name BootstrappingInstance
    * @constructor
    */
   var api = { flow: flow, page: page, tooling: tooling, testing: testing, bootstrap: bootstrap };
   return api;

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Registers a flow to control routing for this application.
    *
    * @param {String} name
    *    the name of the flow to load
    * @param {HTMLElement} anchorElement
    *    container element to determine where to put the flow
    *
    * @return {BootstrappingInstance}
    *    the current bootstrapping instance (self), for chaining
    *
    * @memberof BootstrappingInstance
    */
   function flow(name, anchorElement) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */])(name).hasType(String).isNotNull();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */])(anchorElement).isNotNull();
      __WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */].state(anchorElement.nodeType === Node.ELEMENT_NODE);
      bootstrappingSchedule.items.push({ type: 'flow', name: name, anchorElement: anchorElement });
      return api;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Registers a page to display without navigation control.
    *
    * @param {String} name
    *    the name of the page to load
    * @param {HTMLElement} anchorElement
    *    container element to determine where to put the page
    * @param {Object} [parameters]
    *    page parameters to publish with didNavigate
    *
    * @return {BootstrappingInstance}
    *    the current bootstrapping instance (self), for chaining
    *
    * @memberof BootstrappingInstance
    */
   function page(name, anchorElement) {
      var parameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */])(name).hasType(String).isNotNull();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */])(anchorElement).isNotNull();
      __WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */].state(anchorElement.nodeType === Node.ELEMENT_NODE);
      bootstrappingSchedule.items.push({ type: 'page', name: name, anchorElement: anchorElement, parameters: parameters });
      return api;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Registers a debug bundle for this application.
    *
    * @param {Function|Object} debugInfo
    *    the debug-info bundle for the application, generated by the utilized built tool (e.g. webpack)
    *
    * @return {BootstrappingInstance}
    *    the current bootstrapping instance (self), for chaining
    *
    * @memberof BootstrappingInstance
    */
   function tooling(debugInfo) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */])(debugInfo).isNotNull();
      bootstrappingSchedule.tooling = {
         debugInfo: debugInfo
      };
      return api;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Declare that this instance is used for testing.
    * This will cause .bootstrap not to fail if no flow was configured.
    *
    * @return {BootstrappingInstance}
    *    the current bootstrapping instance (self), for chaining
    *
    * @memberof BootstrappingInstance
    */
   function testing() {
      bootstrappingSchedule.testing = true;
      return api;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Performs the actual application bootstrapping.
    * This includes bootstrapping the application adapters and starting the router.
    *
    * @return {Promise}
    *    a promise resolving when all items have been bootstrapped
    *
    * @memberof BootstrappingInstance
    */
   function bootstrap() {
      var testing = bootstrappingSchedule.testing,
          tooling = bootstrappingSchedule.tooling,
          items = bootstrappingSchedule.items;

      __WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */].state(testing || items.length > 0, 'Nothing configured for bootstrap()');
      __WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */].state(items.length <= 1, 'Multiple bootstrapping items are not supported yet');

      var debugEventBus = tooling && provideSharedDebugEventBus();
      var services = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_runtime_services__["a" /* create */])(configuration, artifacts, debugEventBus);
      var adapterInstances = bootstrapAdapters(services, [__WEBPACK_IMPORTED_MODULE_6__lib_runtime_plain_adapter__].concat(_toConsumableArray(adapters)), artifacts);

      var instanceName = services.configuration.ensure('name');
      var instance = makeTopic(instanceName);

      if (tooling) {
         services.tooling.registerDebugInfo(tooling.debugInfo);
         exportInstance(instanceName, services);
         __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_tooling_external_api__["a" /* create */])(services);
      }

      services.widgetLoader.registerWidgetAdapters(adapterInstances);
      announceInstance(services);

      var log = services.log;

      var promises = items.map(function (item) {
         var type = item.type,
             name = item.name,
             _item$id = item.id,
             id = _item$id === undefined ? generateId(name) : _item$id;

         /**
          * An object of strings which together identify a bootstrapping item.
          *
          * @name ItemMeta
          * @constructor
          */

         var itemMeta = _defineProperty({
            /**
             * The (topic-formatted) name of the LaxarJS instance.
             * @name instance
             * @type {String}
             * @memberof ItemMeta
             */
            instance: instance,
            /**
             * The (topic-formatted, ID-suffixed) name of the bootstrapping item.
             * @name item
             * @type {String}
             * @memberof ItemMeta
             */
            item: id,
            /**
             * The type of the bootstrapping item.
             * @name type
             * @type {String}
             * @memberof ItemMeta
             */
            type: type
         }, type, name);

         if (tooling) {
            services.tooling.registerItem(itemMeta);
         }

         log.trace('laxar.bootstrap: bootstrapping ' + type + ' \'' + name + '\' (' + id + ')');

         if (type === 'flow') {
            var anchorElement = item.anchorElement;


            return whenDocumentReady(function () {
               log.trace('laxar.bootstrap: loading flow: ' + name);
               services.pageService.createControllerFor(anchorElement, itemMeta);
               services.flowController.loadFlow(name).then(function () {
                  log.trace('laxar.bootstrap: flow loaded');
               }, function (err) {
                  log.fatal('laxar.bootstrap: failed to load flow.');
                  log.fatal('Error [0].\nStack: [1]', err, err && err.stack);
               });
            });
         }

         if (type === 'page') {
            var _anchorElement = item.anchorElement,
                parameters = item.parameters;


            return whenDocumentReady(function () {
               var controller = services.pageService.createControllerFor(_anchorElement, itemMeta);
               var eventBus = services.globalEventBus;
               var event = {
                  target: name,
                  place: null,
                  data: parameters
               };

               controller.setupPage(name).then(function () {
                  return eventBus.publish('didNavigate.' + event.target, event, { sender: 'bootstrap' });
               }).then(function () {
                  log.trace('laxar.bootstrap: page loaded');
               }, function (err) {
                  log.fatal('laxar.bootstrap: failed to load page.');
                  log.fatal('Error [0].\nStack: [1]', err, err && err.stack);
               });
            });
         }

         return __WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */].state(false);
      });

      return Promise.all(promises).then(function () {});
   }

   function generateId(name) {
      return makeTopic(name) + '-id' + idCounter++;
   }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function makeTopic(string) {
   return string.trim().toLowerCase().replace(TOPIC_SEGMENTS_MATCHER, TOPIC_SEGMENTS_REPLACER);
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function whenDocumentReady(callback) {
   return new Promise(function (resolve, reject) {
      function ready() {
         try {
            resolve(callback());
         } catch (err) {
            reject(err);
         }
      }

      if (document.readyState === 'complete') {
         ready();
      } else {
         document.addEventListener('DOMContentLoaded', ready);
      }
   });
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function bootstrapAdapters(services, adapterModules, artifacts) {

   var adapterServices = {
      adapterUtilities: services.adapterUtilities,
      artifactProvider: services.artifactProvider,
      configuration: services.configuration,
      flowService: services.flowService,
      globalEventBus: services.globalEventBus,
      debugEventBus: services.debugEventBus,
      heartbeat: services.heartbeat,
      log: services.log,
      storage: services.storage,
      tooling: services.tooling,
      // TODO (https://github.com/LaxarJS/laxar/issues/363 and https://github.com/LaxarJS/laxar/issues/397)
      // Fixing the latter issue broke laxar-mocks, since it could no longer access the widget loader.
      // To temporarily fix this, we re-add the widget loader to the exposed services.
      // Nevertheless on the medium /short term we want to be able to load single widgets into the page
      // (the first issue above) and use the api that will be created for this in laxar-mocks.
      widgetLoader: services.widgetLoader
   };

   var log = services.log;

   var adapterModulesByTechnology = {};
   var artifactsByTechnology = {};

   adapterModules.forEach(function (module) {
      adapterModulesByTechnology[module.technology] = module;
      artifactsByTechnology[module.technology] = { widgets: [], controls: [] };
   });

   ['widgets', 'controls'].forEach(function (type) {
      artifacts[type].forEach(function (artifact) {
         var technology = artifact.descriptor.integration.technology;

         if (!adapterModulesByTechnology[technology]) {
            var name = artifact.descriptor.name;

            log.fatal('Unknown integration technology: [0], required by "[1]"', technology, name);
            return;
         }
         artifactsByTechnology[technology][type].push(artifact);
      });
   });

   var adaptersByTechnology = {};
   Object.keys(adapterModulesByTechnology).forEach(function (technology) {
      var adapterModule = adapterModulesByTechnology[technology];
      var artifacts = artifactsByTechnology[technology];
      adaptersByTechnology[technology] = adapterModule.bootstrap(artifacts, adapterServices);
   });
   return adaptersByTechnology;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function announceInstance(services) {
   var configuration = services.configuration,
       log = services.log,
       storage = services.storage;


   var idGenerator = configuration.get('logging.instanceId', simpleId);
   if (idGenerator === false) {
      return;
   }

   var instanceIdStorageKey = 'axLogTags.INST';
   var store = storage.getApplicationSessionStorage();
   var instanceId = store.getItem(instanceIdStorageKey);
   if (!instanceId) {
      instanceId = idGenerator();
      store.setItem(instanceIdStorageKey, instanceId);
   }
   log.addTag('INST', instanceId);

   function simpleId() {
      return '' + Date.now() + Math.floor(Math.random() * 100);
   }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Provide tooling access to LaxarJS services.
 *
 * Each laxar#bootstrap call creates a new set of services such as a logger, global event bus etc. For tools
 * like the laxar-developer-tools-widget, it may be necessary to access these services for a given instance,
 * or for all instances.
 *
 * @param {String} [optionalName]
 *   the configuration name of a LaxarJS instance to inspect (may be omitted to access all application
 *   instances by name)
 *
 * @return {Object}
 *   the tooling services for a specified instance, or for all instances that have tooling enabled
 *
 * @memberof laxar
 */
function instances(optionalName) {
   var globalInstances = global.laxarInstances || {};
   return optionalName ? globalInstances[optionalName] : globalInstances;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Export a LaxarJS instance to be accessed via the laxar#instances function.
 *
 * @param {String} name
 *    the name under which the instance should be accessible
 * @param {Object} instance
 *    the object representing the LaxarJS instance that should be exported
 *
 * @private
 */
function exportInstance(name, instance) {
   var globalInstances = global.laxarInstances = instances();
   var uniqueName = name;

   if (name in globalInstances) {
      var suffix = 1;
      do {
         uniqueName = '' + name + suffix++;
      } while (uniqueName in globalInstances);
   }

   globalInstances[uniqueName] = instance;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Provide another instance's debug event bus. This instance is shared across all LaxarJS instances.
 * If there is no other active LaxarJS instance, a new event bus is created.
 *
 * @return {EventBus}
 *   the `debugEventBus` service of any other active LaxarJS instance or a new event bus instance
 *
 * @private
 */
function provideSharedDebugEventBus() {
   var globalInstances = instances();

   for (var name in globalInstances) {
      if (globalInstances.hasOwnProperty(name) && globalInstances[name].debugEventBus) {
         return globalInstances[name].debugEventBus;
      }
   }

   return createDebugEventBus({ eventBusTimeoutMs: 1000 });
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Create a new debug event bus with the given configuration.
 *
 * @param {Object} configuration
 *    a plain object with at least a `eventBusTimeoutMs` property
 *
 * @return {EventBus}
 *    a new event bus instance
 *
 * @private
 */
function createDebugEventBus(configuration) {
   var ensure = function ensure(key) {
      __WEBPACK_IMPORTED_MODULE_0__lib_utilities_assert__["a" /* default */].state(key in configuration);
      return configuration[key];
   };
   var nextTick = window.nextTick ? window.nextTick : function (f) {
      return window.setTimeout(f, 0);
   };
   var setTimeout = window.setTimeout;
   var errorHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_runtime_event_bus__["a" /* createLogErrorHandler */])({
      error: function error(message, optionalErrorInformation) {
         window.console.error('DebugEventBus: ' + message, optionalErrorInformation);
      }
   });

   return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_runtime_event_bus__["b" /* create */])({ ensure: ensure }, nextTick, setTimeout, errorHandler);
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////



/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_string__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * The control loader helps to load control assets and implementations.
 *
 * @module control_loader
 */


function create(artifactProvider) {

   var notDeclaredMessage = 'Tried to load control reference [0] without declaration in widget.json.\nDetails: [1]';
   var errorInfoLink = 'https://github.com/LaxarJS/laxar/blob/master/docs/manuals/providing_controls.md#compatibility';

   var aliases = {};
   var modules = {};

   /**
    * @constructor
    * @name ControlLoader
    */
   return {
      load: load,
      provide: provide
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Provides the implementation module of the given control, for manual instantiation by a widget.
    *
    * Because the method must return synchronously, it may only be called for controls that have been
    * loaded before (using {@link #load()})!
    * For controls that are correctly listed in the `controls` section of the `widget.json`, this is ensured
    * by the widget loader.
    *
    * @param {String} controlRef
    *   a valid control reference as used in the `widget.json`
    *
    * @return {*}
    *   the module for the requested control reference
    *
    * @memberof ControlLoader
    */
   function provide(controlRef) {
      var module = modules[aliases[controlRef]];
      if (!module) {
         var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_string__["format"])('axControls: ' + notDeclaredMessage, [controlRef, errorInfoLink]);
         throw new Error(message);
      }
      return module;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Fetches the descriptor for a given control reference, and saves it as a side-effect.
    * This is part of the internal API used by the widget loader.
    *
    * This process must be completed before the descriptor or the module for a control can be provided.
    * For this reason, `load` is called by the widget-loader, using information from the `widget.json` file.
    *
    * @param {String} controlRef
    *   a valid control reference as used in the `widget.json`
    *
    * @return {Promise}
    *   a promise for the (fetched or synthesized) control descriptor
    *
    * @memberof ControlLoader
    */
   function load(controlRef) {
      var _artifactProvider$for = artifactProvider.forControl(controlRef),
          descriptor = _artifactProvider$for.descriptor,
          module = _artifactProvider$for.module;

      return Promise.all([descriptor(), module()]).then(function (_ref) {
         var _ref2 = _slicedToArray(_ref, 2),
             descriptor = _ref2[0],
             module = _ref2[1];

         //TODO: debugEventBus;
         var name = descriptor.name;

         aliases[controlRef] = name;
         modules[name] = module;
         return descriptor;
      });
   }
}

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_assert__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */



function create(artifactProvider, debugEventBus) {
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(artifactProvider).hasType(Object).isNotNull();
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(debugEventBus).hasType(Object).isNotNull();

   return {
      load: function load(layoutRef) {
         var _artifactProvider$for = artifactProvider.forLayout(layoutRef),
             descriptor = _artifactProvider$for.descriptor,
             assetForTheme = _artifactProvider$for.assetForTheme;
         //TODO: debugEventBus;


         return descriptor().then(function (_ref) {
            var name = _ref.name,
                templateSource = _ref.templateSource;
            return Promise.all([Promise.resolve(name), assetForTheme(templateSource || name + '.html')]);
         }).then(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                name = _ref3[0],
                html = _ref3[1];

            return { name: name, html: html, className: name + '-layout' };
         });
      }
   };
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_assert__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */


//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Creates and returns a new page loader instance.
 *
 * @param {ArtifactProvider} artifactProvider
 *    an ArtifactProvider to load application assets
 * @param {EventBus} debugEventBus
 *    an event bus to publish debug information
 *
 * @return {PageLoader}
 *    a page loader instance
 *
 * @private
 */
function create(artifactProvider, debugEventBus) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(artifactProvider).isNotNull();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(debugEventBus).isNotNull();

  return { load: load };

  /**
   * Loads a pre-assembled page definition. References to compositions, widgets and layouts have been
   * resolved at build-time. Schema-validation for the page itself and for the contained feature
   * configurations has also already been performed.
   *
   * @param {String} pageRef
   *    the page to load. Usually a path relative to the page base path, with the `.json` suffix omitted
   *
   * @return {Promise}
   *    the result promise
   *
   * @private
   */
  function load(pageRef) {
    var _artifactProvider$for = artifactProvider.forPage(pageRef),
        definition = _artifactProvider$for.definition;

    return definition().then(function (pageDefinition) {
      return pageDefinition;
    });
  }
}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_string__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */



var TYPE_WIDGET = 'widget';
var TYPE_ACTIVITY = 'activity';

var ID_SEPARATOR = '-';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

var noOp = function noOp() {};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Create a generic widget loader that can load widgets and activities implemented in various technologies
 * by using appropriate adapters.
 *
 * @param {Log} log
 *    log instance to use for technology compatibility warnings
 * @param {ArtifactProvider} artifactProvider
 *    an artifact provider for looking up widget descriptors and assets
 * @param {EventBus} debugEventBus
 *    an event bus to publish debug information
 * @param {ControlLoader} controlLoader
 *    helps loading controls and their assets
 * @param {Function} servicesForWidget
 *    a factory method to create widget-specific services
 *
 * @return {WidgetLoader}
 *    a new widget loader
 */
function create(log, artifactProvider, debugEventBus, controlLoader, servicesForWidget) {

   var widgetAdapters = {};

   /**
    * @name WidgetLoader
    * @constructor
    */
   return {
      load: load,

      /**
       * Register support for integration technologies.
       *
       * @param {Object} adapters
       *    a map of widget adapters by technology to be registered with this loader
       *
       * @memberof WidgetLoader
       */
      registerWidgetAdapters: function registerWidgetAdapters(adapters) {
         Object.assign(widgetAdapters, adapters);
      }
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Load a widget using an appropriate adapter
    *
    * First, get the given widget's descriptor to validate and instantiate the widget features.
    * Then, instantiate a widget adapter matching the widget's technology. Using the adapter, create the
    * widget controller. The adapter is returned and can be used to attach the widget to the DOM, or to
    * destroy it.
    *
    * @param {Object} widgetConfiguration
    *    a widget instance configuration (as used in page definitions) to instantiate the widget from
    * @param {Object} [optionalOptions]
    *    map of additonal options
    * @param {Function} [optionalOptions.whenServicesAvailable]
    *    a callback that will be invoked just before the controller is set up. It receives an object of named,
    *    widget-specific injections as arguments allowing clients and tools such as laxar-mocks to tap into
    *   the provided services
    * @param {ItemMeta} [itemMeta]
    *    an object identifying the bootstrapping item and LaxarJS instance the widget lives in
    *
    * @return {Promise} a promise for a widget adapter, with an already instantiated controller
    *
    * @memberof WidgetLoader
    */
   function load(widgetConfiguration) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$whenServicesAvai = _ref.whenServicesAvailable,
          whenServicesAvailable = _ref$whenServicesAvai === undefined ? noOp : _ref$whenServicesAvai;

      var itemMeta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


      var widgetArtifactProvider = artifactProvider.forWidget(widgetConfiguration.widget);
      var publishDebugInfo = function publishDebugInfo(event, data) {
         debugEventBus.publish(event + '.' + itemMeta.instance + '.' + itemMeta.item, Object.assign({
            itemMeta: itemMeta
         }, data));
      };

      publishDebugInfo('willLoad.widget', { widget: widgetConfiguration.widget });

      return widgetArtifactProvider.descriptor().then(function (descriptor) {
         // The control-descriptors must be loaded prior to controller creation.
         // This allows the widget controller to synchronously instantiate controls.
         return Promise.all((descriptor.controls || []).map(controlLoader.load)).then(function (controlDescriptors) {
            controlDescriptors.forEach(checkTechnologyCompatibility(descriptor));
            return descriptor;
         });
      }).then(function (descriptor) {
         var _descriptor$integrati = descriptor.integration,
             type = _descriptor$integrati.type,
             technology = _descriptor$integrati.technology;

         var widgetName = descriptor.name;
         if (type !== TYPE_WIDGET && type !== TYPE_ACTIVITY) {
            throwError(widgetConfiguration, 'Unknown integration type "' + type + '"');
         }

         var features = widgetConfiguration.features || {};
         var anchorElement = document.createElement('DIV');
         anchorElement.className = widgetName;
         anchorElement.id = 'ax' + ID_SEPARATOR + widgetConfiguration.id;

         var adapterFactory = widgetAdapters[technology];
         var _adapterFactory$servi = adapterFactory.serviceDecorators,
             serviceDecorators = _adapterFactory$servi === undefined ? function () {
            return {};
         } : _adapterFactory$servi;

         var _servicesForWidget = servicesForWidget(descriptor, widgetConfiguration, features, serviceDecorators(descriptor, widgetConfiguration), itemMeta),
             services = _servicesForWidget.services,
             releaseServices = _servicesForWidget.releaseServices;

         var environment = {
            anchorElement: anchorElement,
            services: services,
            widgetName: widgetName,
            provideServices: whenServicesAvailable
         };

         return Promise.resolve(adapterFactory.create(environment)).then(function (adapter) {
            publishDebugInfo('didLoad.widget', { widget: widgetConfiguration.widget });
            return adapter;
         }).then(function (adapter) {
            return Object.assign({ destroy: noOp }, adapter);
         }).then(function (adapter) {
            return {
               id: widgetConfiguration.id,
               adapter: adapter,
               destroy: function destroy() {
                  releaseServices();
                  adapter.destroy();
                  publishDebugInfo('didUnload.widget', { widget: widgetConfiguration.widget });
               },

               templatePromise: loadAssets(descriptor, widgetArtifactProvider)
            };
         });
      }, function (err) {
         var message = 'Could not load widget "' + widgetConfiguration.widget + '": ' + err.message;
         log.error(message);
         throw err;
      });
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Locates and loads the widget HTML template for this widget (if any) as well as any CSS stylesheets
    * used by this widget or its controls.
    *
    * @param {Object} widgetDescriptor
    *    a descriptor identifying the widget to load assets for
    * @param {ArtifactProvider} artifactProviderForWidget
    *    the provider with which to lookup or fetch artifact HTML and CSS
    *
    * @return {Promise}
    *    A promise that will be resolved with the contents of any HTML template for this widget, or with
    *    `null` if there is no template (for example, if this is an activity).
    *
    * @private
    */
   function loadAssets(widgetDescriptor, _ref2) {
      var assetForTheme = _ref2.assetForTheme;
      var type = widgetDescriptor.integration.type,
          name = widgetDescriptor.name;

      return type === TYPE_ACTIVITY ? Promise.resolve(null) : assetForTheme(widgetDescriptor.templateSource || name + '.html');
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function checkTechnologyCompatibility(widgetDescriptor) {
      var name = widgetDescriptor.name,
          technology = widgetDescriptor.integration.technology;

      return function (controlDescriptor) {
         var controlTechnology = (controlDescriptor.integration || {}).technology;
         if (controlTechnology === 'plain') {
            // plain is always compatible
            return;
         }

         if (technology !== controlTechnology) {
            log.warn('Incompatible integration technologies: widget [0] ([1]) cannot use control [2] ([3])', name, technology, controlDescriptor.name, controlTechnology);
         }
      };
   }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function throwError(widgetConfiguration, message) {
   throw new Error(__WEBPACK_IMPORTED_MODULE_0__utilities_string__["format"]('Error loading widget "[widget]" (id: "[id]"): [0]', [message], widgetConfiguration));
}

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */

/**
 * Several factory methods for creating error objects that are useful for almost any adapter.
 *
 * @module adapter_utilities
 */

/**
 * Creates an instance of the adapter utilities.
 *
 * @return {AdapterUtilities}
 *   a collection of methods to create error messages commonly generated by widget adapters
 *
 * @private
 */
function create() {

  /**
   * Provides access to the configuration that was passed during application bootstrapping.
   *
   * A *Configuration* instance provides convenient readonly access to the underlying LaxarJS
   * application bootstrapping configuration. The configuration values are passed to
   * {@link laxar#create()} on startup (before LaxarJS v2.x, these configuration values were read from
   * `window.laxar`). When using the LaxarJS application template, the configuration values are set in the
   * file `init.js` under your project's root directory.
   *
   * @name AdapterUtilities
   * @constructor
   */
  return {

    /**
     * Creates (but does not throw) an error indicating that an activity tried accessing the DOM.
     *
     * @param {Object} details
     *    details for the error
     * @param {String} details.technology
     *    the complaining adapter's technology
     * @param {String} details.widgetName
     *    the canonical name of the activity causing the problem
     *
     * @return {Error}
     *    the error, ready to throw
     */
    activityAccessingDom: function activityAccessingDom(_ref) {
      var technology = _ref.technology,
          widgetName = _ref.widgetName;

      return new Error(technology + " adapter: Trying to access DOM in activity " + widgetName);
    },


    /**
     * Creates (but does not throw) an error indicating that a widget requested an injection that cannot be
     * provided by the adapter.
     *
     * @param {Object} details
     *    details for the error
     * @param {String} details.technology
     *    the complaining adapter's technology
     * @param {String} details.injection
     *    the failing injection
     * @param {String} details.widgetName
     *    the canonical name of the widget causing the problem
     *
     * @return {Error}
     *    the error, ready to throw
     */
    unknownInjection: function unknownInjection(_ref2) {
      var technology = _ref2.technology,
          injection = _ref2.injection,
          widgetName = _ref2.widgetName;

      return new Error(technology + " adapter: " + ("Trying to inject unknown service \"" + injection + " into widget \"" + widgetName + "\""));
    },


    /**
     * Creates (but does not throw) an error indicating that a widget was not registered with the current
     * adapter.
     *
     * @param {Object} details
     *    details for the error
     * @param {String} details.technology
     *    the complaining adapter's technology
     * @param {String} details.widgetName
     *    the canonical name of the missing widget
     *
     * @return {Error}
     *    the error, ready to throw
     */
    unknownWidget: function unknownWidget(_ref3) {
      var technology = _ref3.technology,
          widgetName = _ref3.widgetName;

      return new Error(technology + " adapter: Unknown widget: " + widgetName);
    }
  };
}

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_assert__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_object__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
* Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */



var NOT_FOUND = { content: null };

function create(artifacts, browser, configuration, log) {

   var baseHref = configuration.get('baseHref');

   var resolve = baseHref ? function (_) {
      return browser.resolve(_, baseHref);
   } : function (_) {
      return _;
   };

   var _ref = function (themeRef) {
      var themeIndex = artifacts.aliases.themes[themeRef];
      var theme = artifacts.themes[themeIndex];
      if (!theme) {
         log.error('The configured theme ' + themeRef + ' is not available.');
         return ['default', 'default.theme'];
      }
      return [themeRef, theme.descriptor.name];
   }(configuration.ensure('theme')),
       _ref2 = _slicedToArray(_ref, 2),
       themeRef = _ref2[0],
       themeName = _ref2[1];

   return {
      forFlow: makeProvider('flows', ['descriptor'], ['definition']),
      forTheme: makeProvider('themes', ['descriptor', 'assets']).bind(null, themeRef),
      forPage: makeProvider('pages', ['descriptor'], ['definition']),
      forLayout: makeProvider('layouts', ['descriptor', 'assets']),
      forWidget: makeProvider('widgets', ['descriptor', 'assets', 'module']),
      forControl: makeProvider('controls', ['descriptor', 'assets', 'module'])
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function makeProvider(bucket) {
      var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var cloneKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      return function (ref) {
         var api = {};
         var index = artifacts.aliases[bucket][ref];
         var artifactPromise = index === undefined ? Promise.reject(new Error('Artifact ' + ref + ' not found in ' + bucket)) : Promise.resolve(artifacts[bucket][index]);

         ['definition', 'module', 'descriptor'].forEach(function (key) {
            if (cloneKeys.includes(key)) {
               api[key] = function () {
                  return artifactPromise.then(function (_) {
                     return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_object__["deepClone"])(_[key]);
                  });
               };
            } else if (keys.includes(key)) {
               api[key] = function () {
                  return artifactPromise.then(function (_) {
                     return _[key];
                  });
               };
            }
         });

         if (keys.includes('assets')) {
            var lookup = function lookup(name) {
               __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(name).hasType(String).isNotNull();
               return function (_ref3) {
                  var _ref3$assets = _ref3.assets,
                      assets = _ref3$assets === undefined ? {} : _ref3$assets;

                  return assets[name] || NOT_FOUND;
               };
            };

            var lookupForTheme = function lookupForTheme(name) {
               __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(name).hasType(String).isNotNull();
               return function (_ref4) {
                  var _ref4$assets = _ref4.assets,
                      assets = _ref4$assets === undefined ? {} : _ref4$assets;

                  var themedAssets = assets[themeName];
                  if (themedAssets && themedAssets[name]) {
                     return themedAssets[name];
                  }
                  var defaultAssets = assets['default.theme'];
                  if (defaultAssets && defaultAssets[name]) {
                     return defaultAssets[name];
                  }
                  return NOT_FOUND;
               };
            };

            var provide = function provide(_ref5) {
               var url = _ref5.url,
                   content = _ref5.content;

               if (content == null && url) {
                  return browser.fetch(resolve(url)).then(function (_) {
                     return _.text();
                  });
               }
               return content || null;
            };

            var provideUrl = function provideUrl(_ref6) {
               var url = _ref6.url;
               return url ? resolve(url) : null;
            };

            api.asset = function (name) {
               return artifactPromise.then(lookup(name)).then(provide);
            };

            api.assetUrl = function (name) {
               return artifactPromise.then(lookup(name)).then(provideUrl);
            };

            api.assetForTheme = function (name) {
               return artifactPromise.then(lookupForTheme(name)).then(provide);
            };

            api.assetUrlForTheme = function (name) {
               return artifactPromise.then(lookupForTheme(name)).then(provideUrl);
            };
         }

         return api;
      };
   }
}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * Module providing the Browser factory.
 *
 * Provides abstractions for browser APIs used internally by LaxarJS, which might need a different
 * implementation in a server-side environment, or for testing.
 * This service is internal to LaxarJS and not available to widgets and activities.
 *
 * @module browser
 */

/**
 * Create a browser abstraction environment.
 *
 * @return {Browser}
 *    a fresh browser instance
 *
 * @private
 */
function create() {

   // for the MSIE `resolve`-workaround, cache the temporary HTML document
   var resolveDoc = void 0;
   var resolveDocBase = void 0;

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * A brower mostly abstracts over the location-related DOM window APIs, and provides a console wrapper.
    * Since it is internal to LaxarJS, only relevant APIs are included.
    *
    * @name Browser
    * @constructor
    */
   return {
      /**
      * Calculates an absolute URL from a (relative) URL, and an optional base URL.
      *
      * If no base URL is given, the `document.baseURI` is used instead. The given base URL may also be
      * relative, in which case it is resolved against the `document.baseURI` before resolving the first URL.
      *
      * For browser environments that do not support the `new URL( url, baseUrl )` constructor for resolving
      * URLs or that do not support `document.baseURI`, fallback mechanisms are used.
      *
      * @param {String} url
      *    the URL to resolve
      * @param {String} baseUrl
      *    the base to resolve from
      *
      * @return {String}
      *    an absolute URL based on the given URL
      *
      * @type {Function}
      * @memberof Browser
      */
      resolve: selectResolver(),

      /**
       * Provides easily mocked access to `window.location`
       *
       * @return {Location}
       *    the current (window's) DOM location
       *
       * @type {Function}
       * @memberof Browser
       */
      location: function location() {
         return window.location;
      },

      /**
       * Provides easily mocked access to `window.fetch` or a suitable polyfill:
       *
       * @param {String|Request} input
       *    the URL to fetch or the request to perform
       * @param {Object} [init]
       *    additional options, described here in more detail:
       *    https://developer.mozilla.org/en-US/docs/Web/API/Globalfetch/fetch#Parameters
       *
       * @return {Promise<Response>}
       *    the resulting promise
       *
       * @type {Function}
       * @memberof Browser
       */
      fetch: function fetch(input, init) {
         return window.fetch(input, init);
      },

      /**
       * Provides easily mocked access to `window.console`:
       *
       * @return {Console}
       *    the browser console promise
       *
       * @type {Function}
       * @memberof Browser
       */
      console: function console() {
         return window.console;
      }
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   // perform the exception-based feature-detect only once (for performance, and to be nice to debugger users)
   function selectResolver() {
      try {
         var href = window.location.href;

         return new URL('', href).href === href ? resolveUsingUrl : resolveUsingLink;
      } catch (e) {
         return resolveUsingLink;
      }
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   // Resolve using the DOM URL API (Chrome, Firefox, Safari, MS Edge)
   function resolveUsingUrl(url, baseUrl) {
      var absoluteBaseUrl = baseUrl ? abs(baseUrl) : document.baseURI || abs('.');
      return new URL(url, absoluteBaseUrl).href;

      function abs(url) {
         return new URL(url, document.baseURI || resolveUsingLink('.'));
      }
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   // Resolve using the a-tag fallback (MSIE)
   function resolveUsingLink(url, baseUrl) {
      var absoluteBaseUrl = abs(baseUrl);
      if (!resolveDoc) {
         resolveDoc = document.implementation.createHTMLDocument('');
         resolveDocBase = resolveDoc.createElement('base');
         resolveDoc.head.appendChild(resolveDocBase);
      }
      resolveDocBase.href = absoluteBaseUrl;
      return abs(url, resolveDoc);

      function abs(url) {
         var baseDocument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

         var a = baseDocument.createElement('a');
         // MSIE does not process empty URLs correctly (http://stackoverflow.com/a/7966835)
         a.href = url || '#';
         return url ? a.href : a.href.slice(0, -1);
      }
   }
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_assert__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_object__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * Module providing the Configuration factory.
 *
 * To use the Configuration in a widget, request the {@link widget_services#axConfiguration axConfiguration}
 * injection. In compatibility mode with LaxarJS v1.x, it is also available under `laxar.configuration`.
 *
 * @module configuration
 */



function create(source, defaults) {

  /**
   * Provides access to the configuration that was passed during application bootstrapping.
   *
   * A *Configuration* instance provides convenient readonly access to the underlying LaxarJS
   * application bootstrapping configuration. The configuration values are passed to
   * {@link laxar#create()} on startup (before LaxarJS v2.x, these configuration values were read from
   * `window.laxar`). When using the LaxarJS application template, the configuration values are set in the
   * file `init.js` under your project's root directory.
   *
   * @name Configuration
   * @constructor
   */
  return { get: get, ensure: ensure };

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Returns the configured value for the specified attribute path or `undefined` in case it wasn't
   * configured. If a default value was passed as second argument this is returned instead of `undefined`.
   *
   * Services should use this to get configuration values for which there are universal fallback behaviors.
   *
   * Examples:
   * ```js
   * // ... inject `axConfiguration` as `config` ...
   * config.get( 'logging.threshold' ); // -> 'INFO'
   * config.get( 'iDontExist' ); // -> undefined
   * config.get( 'iDontExist', 42 ); // -> 42
   * ```
   *
   * @param {String} key
   *    a path (using `.` as separator) to the property in the configuration object
   * @param {*} [optionalDefault]
   *    the value to return if no value was set for `key`
   *
   * @return {*}
   *    either the configured value, `undefined` or `optionalDefault`
   *
   * @memberof Configuration
   */
  function get(key, optionalDefault) {
    var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_object__["path"])(source, key);
    return value !== undefined ? value : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_object__["path"])(defaults, key, optionalDefault);
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Retrieves a configuration value by key, failing if it is `undefined` or `null`.
   *
   * Services should use this to get configuration values for which no universal default or fallback exists.
   *
   * Examples:
   * ```js
   * // ... inject `axConfiguration` as `config` ...
   * config.ensure( 'logging.threshold' ); // -> 'INFO'
   * config.ensure( 'iDontExist' ); // -> throws
   * ```
   *
   * @param {String} key
   *    a path (using `.` as separator) to the property in the configuration object
   *
   * @return {*}
   *    the configured value (if `undefined` or `null`, an exception is thrown instead)
   *
   * @memberof Configuration
   */
  function ensure(key) {
    var value = get(key);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(value).isNotNull('Configuration is missing mandatory entry: ' + key);
    return value;
  }
}

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_assert__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_object__ = __webpack_require__(1);
/* unused harmony export TARGET_SELF */
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * Module providing the FlowController factory.
 *
 * This service is internal to LaxarJS and not available to widgets and activities.
 *
 * @module flow_controller
 * @private
 */




var SESSION_KEY_TIMER = 'navigationTimer';
var DEFAULT_PLACE = '';

var TARGET_SELF = '_self';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Creates and returns a new flow controller from its dependencies.
 *
 * @param {ArtifactProvider} artifactProvider
 *    an artifact provider, needed to fetch the flow definition
 * @param {Configuration} configuration
 *    a configuration instance, to determine the name of the flow to load
 * @param {EventBus} eventBus
 *    an event bus instance, used to subscribe to navigateRequest events, and to publish will/did-responses
 * @param {Logger} log
 *    a logger that is used for reporting flow validation and navigation problems
 * @param {PageService} pageService
 *    the page service to use for actual page transitions (setup, teardown) during navigation
 * @param {Router} router
 *    router to register places with, and to use for URL construction
 * @param {Timer} timer
 *    timer to use for measuring page transitions
 *
 * @return {FlowController}
 *    a flow controller instance
 */
function create(artifactProvider, configuration, eventBus, log, pageService, router, timer) {

   var COLLABORATOR_ID = 'AxFlowController';
   var availablePlaces = {};

   var activeParameters = {};
   var activePlace = void 0;
   var activeFragment = void 0;
   var navigationInProgress = false;
   var requestedTarget = null;

   eventBus.subscribe('navigateRequest', function (_ref) {
      var target = _ref.target,
          data = _ref.data,
          fragment = _ref.fragment;

      if (navigationInProgress) {
         return;
      }
      requestedTarget = target;
      navigateToTarget(target, Object.assign({}, activeParameters, data), fragment);
   }, { subscriber: COLLABORATOR_ID });

   /**
    * A flow controller can load a flow definition, setup routes, and allows to navigate between places. The
    * flow controller handles router-initiated navigation as well as `navigateRequest` events and triggers
    * instantiation/destruction of the associated pages.
    *
    * @name FlowController
    * @constructor
    */
   return {
      constructAbsoluteUrl: constructAbsoluteUrl,
      loadFlow: loadFlow
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Load the given flow definition and configure the router.
    *
    * @param {String} name
    *    name of the flow to load
    *
    * @return {Promise}
    *    a promise that is resolved when all routes have been registered
    */
   function loadFlow(name) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(name).hasType(String).isNotNull();
      return artifactProvider.forFlow(name).definition().then(function (flow) {
         return router.registerRoutes(assembleRoutes(flow), createFallbackHandler(flow));
      });
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Get the place definition for a given target or place. If the provided identifier is a target of the
    * current place, the definition of the referenced place is returned. Otherwise, the current place is
    * returned.
    *
    * @param {String} targetOrPlaceId
    *    a string identifying the target or place to obtain a definition for
    * @param {Object} place
    *    the corresponding place definition
    *
    * @return {Object}
    *    a place definition with `targets` and `patterns` as specified in the flow definition, plus `id`
    */
   function placeForTarget(targetOrPlaceId) {
      var place = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : activePlace;

      var placeId = place ? place.targets[targetOrPlaceId] : null;
      if (placeId == null) {
         placeId = targetOrPlaceId;
      }
      __WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */].state(placeId in availablePlaces, 'Unknown target or place "' + targetOrPlaceId + '". Current place: "' + place.id + '"');
      return availablePlaces[placeId];
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Constructs an absolute URL to the given target or place using the given parameters. If a target is
    * given as first argument, it is resolved using the currently active place.
    *
    * @param {String} targetOrPlace
    *    the target or place ID to construct a URL for
    * @param {Object} [optionalParameters]
    *    optional map of place parameters. Missing parameters are filled base on the parameters that were
    *    passed to the currently active place
    * @param {Object} [optionalFragment]
    *    optional hash fragment to append to the URL. Mostly useful with HTML5 based routing
    *
    * @return {String}
    *    the generated absolute URL
    *
    * @memberof FlowService
    */
   function constructAbsoluteUrl(targetOrPlace, optionalParameters, optionalFragment) {
      var place = placeForTarget(targetOrPlace);
      return router.constructAbsoluteUrl(place.patterns, withoutRedundantParameters(place, optionalParameters), optionalFragment);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function navigateToTarget(targetOrPlaceId, parameters, fragment, redirectFrom) {
      var place = placeForTarget(targetOrPlaceId, redirectFrom);
      var options = {};
      if (redirectFrom) {
         options.replaceHistory = true;
      }
      if (fragment) {
         options.fragment = fragment;
      }
      router.navigateTo(place.patterns, withoutRedundantParameters(place, parameters), options);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function navigateToPath(path, redirectFrom) {
      router.navigateToPath(path, { replaceHistory: !!redirectFrom });
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function handleRouteChange(place, routerParameters, fragment) {
      var parameters = Object.assign({}, place.defaultParameters, routerParameters);
      var isSamePlace = activePlace && place.id === activePlace.id;
      var isSameFragment = fragment === activeFragment;

      if (isSamePlace && isSameFragment && equals(parameters, activeParameters)) {
         navigationInProgress = false;
         log.trace('Canceling navigation to "' + place.id + '". Already there with same parameters.');
         return Promise.resolve();
      }
      if (navigationInProgress) {
         log.trace('Canceling navigation to "' + place.id + '". Navigation already in progress.');
         return Promise.resolve();
      }
      navigationInProgress = true;

      var fromPlace = activePlace ? activePlace.targets[TARGET_SELF] : '';
      var navigationTimer = timer.started({
         label: 'navigation (' + fromPlace + ' -> ' + place.targets[TARGET_SELF] + ')',
         persistenceKey: SESSION_KEY_TIMER
      });

      var event = {
         target: requestedTarget || place.id,
         place: place.id,
         data: parameters
      };
      if (fragment) {
         event.fragment = fragment;
      }
      requestedTarget = null;

      var options = { sender: COLLABORATOR_ID };
      return eventBus.publish('willNavigate.' + event.target, event, options).then(function () {
         if (activePlace && isSamePlace) {
            activeParameters = parameters;
            activeFragment = fragment;
            return Promise.resolve();
         }

         return pageService.controller().tearDownPage().then(function () {
            log.setTag('PLCE', place.id);
            activeParameters = parameters;
            activeFragment = fragment;
            activePlace = place;
            return pageService.controller().setupPage(place.page);
         });
      }).then(function () {
         navigationInProgress = false;
         navigationTimer.stopAndLog('didNavigate');
         return eventBus.publish('didNavigate.' + event.target, event, options);
      }).catch(function (err) {
         log.error('Failed to navigate to place "' + place.id + '". Error: [0]\n', err.stack);
         return Promise.reject(err);
      });
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function createFallbackHandler(flow) {
      var redirectOn = flow.redirectOn,
          places = flow.places;

      return function (path) {
         log.warn('Received request for unknown route "' + path + '".');
         if (redirectOn.unknownPlace in places) {
            log.trace('- Redirecting to error place ("' + redirectOn.unknownPlace + '").');
            handleRouteChange(places[redirectOn.unknownPlace], {});
         } else if (DEFAULT_PLACE in places) {
            log.trace('- Redirecting to default place ("' + DEFAULT_PLACE + '").');
            handleRouteChange(places[DEFAULT_PLACE], {});
         } else {
            log.trace('- Got no unknownPlace redirect and no default place. Doing nothing.');
         }
      };
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function assembleRoutes(_ref2) {
      var places = _ref2.places;

      var routeMap = {};
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_object__["forEach"])(places, function (place, placeId) {
         place.id = placeId;
         place.patterns = place.patterns || ['/' + placeId];
         __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_object__["setPath"])(place, 'targets.' + TARGET_SELF, place.id);

         var id = place.id,
             patterns = place.patterns,
             page = place.page,
             redirectTo = place.redirectTo,
             redirectToPath = place.redirectToPath;

         availablePlaces[id] = place;

         if (redirectTo) {
            patterns.forEach(function (pattern) {
               routeMap[pattern] = function (parameters) {
                  navigateToTarget(redirectTo, parameters, null, place);
               };
            });
            return;
         }

         if (redirectToPath) {
            patterns.forEach(function (pattern) {
               routeMap[pattern] = function () {
                  navigateToPath(redirectToPath, place);
               };
            });
            return;
         }

         if (!page) {
            log.error('flow: invalid empty place: ' + id);
            return;
         }

         patterns.forEach(function (pattern) {
            routeMap[pattern] = function (parameters, fragment) {
               handleRouteChange(place, parameters, fragment);
            };
         });
      });
      return routeMap;
   }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function withoutRedundantParameters(place, parameters) {
   var _place$defaultParamet = place.defaultParameters,
       defaultParameters = _place$defaultParamet === undefined ? {} : _place$defaultParamet;

   var remainingParameters = {};
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_object__["forEach"])(parameters, function (value, key) {
      if (!(key in defaultParameters) || defaultParameters[key] !== value) {
         remainingParameters[key] = value;
      }
   });
   return remainingParameters;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function equals(a, b) {
   var aKeys = Object.keys(a);
   var bKeys = Object.keys(b);
   return aKeys.length === bKeys.length && aKeys.every(function (key) {
      return key in b && a[key] === b[key];
   });
}

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * Module providing the FlowService factory.
 *
 * To access the FlowService in a widget, request the {@link widget_services#axFlowService axFlowService}
 * injection.
 *
 * @module flow_service
 */

/**
 * Creates a flow service backed by the given flow controller.
 *
 * @param {FlowController} flowController
 *    a flow controller, needed to respect default parameter values when generating URLs
 *
 * @return {FlowService}
 *    a flow service instance
 *
 * @private
 */
function create(flowController) {

  /**
   * Allows widgets to create valid URLs without knowledge about the current place, its routing patterns, or
   * about the actual routing implementation.
   *
   * @name FlowService
   * @constructor
   */
  return {
    constructAbsoluteUrl: constructAbsoluteUrl
  };

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Constructs an absolute URL to the given target or place using the given parameters. If a target is
   * given as first argument, it is resolved using the currently active place.
   *
   * @param {String} targetOrPlace
   *    the target or place ID to construct a URL for
   * @param {Object} [optionalParameters]
   *    optional map of place parameters. Missing parameters are filled base on the parameters that were
   *    passed to the currently active place
   *
   * @return {String}
   *    the generated absolute URL
   *
   * @memberof FlowService
   */
  function constructAbsoluteUrl(targetOrPlace) {
    var optionalParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return flowController.constructAbsoluteUrl(targetOrPlace, optionalParameters);
  }
}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * Module providing the Heartbeat factory.
 *
 * To use the Heartbeat service in a widget, request the {@link widget_services#axHeartbeat axHeartbeat}
 * injection.
 *
 * @module heartbeat
 */

// Workaround: The angular adapter ties Promise resolution to $rootScope.$digest.
// However, for application performance and ease of testing, we avoid this coupling here.
// We just want to asynchronously execute a callback as quickly as possible.
var NativePromise = window.Promise;

/**
 * Creates a heartbeat backed by the given scheduler.
 *
 * @param {Function} [customNextTick]
 *    a function that takes a callback, and will asynchronously execute that callback as soon as possible,
 *    but asynchronously (that is, after the calling execution stack has finished running).
 *    If omitted, the callback is scheduled using `Promise.resolve().then( ... )`.
 * @param {Function} [customTimeout]
 *    an optional replacement for `window.setTimeout`, used to run coalesced callbacks in a second stage
 *    after the immediately scheduled operation.
 *    This is intended for callbacks that rely on render state (e.g. the angular visibility service).
 *
 * @return {Heartbeat}
 *    a heartbeat instance
 *
 * @private
 */
function create(customNextTick, customTimeout) {

   // "as-soon-as-possible", preferably before rendering
   var nextTick = customNextTick || function (f) {
      NativePromise.resolve().then(f);
   };
   // "as-soon-as-possible", but after rendering of any previous nextTick changes
   var timeout = customTimeout || function (f) {
      setTimeout(f, 0);
   };

   var heartbeatListeners = [];
   var nextQueue = [];
   var beforeQueue = [];
   var afterQueue = [];

   var beatRequested = false;

   /**
    * Scheduler for tasks that possibly synchronously trigger creation of new tasks, that need some common
    * work to be done before or after all of these tasks (and all tasks scheduled in the meantime) are
    * finished.
    *
    * An example would be model-manipulating operations in an application using AngularJS, that need to run
    * `$rootScope.$apply` after all operations are done, but only *once*.
    *
    * @name Heartbeat
    * @constructor
    */
   return {
      registerHeartbeatListener: registerHeartbeatListener,
      onBeforeNext: onBeforeNext,
      onNext: onNext,
      onAfterNext: onAfterNext
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Registers a listener, that is called whenever a heartbeat occurs.
    * It is called after the before and next queues were processed, but before working off the after queue has
    * started.
    * In contrast to the `on*` methods, listeners are not removed after a tick, but will be called again each
    * time a heartbeat occurs.
    * Instead this method returns a function to manually remove the listener again.
    *
    * @param  {Function} listener
    *    the listener to register
    *
    * @return {Function}
    *    a function to remove the listener again
    *
    * @memberof Heartbeat
    */
   function registerHeartbeatListener(listener) {
      heartbeatListeners.push(listener);

      return function () {
         var index = void 0;
         while ((index = heartbeatListeners.indexOf(listener)) !== -1) {
            heartbeatListeners.splice(index, 1);
         }
      };
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Schedules a function for the next heartbeat.
    * If no heartbeat was triggered yet, it will be requested now.
    *
    * @param {Function} func
    *    a function to schedule for the next tick
    *
    * @memberof Heartbeat
    */
   function onNext(func) {
      if (!beatRequested) {
         beatRequested = true;
         nextTick(function () {
            while (beforeQueue.length) {
               beforeQueue.shift()();
            }
            while (nextQueue.length) {
               nextQueue.shift()();
            }
            heartbeatListeners.forEach(function (listener) {
               return listener();
            });
            if (afterQueue.length) {
               // run after-queue once all directly resolvable promises are through.
               timeout(function () {
                  // Ensure that no further event bus deliveries were scheduled
                  if (!beatRequested) {
                     while (afterQueue.length) {
                        afterQueue.shift()();
                     }
                  }
               });
            }
            beatRequested = false;
         });
      }
      nextQueue.push(func);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Schedules a function to be called before the next heartbeat occurs.
    * Note that `func` may never be called, if there is no next heartbeat since calling this function won't
    * trigger a new heartbeat.
    *
    * @param {Function} func
    *    a function to call before the next heartbeat
    *
    * @memberof Heartbeat
    */
   function onBeforeNext(func) {
      beforeQueue.push(func);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Schedules a function to be called after the next heartbeat occured.
    * Note that `func` may never be called, if there is no next heartbeat since calling this function won't
    * trigger a new heartbeat.
    *
    * @param {Function} func
    *    a function to call after the next heartbeat
    *
    * @memberof Heartbeat
    */
   function onAfterNext(func) {
      afterQueue.push(func);
   }
}

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__area_helper__ = __webpack_require__(4);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */


function create(areaHelper, className, widget) {

   var exports = {
      createController: createController,
      domAttachTo: domAttachTo,
      domDetach: domDetach,
      destroy: destroy
   };
   var layoutNode = void 0;
   var deregister = function deregister() {};

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function createController() {}
   // noop


   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function domAttachTo(areaElement, htmlTemplate) {
      if (layoutNode) {
         areaElement.appendChild(layoutNode);
         return;
      }

      layoutNode = document.createElement('div');
      layoutNode.id = widget.id;
      layoutNode.className = className;
      layoutNode.innerHTML = htmlTemplate;

      var areas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__area_helper__["b" /* findWidgetAreas */])(layoutNode);
      var deregisterFuncs = Object.keys(areas).map(function (areaName) {
         return areaHelper.register(widget.id + '.' + areaName, areas[areaName], areaName);
      });
      deregister = function deregister() {
         return deregisterFuncs.forEach(function (func) {
            return func();
         });
      };

      areaElement.appendChild(layoutNode);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function domDetach() {
      if (layoutNode.parentNode) {
         layoutNode.parentNode.removeChild(layoutNode);
      }
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function destroy() {
      deregister();
      layoutNode = null;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   return exports;
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_object__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */


var senderOptions = { sender: 'AxPageController' };
var subscriberOptions = { subscriber: 'AxPageController' };

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * The LocaleManager initializes the locale(s) and implements changes to them.
 *
 * Before publishing the state of all configured locales, it listens to change requests, allowing
 * widgets and activities (such as a LocaleSwitcherWidget) to influence the state of locales before
 * the navigation is complete.
 */

function create(eventBus, configuration) {

   var exports = {
      initialize: initialize,
      subscribe: subscribe,
      unsubscribe: unsubscribe
   };

   var configLocales = configuration.ensure('i18n.locales');
   var i18n = void 0;
   var initialized = void 0;
   var unsubscribeFromEventBus = function unsubscribeFromEventBus() {};

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function publish(locale) {
      var event = { locale: locale, languageTag: i18n[locale] };
      return eventBus.publish('didChangeLocale.' + locale, event, senderOptions);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function initialize() {
      initialized = true;
      return Promise.all(Object.keys(configLocales).map(publish));
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function unsubscribe() {
      unsubscribeFromEventBus();
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function subscribe() {
      i18n = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_object__["deepClone"])(configLocales);
      initialized = false;

      unsubscribeFromEventBus = eventBus.subscribe('changeLocaleRequest', function (event) {
         i18n[event.locale] = event.languageTag;
         if (initialized) {
            publish(event.locale);
         }
      }, subscriberOptions);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   return exports;
}

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_navigo__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_navigo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_navigo__);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * Module providing the Navigo router factory.
 *
 * @module navigo_router
 */


var ROUTE_PARAM_MATCHER = /\/:([^/?(]+)?/g;
var TRAILING_SEGMENTS_MATCHER = /\/(_\/)*_?$/;

/**
 * Creates and returns a new Navigo router instance from its dependencies.
 *
 * @param {Browser} browser
 *    the browser, used to determine the document base href
 * @param {Configuration} configuration
 *    the configuration instance, used to lookup router configuration as described above
 * @param {Function} [Navigo]
 *    a Navigo constructor or mock to use instead of the original implementation. Intended for testing only
 *
 * @return {NavigoRouter}
 *    a router instance that will route as soon as `registerRoutes` is invoked
 *
 * @private
 */
function create(browser, configuration) {
   var Navigo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0_navigo___default.a;


   var useHash = configuration.get('router.navigo.useHash', false);
   var hash = configuration.get('router.navigo.hash', '#');
   var queryEnabled = configuration.ensure('router.query.enabled');

   var absoluteBase = function () {
      if (useHash) {
         return null;
      }
      var base = configuration.get('router.base') || fallbackBase();
      var origin = originFromLocation(browser.location());
      return browser.resolve(base, origin).replace(/\/$/, '');
   }();

   var router = new Navigo(absoluteBase, useHash, hash);

   /**
    * Router implementation based on [Navigo](https://github.com/krasimir/navigo).
    *
    * This router allows to register flow patterns in Navigo syntax so that their handler is activated when
    * the corresponding URL is entered in the browser. While that alone does not add much to the
    * functionality built into Navigo, this router also allows to construct URLs based on a pattern and
    * corresponding substitution parameters. Finally, users can trigger navigation directly.
    *
    * Note that the router supports various configuration options:
    *
    *  - `router.navigo`: configuration object that is directly passed to Navigo (such as `useHash`). The
    *    application is responsible for specifying the required options, as LaxarJS does not touch the Navigo
    *    defaults otherwise. Consult the Navigo documentation for more information
    *  - `router.query.enabled`: if `true`, query parameters are automatically transformed into additional
    *    place parameters and vice versa. The default is `false`
    *  - `router.base`: The base path under which to perform routing. If omitted, the document base href is
    *    used
    *
    * Note that this router encodes/decodes certain parameters in a way that is different from Navigo:
    *
    *  - when the value `null` is encoded into a URL path segment, it is encoded as `_`
    *  - the value `/` is double-encoded
    *
    * @name NavigoRouter
    * @constructor
    */
   return {
      registerRoutes: registerRoutes,
      navigateTo: navigateTo,
      navigateToPath: navigateToPath,
      constructAbsoluteUrl: constructAbsoluteUrl
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Registers all routes defined in the given route map, as well as a fallback route that should be used
    * when none of the other routes match. Also causes the initial route to be triggered.
    *
    * @param {Object.<String, Function>} routeMap
    *    a map of routing patterns in Navigo syntax to the corresponding handler functions. When invoked,
    *    the handler functions will receive the decoded parameter values for their pattern and (if configured)
    *    from the query string, as a map from string parameter name to string value
    * @param {Function} fallbackHandler
    *    a handler that is invoked when none of the configured routes match. It receives the failed location
    *    href as a string argument
    *
    * @memberof NavigoRouter
    */
   function registerRoutes(routeMap, fallbackHandler) {
      var emptyHashRouteHandler = null;
      if (useHash && '/' in routeMap) {
         emptyHashRouteHandler = routeMap['/'];
         delete routeMap['/'];
      }

      var preparedRoutes = Object.keys(routeMap).reduce(function (routes, pattern) {
         return Object.assign({}, routes, _defineProperty({}, pattern, function (params, querystring) {
            var frag = collectFragment();
            routeMap[pattern](collectParameters(params, querystring, frag), frag);
         }));
      }, {});

      router.on(preparedRoutes).on('*', function () {
         if (emptyHashRouteHandler) {
            var _browser$location$has = browser.location().hash.split('?'),
                _browser$location$has2 = _slicedToArray(_browser$location$has, 2),
                _hash = _browser$location$has2[0],
                querystring = _browser$location$has2[1];

            if (['', _hash, _hash + '/'].indexOf(_hash) !== -1) {
               var frag = collectFragment();
               emptyHashRouteHandler(collectParameters({}, querystring, frag));
               return;
            }
         }
         fallbackHandler(browser.location().href);
      }).resolve();

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function collectFragment() {
         var location = browser.location();
         if (!useHash) {
            return location.hash ? decodeURIComponent(location.hash.slice(1)) : null;
         }
         var routingFragment = location.hash.slice(hash.length);
         var start = routingFragment.indexOf('#');
         return start === -1 ? null : decodeURIComponent(routingFragment.slice(start + 1));
      }
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Change the browser location to a different routable URL, from pattern and parameters. This is also
    * called reverse-routing.
    *
    * @param {String[]} patterns
    *    a list of patterns to choose from. This allows the router to pick the "best" pattern, such as the
    *    pattern containing the largest number of given parameters. This router always picks the first pattern
    *    for now
    * @param {Object} parameters
    *    parameter values to substitute into the pattern to generate a URL
    * @param {Object} [options]
    *    additional options to influence navigation
    * @param {Boolean} [options.replaceHistory=false]
    *    if `true`, the current history entry is replaced with the new one, otherwise a new entry is pushed.
    *    Useful to express redirects
    * @param {String} [options.fragment=null]
    *    if set, the given fragment is appended to the URL (after a `#`). Useful with pushState based routing
    *
    * @memberof NavigoRouter
    */
   function navigateTo(patterns, parameters, options) {
      var _replaceHistory$fragm = Object.assign({ replaceHistory: false, fragment: null }, options),
          replaceHistory = _replaceHistory$fragm.replaceHistory,
          fragment = _replaceHistory$fragm.fragment;

      navigateToPath(constructPath(patterns, parameters, fragment), replaceHistory);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Change the browser location to a different routable URL, from a complete path. This is also
    * called reverse-routing.
    *
    * @param {String} path
    *    the complete path to navigate to. This includes values for all relevant parameters
    * @param {Object} [options]
    *    additional options to influence navigation
    * @param {Boolean} [options.replaceHistory=false]
    *    if `true`, the current history entry is replaced with the new one, otherwise a new entry is pushed.
    *    Useful to express redirects
    *
    * @memberof NavigoRouter
    */
   function navigateToPath(path, options) {
      var _replaceHistory$optio = Object.assign({ replaceHistory: false }, options),
          replaceHistory = _replaceHistory$optio.replaceHistory;

      if (!replaceHistory) {
         router.navigate(path);
         return;
      }

      // Navigo uses replaceState only if the router is paused. Alas, if the router is paused, routes will no
      // longer be resolved. Hence, we call resolve again manually after changing history and the location.
      router.pause();
      router.navigate(path);
      router.resume();
      router.resolve();
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Create a routable URL, from pattern and parameters. This allows to create link-hrefs without repeating
    * URL patterns throughout the code base.
    *
    * @param {Array<String>} patterns
    *    a list of patterns to choose from. This allows the router to pick the "best" pattern, such as the
    *    pattern containing the largest number of given parameters. This router always picks the first pattern
    *    for now
    * @param {Object} parameters
    *    parameter values to substitute into the pattern to generate a URL
    * @param {String} [fragment]
    *    optional String fragment to append to the generated URL
    *
    * @return {String}
    *    the resulting URL, including schema and host
    *
    * @memberof NavigoRouter
    */
   function constructAbsoluteUrl(patterns, parameters) {
      var fragment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      return router.link((useHash ? hash : '') + constructPath(patterns, parameters, fragment));
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function constructPath(patterns, parameters, fragment) {
      var bestPattern = patterns[0];
      var remainingParameters = Object.assign({}, parameters);
      var segments = bestPattern.replace(ROUTE_PARAM_MATCHER, function ($0, $param) {
         var replacement = encodeSegment(parameters[$param]);
         delete remainingParameters[$param];
         return '/' + replacement;
      }).replace(TRAILING_SEGMENTS_MATCHER, '/');

      return segments + (queryEnabled ? queryPart() : '') + (fragment != null ? fragmentPart() : '');

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function queryPart() {
         var query = Object.keys(remainingParameters).map(function (name) {
            var value = remainingParameters[name];
            var encodedKey = encodeURIComponent(name);
            if (value === true) {
               return encodedKey;
            }
            if (value === false || value == null) {
               return null;
            }
            return encodedKey + '=' + encodeURIComponent(value);
         }).filter(function (_) {
            return _;
         });

         return query.length ? '?' + query.join('&') : '';
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function fragmentPart() {
         return fragment ? '#' + encodeURIComponent(fragment) : '';
      }
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function collectParameters(params, querystring, frag) {
      var routingUri = browser.location().hash.slice(hash.length);

      var parameters = {};
      if (queryEnabled && querystring && querystring.length) {
         withoutNestedFragment(querystring).split('&').map(function (_) {
            return _.split('=').map(decodeURIComponent);
         }).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            parameters[key] = value !== undefined ? value : true;
         });
      }

      if (!querystring) {
         Object.keys(params || {}).forEach(function (key) {
            params[key] = withoutNestedFragment(params[key]);
         });
      }
      Object.keys(params || {}).forEach(function (key) {
         parameters[key] = decodeSegment(querystring ? params[key] : withoutNestedFragment(params[key]));
      });
      return parameters;

      function withoutNestedFragment(uriPart) {
         // remove nested fragment from parameter. The route-handler will receive it separately
         var containsFragment = useHash && frag && endsWith(uriPart, '#' + frag) && endsWith(routingUri, uriPart);
         return containsFragment ? uriPart.slice(0, uriPart.length - frag.length - 1) : uriPart;
      }
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Encode a parameter value for use as path segment(s) in routing.
    *
    * Usually, values are simply URL-encoded, but there are special cases:
    *
    *  - `null` and `undefined` are encoded as '_',
    *  - other non-string values are converted to strings before URL encoding,
    *  - slashes ('/') are double-encoded to '%252F', so that Navigo ignores them during route matching,
    *  - underscore ('_') is double-encoded to '%255F', to avoid confusion with '_' (null).
    *
    * When decoded, for use in didNavigate events, the original values will be restored, except for:
    *  - non-string input values, which will always be decoded into strings,
    *  - `undefined` values which will be decoded to `null`.
    *
    * @param {*} value
    *   the parameter to encode
    * @return {String}
    *   the encoded value, for use as a path segment in URLs
    *
    * @private
    */
   function encodeSegment(value) {
      if (value == null) {
         return '_';
      }
      var urlSegment = encodeURIComponent(value).replace(/_/g, '%255F');
      return urlSegment.replace(/%2F/g, '%252F');
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Decodes a place parameter value from a path segment, to restore it for use in will/didNavigate events.
    *
    * Usually, this reverses the application of {#encodeSegment} after the browser has decoded a URL, except:
    *  - path-segments based on non-string input values, which will always be decoded into strings,
    *  - path-segments based on `undefined` values which will be decoded to `null`.
    *
    * Note that while the browser has already performed URL-decoding, this function replaces `%2F` into `/`
    * and `%5F` to `_`, to be compatible with the double-encoding performaed by {#encodeSegment}.
    *
    * @param {String} value
    *   the encoded parameter segment to decode
    * @return {String}
    *   the decoded value, for use as a path segment in URLs
    *
    * @private
    */
   function decodeSegment(value) {
      if (value === '_' || value == null) {
         return null;
      }
      var segment = decodeURIComponent(value).replace(/%5F/g, '_');
      return segment.replace(/%2F/g, '/');
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function fallbackBase() {
      // relies on the HTML `base` element being present
      var documentBase = browser.resolve('.').replace(/\/$/, '');
      return documentBase;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function endsWith(subject, searchString) {
      var lastIndex = subject.lastIndexOf(searchString);
      return lastIndex !== -1 && lastIndex === subject.length - searchString.length;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function originFromLocation(_ref3) {
      var protocol = _ref3.protocol,
          hostname = _ref3.hostname,
          port = _ref3.port;

      return protocol + '://' + hostname + (port ? ':' + port : '');
   }
}

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_assert__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area_helper__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_widget_adapter__ = __webpack_require__(21);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */




function create(eventBus, pageLoader, layoutLoader, widgetLoader, localeManager, visibilityManager, log, debugEventBus) {

   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(eventBus).isNotNull();
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(pageLoader).isNotNull();
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(layoutLoader).isNotNull();
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(widgetLoader).isNotNull();
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(localeManager).isNotNull();
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(visibilityManager).isNotNull();
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(debugEventBus).isNotNull();

   var pageController = void 0;

   var pageServiceApi = {
      createControllerFor: function createControllerFor(pageElement, instanceContext) {
         __WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */].state(!pageController, 'Cannot create a page controller more than once.');
         __WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */].state(pageElement instanceof HTMLElement, 'A page controller can only be created for a valid DOM element.');
         __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(instanceContext).hasType(Object).isNotNull();

         pageController = createPageController(pageElement, instanceContext);
         return pageController;
      },
      controller: function controller() {
         return pageController;
      }
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function createPageController(pageElement, /* bootstrappingItemMeta */instanceContext) {

      var _areaHelper = null;
      var api = {
         setupPage: setupPage,
         tearDownPage: tearDownPage,
         areaHelper: function areaHelper() {
            return _areaHelper;
         }
      };
      var publishDebugInfo = function publishDebugInfo(event, data) {
         debugEventBus.publish(event + '.' + instanceContext.instance + '.' + instanceContext.item, Object.assign({
            itemMeta: instanceContext
         }, data));
      };

      /** Delay between sending didLifeCycle and attaching widget templates. */
      var WIDGET_ATTACH_DELAY_MS = 5;
      var COLLABORATOR_ID = 'AxPageController';
      var LIFECYCLE_EVENT = { lifecycleId: 'default' };
      var EVENT_OPTIONS = { sender: COLLABORATOR_ID };
      var DEFAULT_AREAS = [{ name: 'axActivities', hidden: true }, { name: 'axPopups' }, { name: 'axPopovers' }];

      var activeWidgetAdapterWrappers = [];
      var cleanUpLayout = function cleanUpLayout() {};
      var activePage = null;

      pageElement.innerHTML = '';

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function setupPage(pageName) {
         __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(pageName).hasType(String).isNotNull();

         publishDebugInfo('willLoad.page', { page: pageName });

         return pageLoader.load(pageName).then(function (page) {
            _areaHelper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__area_helper__["a" /* create */])(page, log);
            visibilityManager.setAreaHelper(_areaHelper);

            var layoutPromise = layoutLoader.load(page.layout).then(function (layoutInfo) {
               cleanUpLayout = renderLayout(pageElement, _areaHelper, layoutInfo);
            });

            localeManager.subscribe();
            var layoutWidget = function layoutWidget(widget) {
               return layoutWidgetAdapterFor(_areaHelper, widget);
            };

            // instantiate controllers wrapped by widget adapters
            var widgetPromises = widgetsForPage(page).map(function (widget) {
               return 'layout' in widget ? layoutWidget(widget) : widgetLoader.load(widget, {}, instanceContext);
            });

            return Promise.all([].concat(_toConsumableArray(widgetPromises), [layoutPromise])).then(function (results) {
               return results.slice(0, -1);
            });
         }).then(function (widgetAdapterWrappers) {
            publishDebugInfo('didLoad.page', { page: pageName });

            activePage = pageName;
            activeWidgetAdapterWrappers = widgetAdapterWrappers;
         }).then(localeManager.initialize).then(function () {
            return eventBus.publishAndGatherReplies('beginLifecycleRequest.default', LIFECYCLE_EVENT, EVENT_OPTIONS);
         }).then(visibilityManager.initialize)
         // Give the widgets (a little) time to settle on the event bus before $digesting and painting:
         .then(function () {
            return delay(WIDGET_ATTACH_DELAY_MS);
         }).then(function () {
            return _areaHelper.attachWidgets(activeWidgetAdapterWrappers);
         });
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function tearDownPage() {
         visibilityManager.unsubscribe();
         localeManager.unsubscribe();

         publishDebugInfo('willUnload.page', { page: activePage });

         return eventBus.publishAndGatherReplies('endLifecycleRequest.default', LIFECYCLE_EVENT, EVENT_OPTIONS).then(function () {
            var pageName = activePage;
            activeWidgetAdapterWrappers.forEach(function (wrapper) {
               return wrapper.destroy();
            });
            activeWidgetAdapterWrappers = [];
            activePage = null;

            publishDebugInfo('didUnload.page', { page: pageName });
            cleanUpLayout();
            cleanUpLayout = function cleanUpLayout() {};
         });
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function widgetsForPage(page) {
         return Object.keys(page.areas).reduce(function (widgets, areaName) {
            var areaWidgets = page.areas[areaName];
            return areaWidgets.reduce(function (widgets, widget) {
               widget.area = areaName;
               return [].concat(_toConsumableArray(widgets), [widget]);
            }, widgets);
         }, []);
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function layoutWidgetAdapterFor(areaHelper, widget) {
         return layoutLoader.load(widget.layout).then(function (_ref) {
            var className = _ref.className,
                html = _ref.html;

            var adapter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__layout_widget_adapter__["a" /* create */])(areaHelper, className, {
               area: widget.area,
               id: widget.id,
               path: widget.layout
            });

            return {
               id: widget.id,
               adapter: adapter,
               destroy: adapter.destroy,
               templatePromise: Promise.resolve(html)
            };
         });
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function renderLayout(pageElement, areaHelper, layoutInfo) {
         addClass(pageElement, layoutInfo.className);
         pageElement.innerHTML = layoutInfo.html;

         var areas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__area_helper__["b" /* findWidgetAreas */])(pageElement);
         var deregisterFuncs = Object.keys(areas).map(function (areaName) {
            return areaHelper.register(areaName, areas[areaName]);
         });

         DEFAULT_AREAS.forEach(function (area) {
            if (areaHelper.exists(area.name)) {
               return;
            }

            var node = document.createElement('div');
            if (area.hidden) {
               node.style.display = 'none';
            }
            deregisterFuncs.push(areaHelper.register(area.name, node, area.name));
            pageElement.appendChild(node);
         });

         return function () {
            deregisterFuncs.forEach(function (func) {
               return func();
            });
            removeClass(pageElement, layoutInfo.className);
         };
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      return api;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   return pageServiceApi;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function addClass(element, cssClass) {
   if (element.classList) {
      element.classList.add(cssClass);
      return;
   }
   element.className += ' ' + cssClass;
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function removeClass(element, cssClass) {
   if (element.classList) {
      element.classList.remove(cssClass);
      return;
   }
   element.className = element.className.split(' ').map(function (c) {
      return c.trim();
   }).filter(function (c) {
      return c !== cssClass;
   }).join(' ');
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function delay(ms) {
   return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
   });
}

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_assert__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */

/**
 * Module providing the StorageApi factory.
 *
 * Widgets and activities can access their StorageApi instance by requesting the injection
 * {@link widget_services#axStorage axStorage}, or use
 * {@link widget_services#axGlobalStorage axGlobalStorage} for shared items.
 *
 * As such, in most cases only the {@link StorageApi} documentation is relevant.
 *
 * @module storage
 */


var SESSION = 'sessionStorage';
var LOCAL = 'localStorage';

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * @param {Object} backend
 *    the K/V store, probably only accepting string values
 * @param {String} namespace
 *    prefix for all keys for namespacing purposes
 *
 * @return {StorageApi}
 *    a storage wrapper to the given backend with `getItem`, `setItem` and `removeItem` methods
 *
 * @private
 */
function createStorage(backend, namespace) {

   /**
    * Provides a convenient API over the browser's `window.localStorage` and `window.sessionStorage` objects.
    * If a browser doesn't support [web storage](http://www.w3.org/TR/webstorage/), a warning is logged to the
    * `console` (if available) and a non-persistent in-memory store will be used instead. Note that this can
    * for example also happen when using Mozilla Firefox with cookies disabled and as such isn't limited to
    * older browsers.
    *
    * Additionally, in contrast to plain *web storage* access, non-string values will be automatically passed
    * through JSON (de-) serialization on storage or retrieval. All keys will be prepended with a combination
    * of a fixed (`ax.`) and an application-specific namespace (configured using `storagePrefix` with fallback
    * to `name`) to avoid naming clashes with other (LaxarJS) web applications running on the same host and
    * port. All {@link StorageApi} accessor methods should be called without any namespace as it is
    * prepended automatically.
    *
    * @name StorageApi
    * @constructor
    */
   return {
      getItem: getItem,
      setItem: setItem,
      removeItem: removeItem
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Retrieves a `value` by `key` from the store. JSON deserialization will automatically be applied.
    *
    * @param {String} key
    *    the key of the item to retrieve (without namespace prefix)
    *
    * @return {*}
    *    the value or `null` if it doesn't exist in the store
    *
    * @memberof StorageApi
    */
   function getItem(key) {
      var item = backend.getItem(namespace + '.' + key);
      return item && JSON.parse(item);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Sets a `value` for a `key`. The value must be JSON serializable. An existing value will be overwritten.
    *
    * @param {String} key
    *    the key of the item to set (without namespace prefix)
    * @param {*} value
    *    the new value to set
    *
    * @memberof StorageApi
    */
   function setItem(key, value) {
      var nsKey = namespace + '.' + key;
      if (value === undefined) {
         backend.removeItem(nsKey);
      } else {
         backend.setItem(nsKey, JSON.stringify(value));
      }
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Removes the value associated with `key` from the store.
    *
    * @param {String} key
    *    the key of the item to remove (without namespace prefix)
    *
    * @memberof StorageApi
    */
   function removeItem(key) {
      backend.removeItem(namespace + '.' + key);
   }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function getOrFakeBackend(browser, webStorageName) {
   var browserConsole = browser.console();
   var store = window[webStorageName];
   if (store.setItem && store.getItem && store.removeItem) {
      try {
         var testKey = 'ax_.storage.test';
         // In iOS Safari Private Browsing, this will fail:
         store.setItem(testKey, 1);
         store.removeItem(testKey);
         return store;
      } catch (e) {
         // setItem failed: must use fake storage
      }
   }

   if (browserConsole) {
      var method = 'warn' in browserConsole ? 'warn' : 'log';
      browserConsole[method]('window.' + webStorageName + ' not available: Using non-persistent polyfill. \n' + 'Try disabling private browsing or enabling cookies.');
   }

   var backend = {};
   return {
      getItem: function getItem(key) {
         return backend[key] || null;
      },
      setItem: function setItem(key, val) {
         backend[key] = val;
      },
      removeItem: function removeItem(key) {
         if (key in backend) {
            delete backend[key];
         }
      }
   };
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function applicationPrefix(configuration) {
   return configuration.get('storagePrefix', configuration.ensure('name'));
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Creates a new storage factory. In most cases this module will be called without arguments,
 * but having the ability to provide them is useful e.g. for mocking purposes within tests.
 * If the arguments are omitted, an attempt is made to access the native browser WebStorage api.
 * If that fails, storage is only mocked by an in memory map (thus actually unavailable).
 *
 * Developers are free to use polyfills to support cases where local- or session-storage may not be
 * available. Just make sure to initialize the polyfills before this module.
 *
 * @param {Object} configuration
 *    a configuration service instance, to determine a storage prefix based on the configured name
 * @param {Object} browser
 *    the browser api adapter
 * @param {Object} [localStorageBackend]
 *    the backend for local storage. Default is `window.localStorage`
 * @param {Object} [sessionStorageBackend]
 *    the backend for session storage. Default is `window.sessionStorage`
 *
 * @return {StorageFactory}
 *    a new storage factory
 *
 * @private
 */
function create(configuration, browser, localStorageBackend, sessionStorageBackend) {

   var localBackend = localStorageBackend || getOrFakeBackend(browser, LOCAL);
   var sessionBackend = sessionStorageBackend || getOrFakeBackend(browser, SESSION);
   var prefix = 'ax.' + applicationPrefix(configuration) + '.';

   /**
    * The API returned by the module's `create` function.
    *
    * @name StorageFactory
    * @constructor
    */
   return {

      /**
       * Returns a local storage object for a specific local namespace.
       *
       * @param {String} namespace
       *    the namespace to prepend to keys
       *
       * @return {StorageApi}
       *    the local storage object
       *
       * @memberof StorageFactory
       */
      getLocalStorage: function getLocalStorage(namespace) {
         __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(namespace).hasType(String).isNotNull();

         return createStorage(localBackend, prefix + namespace);
      },


      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      /**
       * Returns a session storage object for a specific local namespace.
       *
       * @param {String} namespace
       *    the namespace to prepend to keys
       *
       * @return {StorageApi}
       *    the session storage object
       *
       * @memberof StorageFactory
       */
      getSessionStorage: function getSessionStorage(namespace) {
         __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(namespace).hasType(String).isNotNull();

         return createStorage(sessionBackend, prefix + namespace);
      },


      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      /**
       * Returns the local storage object for application scoped keys. This is equivalent to
       * `storage.getLocalStorage( 'app' )`.
       *
       * @return {StorageApi}
       *    the application local storage object
       *
       * @memberof StorageFactory
       */
      getApplicationLocalStorage: function getApplicationLocalStorage() {
         return createStorage(localBackend, prefix + 'app');
      },


      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      /**
       * Returns the session storage object for application scoped keys. This is equivalent to
       * `storage.getSessionStorage( 'app' )`.
       *
       * @return {StorageApi}
       *    the application session storage object
       *
       * @memberof StorageFactory
       */
      getApplicationSessionStorage: function getApplicationSessionStorage() {
         return createStorage(sessionBackend, prefix + 'app');
      }
   };
}

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_object__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */


function create(log) {

   var api = {
      started: started
   };

   var idCounter = 0;

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function started(optionalOptions) {
      var timer = new Timer(optionalOptions);
      timer.start();
      return timer;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function Timer(optionalOptions) {
      this.options_ = Object.assign({
         label: 'timer' + idCounter++
      }, optionalOptions);
      this.startTime_ = null;
      this.stopTime_ = null;
      this.splitTimes_ = [];
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   Timer.prototype.getData = function () {
      return {
         label: this.options_.label,
         startTime: this.startTime_,
         stopTime: this.stopTime_,
         splitTimes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_object__["deepClone"])(this.splitTimes_)
      };
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   Timer.prototype.start = function () {
      this.startTime_ = Date.now();
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   Timer.prototype.splitTime = function (optionalLabel) {
      this.splitTimes_.push({
         time: Date.now(),
         label: optionalLabel || 'split' + this.splitTimes_.length
      });
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   Timer.prototype.stop = function () {
      this.stopTime_ = Date.now();
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   Timer.prototype.stopAndLog = function (optionalLabel) {
      this.stop();

      var startTime = this.startTime_;
      var endTime = Date.now();
      var label = optionalLabel || 'Timer Stopped';
      this.splitTimes_.push({ label: label, time: endTime });

      var message = [];
      message.push('Timer "', this.options_.label, '": ');
      message.push('start at ', new Date(startTime).toISOString(), ' (client), ');
      message.push(label, ' after ', (endTime - startTime).toFixed(0), 'ms ');
      message.push('(checkpoints: ');
      var intervals = [];
      this.splitTimes_.reduce(function (from, data) {
         intervals.push('"' + data.label + '"=' + (data.time - from).toFixed(0) + 'ms');
         return data.time;
      }, startTime);
      message.push(intervals.join(', '), ')');
      log.info(message.join(''));
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   return api;
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
var senderOptions = { sender: 'AxPageController', deliverToSender: false };
var subscriberOptions = { subscriber: 'AxPageController' };

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * The visibility event manager initializes and coordinates events for widget area visibility.
 *
 * It subscribes to all visibility changes and propagates them to nested widget areas
 * (if applicable). It is not concerned with the resulting DOM-visibility of individual controls:
 * the `axVisibilityService` takes care of that.
 *
 * @param {EventBus} eventBus
 *    an event bus instance
 * @return {Object}
 *    a function to trigger initialization of the manager and initial widget visibility
 */
function create(eventBus) {

   var exports = {
      initialize: initialize,
      setAreaHelper: setAreaHelper,
      unsubscribe: unsubscribe
   };

   var areaHelper = void 0;
   var unsubscribeFromAreaVisibilityRequest = function unsubscribeFromAreaVisibilityRequest() {};
   var unsubscribeFromWidgetVisibilityRequest = function unsubscribeFromWidgetVisibilityRequest() {};
   var ROOT = '';

   function setAreaHelper(_) {
      areaHelper = _;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function initialize() {
      // broadcast visibility changes in individual widgets to their nested areas
      unsubscribeFromWidgetVisibilityRequest = eventBus.subscribe('changeWidgetVisibilityRequest', function (event) {
         var affectedAreas = areaHelper.areasInWidget(event.widget);
         var will = ['willChangeWidgetVisibility', event.widget, event.visible].join('.');
         var did = ['didChangeWidgetVisibility', event.widget, event.visible].join('.');

         eventBus.publish(will, event, senderOptions);

         Promise.all((affectedAreas || []).map(event.visible ? show : hide)).then(function () {
            return eventBus.publish(did, event, senderOptions);
         });
      }, subscriberOptions);

      // broadcast visibility changes in widget areas to their nested areas
      unsubscribeFromAreaVisibilityRequest = eventBus.subscribe('changeAreaVisibilityRequest', function (event) {
         return initiateAreaChange(event.area, event.visible);
      }, subscriberOptions);

      return implementAreaChange(ROOT, true);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function show(area) {
      return requestAreaChange(area, true);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function hide(area) {
      return requestAreaChange(area, false);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * First, publish a `changeAreaVisibilityRequest` to ask if some widget would like to manage the
    * given area's visibility.
    * If no widget responds, self-issue a will/did-response to notify interested widgets in the area
    * of their new visibility status.
    * In either case, manage the propagation to nested areas and inform the area helper so that it
    * may compile and attach the templates of any newly visible widgets.
    *
    * @param {String} area
    *    the area whose visibility to update
    * @param {Boolean} visible
    *    the new visibility state of the given area, to the best knowledge of the client
    * @return {Promise}
    *    promise that is resolved after the change request is completed
    */
   function requestAreaChange(area, visible) {
      var request = ['changeAreaVisibilityRequest', area].join('.');
      var event = { area: area, visible: visible };
      return eventBus.publishAndGatherReplies(request, event, senderOptions).then(function (responses) {
         if (responses.length === 0) {
            // no one took responsibility, so the event manager determines visibility by area nesting
            return initiateAreaChange(area, visible);
         }
         // assume the first 'did'-response to be authoritative:
         var response = responses[0];
         return implementAreaChange(area, response.event.visible);
      });
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   // eslint-disable-next-line valid-jsdoc
   /**
    * Set the new visibility state for the given area, then issue requests for the child areas.
    * Inform the area helper so that it may compile and attach the templates of any newly visible
    * widgets.
    */
   function initiateAreaChange(area, visible) {
      var will = ['willChangeAreaVisibility', area, visible].join('.');
      var event = { area: area, visible: visible };
      return eventBus.publish(will, event, senderOptions).then(function () {
         return implementAreaChange(area, visible);
      }).then(function () {
         var did = ['didChangeAreaVisibility', area, visible].join('.');
         return eventBus.publish(did, event, senderOptions);
      });
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function implementAreaChange(ofArea, areaVisible) {
      areaHelper.setVisibility(ofArea, areaVisible);
      var children = areaHelper.areasInArea(ofArea);
      if (!children) {
         return Promise.resolve();
      }

      return Promise.all(children.map(areaVisible ? show : hide));
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function unsubscribe() {
      unsubscribeFromWidgetVisibilityRequest();
      unsubscribeFromAreaVisibilityRequest();
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   return exports;
}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_assert__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__runtime_log__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__widget_services_i18n__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__widget_services_visibility__ = __webpack_require__(30);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */

/**
 * Factory for the services that are available to the controller of a widget, regardless of the underlying
 * view framework.
 *
 * @module widget_services
 */






var INVALID_ID_MATCHER = /[^A-Za-z0-9_.-]/g;
var ID_SEPARATOR = '-';

function create(artifactProvider, configuration, controlLoader, debugEventBus, globalEventBus, flowService, log, heartbeat, pageService, storage, tooling) {

   var i18nOptions = configuration.ensure('i18n');

   return {
      forWidget: function forWidget(specification, widgetConfiguration, features) {
         var decorators = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
         var itemMeta = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
         var widgetId = widgetConfiguration.id;
         var widgetName = specification.name;


         var instances = {
            /**
             * Allows to manage the widget's areas.
             *
             * @type {AxAreaHelper}
             */
            axAreaHelper: null,

            /**
             * Provides access to the widget's assets.
             *
             * @type {AxAssets}
             */
            axAssets: null,

            /**
             * Interface to the full configuration the application was bootstrapped with.
             *
             * @type {Configuration}
             */
            axConfiguration: null,

            /**
             * Combines essential widget services with some instance information to be passed around en bloc.
             *
             * @type {AxContext}
             */
            axContext: null,

            /**
             * Provides access to implementation modules of the controls used by the widget.
             *
             * @type {ControlLoader}
             */
            axControls: null,

            /**
             * Provides access to a super-global EventBus shared by Laxar instances.
             *
             * @type {AxEventBus}
             */
            axDebugEventBus: null,

            /**
             * Event bus instance specifically enriched for the widget instance.
             *
             * @type {AxEventBus}
             */
            axEventBus: null,

            /**
             * The features the widget was configured with.
             * Its structure depends on the schema defined in the widget descriptor (`widget.json`).
             *
             * @type {Object}
             */
            axFeatures: null,

            /**
             * Allows to generate URLs based on navigation targets or place IDs, in order to create links.
             *
             * @type {FlowService}
             */
            axFlowService: null,

            /**
             * The global event bus instance of the application.
             *
             * The widget-specific {@link axEventBus} should always be prefered over this, since subscriptions
             * to the global event bus will not be cleaned up automatically as clients are destroyed, which
             * can lead to severe memory leaks.
             * A valid use case could be an activity that needs to add an inspector to the event bus in order
             * to provide debuggig information about application events, or to log specific events without
             * stopping on page navigation.
             *
             * @type {EventBus}
             */
            axGlobalEventBus: null,

            /**
             * Allows to log messages, taking into account the configured log level.
             *
             * @type {Logger}
             */
            axGlobalLog: null,

            /**
             * The global storage factory allows to share storage items across widgets.
             *
             * @type {StorageFactory}
             */
            axGlobalStorage: null,

            /**
             * The heartbeat instance allows to perform actions such as dirty checking after each event
             * bus cycle.
             *
             * @type {Heartbeat}
             */
            axHeartbeat: null,

            /**
             * I18n API that allows to localize values depending on the locale configured for the widget.
             *
             * @type {AxI18n}
             */
            axI18n: null,

            /**
             * A function that generates page-wide unique IDs based on IDs that are unique within the scope
             * of a widget.
             *
             * A common use case is the connection of a `label` HTML element and an `input` element via `for`
             * and `id` attributes.
             * To avoid collisions, IDs should **always** be generated using this service.
             *
             * Example:
             *
             * ```js
             * // ... inject `axId`, get reference to `widgetDom` (depends on integration technology) ...
             * widgetDom.querySelector( 'label' ).setAttribute( 'for', axId( 'myField' ) );
             * widgetDom.querySelector( 'input' ).setAttribute( 'id', axId( 'myField' ) );
             * ```
             *
             * @param {String} localUniqueId
             *    an identifier that is unique within a widget
             *
             * @return {String}
             *    an identifier that is unique for the current page
             *
             * @type {Function}
             */
            axId: null,

            /**
             * The widget logger instance.
             * Similar to {@link #axGlobalLog}, but adds the name of the widget as prefix and the widget ID
             * as suffix to every log message.
             *
             * @type {Logger}
             */
            axLog: null,

            /**
             * Preconfigured storage API for a widget: all keys are namespaced using the widget ID,
             * in order to limit item visibility to this specific instance.
             *
             * @type {AxStorage}
             */
            axStorage: null,

            /**
             * Access to the tooling provider API.
             *
             * @type {AxTooling}
             */
            axTooling: null,

            /**
             * Visibility services for a widget instance.
             * @type {AxVisibility}
             */
            axVisibility: null
         };

         var services = Object.assign({}, instances);
         var releaseHandlers = [];

         registerServiceFactory('axAreaHelper', function () {
            return createAreaHelperForWidget(widgetId);
         }, function () {
            instances.axAreaHelper.release();
         });
         registerServiceFactory('axAssets', function () {
            return createAssetsServiceForWidget(widgetName);
         });
         registerService('axConfiguration', configuration);
         registerServiceFactory('axContext', function () {
            return createContextForWidget(widgetConfiguration, widgetId, services);
         });
         registerService('axControls', controlLoader);
         registerService('axDebugEventBus', debugEventBus);
         registerServiceFactory('axEventBus', function () {
            return createEventBusForWidget(services.axGlobalEventBus, widgetName, widgetId);
         }, function () {
            instances.axEventBus.release();
         });
         registerService('axFeatures', features);
         registerService('axFlowService', flowService);
         registerService('axGlobalEventBus', globalEventBus);
         registerService('axGlobalLog', log);
         registerService('axGlobalStorage', storage);
         registerService('axHeartbeat', heartbeat);

         registerServiceFactory('axI18n', function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__widget_services_i18n__["a" /* create */])(services.axContext, services.axConfiguration, i18nOptions);
         });
         registerServiceFactory('axId', function () {
            return createIdGeneratorForWidget(widgetId);
         });
         registerServiceFactory('axLog', function () {
            return createLoggerForWidget(log, widgetName, widgetId);
         });
         registerServiceFactory('axStorage', function () {
            return createStorageForWidget(storage, widgetId);
         });
         registerServiceFactory('axTooling', function () {
            return createToolingForWidget(tooling, widgetId, itemMeta);
         }, function () {
            instances.axTooling.release();
         });
         registerServiceFactory('axVisibility', function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__widget_services_visibility__["a" /* create */])(services.axContext, services.axAreaHelper);
         });

         return {
            services: services,
            releaseServices: function releaseServices() {
               releaseHandlers.forEach(function (f) {
                  f();
               });
            }
         };

         /////////////////////////////////////////////////////////////////////////////////////////////////////

         function registerService(name, instance) {
            var decorate = decorators[name];
            instances[name] = services[name] = decorate ? decorate(instance) : instance;
         }

         /////////////////////////////////////////////////////////////////////////////////////////////////////

         function registerServiceFactory(name, factory, optionalRelease) {
            Object.defineProperty(services, name, {
               get: function get() {
                  if (!instances[name]) {
                     var decorate = decorators[name];
                     var instance = factory();
                     instances[name] = decorate ? decorate(instance) : instance;
                     if (optionalRelease) {
                        releaseHandlers.push(optionalRelease);
                     }
                  }
                  return instances[name];
               },
               set: function set(value) {
                  instances[name] = value;
               }
            });
         }
      }
   };

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function createContextForWidget(widgetConfiguration, widgetId, services) {

      /**
       * This object encapsulates widget context information and provides access to the most important widget
       * specific service instances.
       * Most commonly this is used when working with
       * [LaxarJS Patterns](https://github.com/LaxarJS/laxar-patterns).
       *
       * @name AxContext
       * @constructor
       */
      return {

         /**
          * The event bus instance of the widget. This is the same as {@link #axEventBus}.
          *
          * @type {AxEventBus}
          * @memberof AxContext
          */
         eventBus: services.axEventBus,

         /**
          * The configured features of the widget. This is the same as {@link #axFeatures}.
          *
          * @type {Object}
          * @memberof AxContext
          */
         features: services.axFeatures,

         /**
          * The unique id generator function. This is the same as {@link #axId}.
          *
          * @type {Function}
          * @memberof AxContext
          */
         id: services.axId,

         /**
          * The widget local log instance. This is the same as {@link #axLog}.
          *
          * @type {AxLog}
          * @memberof AxContext
          */
         log: services.axLog,

         /**
          * Some information regarding the widget instance.
          *
          * The following fields are available:
          * - `area`: full name of the area the widget is located in
          * - `id`: the unique id of the widget on the page
          * - `path`: path of the widget that was used to reference it in the according page or composition.
          *    This is not the actual path on the file system, but most probably an alias known by the used
          *    module loader.
          *
          * @type {Object}
          * @memberof AxContext
          */
         widget: {
            area: widgetConfiguration.area,
            id: widgetId,
            path: widgetConfiguration.widget
         }
      };
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function createAreaHelperForWidget(widgetId) {
      var deregisterFuncs = [];

      /**
       * @name AxAreaHelper
       * @constructor
       */
      return {

         /**
          * Query if a given widget area is currently visible by accessing the underlying area status through
          * the page controller. Can be used to determine the current visibility state of an area without
          * having to constantly observe visibility events.
          *
          * @param {String} fullAreaName
          *    the global name of the area
          *
          * @return {Boolean}
          *    the current visibility state of the given area
          *
          * @memberof AxAreaHelper
          */
         isVisible: function isVisible(fullAreaName) {
            return pageService.controller().areaHelper().isVisible(fullAreaName);
         },


         /**
          * Looks up the global name of a widget area within a widget, as generated by LaxarJS.
          * This is the reverse of {@link #AxAreaHelper.localName()}.
          *
          * @param {String} localAreaName
          *    the widget-local name of the area
          *
          * @return {String}
          *    the globally valid name of the area
          *
          * @memberof AxAreaHelper
          */
         fullName: function fullName(localAreaName) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(localAreaName || null).hasType(String).isNotNull();
            return qualify(localAreaName);
         },


         /**
          * Returns the local part of a global area name.
          * This is the reverse of {@link #AxAreaHelper.fullName()}.
          *
          * @param {String} fullAreaName
          *    the global name of the area
          *
          * @return {String}
          *    the name of the area as it is known to the widget
          *
          * @memberof AxAreaHelper
          */
         localName: function localName(fullAreaName) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(fullAreaName).hasType(String).isNotNull();
            return unqualify(fullAreaName);
         },


         /**
          * Registers a DOM element as area of a widget with the area helper.
          *
          * @param {String} localAreaName
          *    the widget-local name of the area
          * @param {HTMLElement} element
          *    the element to register as widget area
          *
          * @memberof AxAreaHelper
          */
         register: function register(localAreaName, element) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(localAreaName).hasType(String).isNotNull();
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(element).hasType(Object).isNotNull();
            var areaHelper = pageService.controller().areaHelper();
            deregisterFuncs.push(areaHelper.register(qualify(localAreaName), element, localAreaName));
         },
         release: function release() {
            deregisterFuncs.forEach(function (_) {
               _();
            });
         }
      };

      function qualify(localAreaName) {
         return widgetId + '.' + localAreaName;
      }

      function unqualify(fullAreaName) {
         return fullAreaName.slice(widgetId.length + 1);
      }
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function createAssetsServiceForWidget(widgetName) {
      var widgetArtifacts = artifactProvider.forWidget(widgetName);

      /**
       * _Note:_ This service is a function with the {@link #AxAssets.url()}, {@link #AxAssets.forTheme()} and
       * {@link #AxAssets.urlForTheme()} functions as properties.
       *
       * Resolves an asset located directly in the widget folder or a subfolder of it.
       * Valid assets are all non-binary files like JSON or text files.
       * For binary files there exists the {@link #AxAssets.url} function.
       *
       * Example:
       * ```js
       * // ... inject `axAssets` ...
       * axAssets( 'data.json' ).then( fileContent => { ... } );
       * ```
       *
       * @param {String} name
       *    name of the asset to resolve
       *
       * @return {Promise}
       *    promise for the asset
       *
       * @name AxAssets
       */
      var assetService = function assetService(name) {
         return widgetArtifacts.asset(name);
      };

      /**
       * Resolves the absolute url to the given asset located directly in the widget folder or a subfolder of
       * it.
       * This can then be safely used in e.g. `video` or `img` tags.
       *
       * Example:
       * ```js
       * // ... inject `axAssets`, find `img` in DOM ...
       * axAssets.url( 'tux.jpg' ).then( url => { img.src = url; } );
       * ```
       *
       * @param  {String} name
       *    name of the asset the url should be returned of
       *
       * @return {Promise}
       *    promise for the url
       *
       * @memberof AxAssets
       */
      assetService.url = function (name) {
         return widgetArtifacts.assetUrl(name);
      };

      /**
       * Resolves an asset from one of the `*.theme` subfolders of the widget.
       * The folder from which the asset is taken, depends on the selected theme and the availability of the
       * file within that theme (See
       * [here](http://laxarjs.org/docs/laxar-latest/manuals/creating_themes/#how-the-runtime-finds-css) for
       * further information on theme asset lookup).
       * Valid assets are all non-binary files like JSON or text files.
       * For binary files there exists the {@link #AxAssets.urlForTheme} function.
       *
       * Example:
       * ```js
       * // ... inject `axAssets` ...
       * axAssets.forTheme( 'some-template.html' ).then( template => { ... } );
       * ```
       *
       * @param {String} name
       *    name of the asset to resolve
       *
       * @return {Promise}
       *    promise for the asset
       *
       * @memberof AxAssets
       */
      assetService.forTheme = function (name) {
         return widgetArtifacts.assetForTheme(name);
      };

      /**
       * Resolves the absolute url to the given asset from one of the `*.theme` subfolders of the widget.
       * This can then be safely used in e.g. `video` or `img` tags.
       * The folder from which the asset is taken, depends on the selected theme and the availability of the
       * file within that theme (See
       * [here](http://laxarjs.org/docs/laxar-latest/manuals/creating_themes/#how-the-runtime-finds-css) for
       * further information on theme asset lookup).
       *
       * Example:
       * ```js
       * // ... inject `axAssets`, find `img` in DOM ...
       * axAssets.urlForTheme( 'icon.jpg' ).then( url => { img.src = url; } );
       * ```
       *
       * @param  {String} name
       *    name of the asset the url should be returned of
       *
       * @return {Promise}
       *    promise for the url
       *
       * @memberof AxAssets
       */
      assetService.urlForTheme = function (name) {
         return widgetArtifacts.assetUrlForTheme(name);
      };
      return assetService;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function createLoggerForWidget(logger, widgetName, widgetId) {
      var newLogger = Object.create(logger);
      newLogger.log = function (level, message) {
         for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            rest[_key - 2] = arguments[_key];
         }

         return logger.log.apply(logger, [level, enrich(message)].concat(rest, [__WEBPACK_IMPORTED_MODULE_1__runtime_log__["b" /* BLACKBOX */]]));
      };
      Object.keys(logger.levels).map(function (_) {
         return _.toLowerCase();
      }).forEach(function (method) {
         newLogger[method] = function (message) {
            for (var _len2 = arguments.length, rest = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
               rest[_key2 - 1] = arguments[_key2];
            }

            return logger[method].apply(logger, [enrich(message)].concat(rest, [__WEBPACK_IMPORTED_MODULE_1__runtime_log__["b" /* BLACKBOX */]]));
         };
      });
      return newLogger;

      function enrich(message) {
         return widgetName + ': ' + message + ' (widget-id: ' + widgetId + ')';
      }
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function createStorageForWidget(storage, widgetId) {
      var namespace = 'widget-' + widgetId;

      /**
       * Ready to use storage API for a single widget instance.
       * All keys are namespaced by the widget id to limit visibility to this specific instance.
       *
       * @name AxStorage
       * @constructor
       */
      return {
         /**
          * An instance of the storage api using the persistent `window.localStorage`.
          *
          * @type {StorageApi}
          * @memberof AxStorage
          */
         local: storage.getLocalStorage(namespace),

         /**
          * An instance of the storage api using the non-persistent `window.sessionStorage`.
          *
          * @type {StorageApi}
          * @memberof AxStorage
          */
         session: storage.getSessionStorage(namespace)
      };
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function createToolingForWidget(tooling, widgetId, itemMeta) {
      return tooling.forItem(itemMeta);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function createIdGeneratorForWidget(widgetId) {
      var charCodeOfA = 'a'.charCodeAt(0);
      function fixLetter(l) {
         // We map invalid characters deterministically to valid lower case letters. Thereby a collision of
         // two IDs with different invalid characters at the same positions is less likely to occur.
         return String.fromCharCode(charCodeOfA + l.charCodeAt(0) % 26);
      }

      var prefix = 'ax' + ID_SEPARATOR + widgetId.replace(INVALID_ID_MATCHER, fixLetter) + ID_SEPARATOR;
      return function (localId) {
         return prefix + ('' + localId).replace(INVALID_ID_MATCHER, fixLetter);
      };
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function createEventBusForWidget(eventBus, widgetName, widgetId) {

      var collaboratorId = 'widget.' + widgetName + '#' + widgetId;
      var inspectorRemoveFunctions = [];
      var unsubscribeFunctions = [];

      /**
       * This is an extension of the global {@link event_bus#EventBus EventBus} by widget specific information
       * and tasks.
       * For example a combination of the widget's name and its id is always used as subscriber and sender
       * id.
       * Hence for example {@link event_bus#EventBus.publishAndGatherReplies EventBus.publishAndGatherReplies}
       * works without passing in any options.
       *
       * Additionally all subscriptions of a widget are removed as soon as the widget itself is destroyed.
       * So in practice a widget will receive no further events after the `endLifecycleRequest` event
       * processing has finished.
       *
       * The documentation for the events bus api can be found {@linkplain event_bus here}.
       *
       * @name AxEventBus
       * @constructor
       */
      return {
         addInspector: function addInspector(inspector) {
            return makeAutoRemovable(inspectorRemoveFunctions, eventBus.addInspector(inspector));
         },
         unsubscribe: function unsubscribe(subscriber) {
            return eventBus.unsubscribe(subscriber);
         },
         subscribe: function subscribe(eventName, subscriber, optionalOptions) {
            var options = Object.assign({}, optionalOptions, { subscriber: collaboratorId });
            var unsubscribe = eventBus.subscribe(eventName, subscriber, options);

            return makeAutoRemovable(unsubscribeFunctions, unsubscribe);
         },
         publish: function publish(eventName, optionalEvent, optionalOptions) {
            var options = Object.assign({}, optionalOptions, { sender: collaboratorId });
            return eventBus.publish(eventName, optionalEvent, options);
         },
         publishAndGatherReplies: function publishAndGatherReplies(eventName, optionalEvent, optionalOptions) {
            var options = Object.assign({}, optionalOptions, { sender: collaboratorId });
            return eventBus.publishAndGatherReplies(eventName, optionalEvent, options);
         },
         release: function release() {
            purgeAutoRemoveRegistries(inspectorRemoveFunctions, unsubscribeFunctions);
         }
      };

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function makeAutoRemovable(registry, removeFunction) {
         registry.push(removeFunction);
         return function () {
            removeFunction();
            var index = registry.indexOf(removeFunction);
            if (index !== -1) {
               registry.splice(index, 1);
            }
         };
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function purgeAutoRemoveRegistries() {
         for (var _len3 = arguments.length, registries = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            registries[_key3] = arguments[_key3];
         }

         registries.forEach(function (registry) {
            registry.forEach(function (_) {
               _();
            });
            registry.length = 0;
         });
      }
   }
}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_assert__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_object__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_string__ = __webpack_require__(2);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */

/**
 * Factory for i18n widget service instances.
 *
 * @module widget_services_i18n
 */




var noDeliveryToSender = { deliverToSender: false };

var primitives = {
   string: true,
   number: true,
   boolean: true
};

var normalize = memoize(function (languageTag) {
   return languageTag.toLowerCase().replace(/[_]/g, '-');
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Creates a widget-specific helper for `didChangeLocale` events.
 *
 * The helper automatically observes the any changes to the locale that was configured under the `i18n`
 * feature, and can be asked for localization based on that locale. It also allows to `track` the current
 * language tag for all observed locale topics under the object `i18n.tags`. This object can be used to set
 * up value bindings and/or watchers so that other components may react to locale-changes in a data-driven
 * way.
 *
 * The i18n helper is an {@link AxI18nHandler} for the feauture "i18n" by default, but allows to create
 * handlers for other feature-paths using the `forFeature` method.
 * Using `release`, it is possible to free the eventBus subscription held by an i18n helper instance and by
 * all feature-handlers created by it.
 *
 * @param {AxContext} context
 *    the widget context/scope that the handler should work with. It uses the `eventBus` property there
 *    with which it can do the event handling
 * @param {AxConfiguration} configuration
 *    the (global) configuration to use for supplying a default locale if the widget does not have an 'i18n'
 *    feature
 * @param {Object} [optionalOptions]
 *    the fallback language tag to use when no localization is available for a locale's current language tag
 * @param {String} [optionalOptions.fallback]
 *    the fallback language tag to use when no localization is available for a locale's current language tag
 * @param {Boolean} [optionalOptions.strict]
 *    if `true`, localizations are only used if the language tags exactly match the current locale's tag
 *    (after normalizing case and dash/underscore). If `false` (default), specific requests can be satisfied
 *    by general localizations (e.g. a translation for 'en' may be used when missing 'en_GB' was requested).
 *
 * @return {AxI18n}
 *    an i18n instance
 */
function create(context, configuration) {
   var optionalOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
   var features = context.features,
       eventBus = context.eventBus,
       widget = context.widget;
   var _optionalOptions$fall = optionalOptions.fallback,
       fallback = _optionalOptions$fall === undefined ? 'en' : _optionalOptions$fall,
       _optionalOptions$stri = optionalOptions.strict,
       strict = _optionalOptions$stri === undefined ? false : _optionalOptions$stri;

   var handlers = {};
   var tags = {};
   var callbacks = {};

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   var unsubscribe = eventBus.subscribe('didChangeLocale', handleLocaleChange);

   var fallbackLocale = configuration.get('i18n.locales.default', fallback);
   var defaultLocale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_object__["path"])(features, 'i18n.locale', fallbackLocale);

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * An i18n instance allows to create {@link #AxI18nHandler} instances for any feature, but is itself also
    * an i18n handler for the feature `i18n`.
    * So if the widget using the {@link widget_services#axI18n axI18n} injection uses the recommended
    * name `i18n` for the localization feature, use this directly with the i18n handler API.
    *
    * @constructor
    * @name AxI18n
    */
   return Object.assign({
      forFeature: forFeature,
      release: function release() {
         return unsubscribe();
      }
   }, forLocale(defaultLocale, 'i18n'));

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Creates and returns an i18n handler for the loclization configuration under the given
    * [feature path](../glossary#feature-path).
    * The configuration value is expected to be an object with the key `locale` that is configured with the
    * locale to use in the widget instance.
    *
    * @param {String} featurePath
    *    the feature path localization configuration can be found at
    *
    * @return {AxI18nHandler}
    *    the i18n handler for the given feature path
    *
    * @memberof AxI18n
    */
   function forFeature(featurePath) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(featurePath).hasType(String).isNotNull();
      if (handlers[featurePath]) {
         return handlers[featurePath];
      }

      var locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_object__["path"])(features, featurePath + '.locale');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(locale).hasType(String).isNotNull('axI18n: missing feature-configuration \'' + featurePath + '.locale\' (widget: ' + widget.id + ')');

      var api = forLocale(locale, featurePath);
      handlers[featurePath] = api;
      return api;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function forLocale(locale, trackingProperty) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(trackingProperty).hasType(String).isNotNull();
      var localize = strict ? localizeStrict : localizeRelaxed;

      /**
       * @constructor
       * @name AxI18nHandler
       */
      return {
         format: format,
         languageTag: languageTag,

         /**
          * Localize the given internationalized object using the given languageTag.
          *
          * If i18n is configured to be _strict_, the currently active language tag is used to lookup a
          * translation.
          * If nothing is found, the `languageTag` argument is tried.
          * If still nothing is found, `undefined` is returned.
          *
          * In the case _strict_ is set to `false`, the behavior is the same as in _strict_ mode if an exact
          * localization is available.
          * If not, the language tag is successively generalized by stripping off the rightmost sub-tags
          * until a localization is found.
          * Eventually, a fallback (default: 'en') is used.
          * This behavior is especially useful for controls (such as a datepicker), where we cannot
          * anticipate all required language tags, as they may be app-specific.
          *
          * @param {*} i18nValue
          *    a possibly internationalized value:
          *    - when passing a primitive value, it is returned as-is
          *    - when passing an object, the languageTag is used as a key within that object
          * @param {*} [optionalFallbackValue]
          *    a value to use if no localization is available for the given language tag
          * @param {String} [languageTag]
          *    a language tag to override the current locale tag. Only available in _strict_ mode
          *
          * @return {*}
          *    the localized value if found, the fallback (or `undefined`) otherwise
          *
          * @memberof AxI18nHandler
          * @name localize
          */
         localize: localize,
         track: track,
         update: update,
         whenLocaleChanged: whenLocaleChanged
      };

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      /**
       * Updates the language tag for the configured locale by emitting the according `changeLocaleRequest`
       * event.
       *
       * @param {String} languageTag
       *    the language tag to propagate
       *
       * @return {Promise}
       *    the promise of the event cycle
       *
       * @memberof AxI18nHandler
       */
      function update(languageTag) {
         return eventBus.publishAndGatherReplies('changeLocaleRequest.' + locale, {
            locale: locale,
            languageTag: languageTag
         }, noDeliveryToSender).then(function () {
            tags[locale] = languageTag;
         });
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      /**
       * Returns the language tag set for the configured locale.
       * If no tag is available, `undefined` is returned.
       *
       * @return {String}
       *    the active language tag or `undefined`
       *
       * @memberof AxI18nHandler
       */
      function languageTag() {
         return tags[locale];
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      /**
       * References the current i18n state as an object under the given property of the context.
       *
       * If this method is not used, changes to the locale are still observed by the handler, but not
       * tracked on the context object. Use this to react to locale-changes in a data-driven fashion, for
       * example by using an AngularJS watcher.
       *
       * By default, the i18n state is stored under the feature path used to create this i18n handler ("i18n"
       * for the default handler provided by the "axI18n" widget service injection).
       *
       * The tracking structure stored under the property is an object that has two properties:
       *
       *   - `locale` is the constant locale topic that was configured for the tracked feature
       *   - `tags` is an object mapping all locale names to their normalized current language tag
       *
       * Note that tracked language tags are *normalized*, i.e. converted to lowercase with underscores (`_`)
       * replaced by dashes (`-`).
       *
       * @param {String} [property=trackingProperty]
       *    name of the context property to store the state under, defaults to the feature path
       *
       * @memberof AxI18nHandler
       */
      function track() {
         var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : trackingProperty;

         __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_object__["setPath"])(context, property, { locale: locale, tags: tags });
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      /**
       * Format an i18n value, by first localizing it and then applying substitutions.
       *
       * These are equivalent:
       * - `string.format( axI18n.localize( i18nValue ), numericArgs, namedArgs )`
       * - `axI18n.format( i18nValue, numericArgs, namedArgs )`.
       *
       * @param {String} i18nValue
       *    the value to localize and then format
       * @param {Array} [optionalIndexedReplacements]
       *    replacements for any numeric placeholders in the localized value
       * @param {Object} [optionalNamedReplacements]
       *    replacements for any named placeholders in the localized value
       *
       * @return {String}
       *    the formatted string after localization
       *
       * @memberof AxI18nHandler
       */
      function format(i18nValue, optionalIndexedReplacements, optionalNamedReplacements) {
         var formatString = localize(i18nValue);
         return formatString && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utilities_string__["format"])(formatString, optionalIndexedReplacements, optionalNamedReplacements);
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      /**
       * Registers a callback that is called whenever the new valid locale was received via event.
       *
       * @param {Function} callback
       *    the function to call on locale change
       *
       * @memberof AxI18nHandler
       */
      function whenLocaleChanged(callback) {
         callbacks[locale] = callbacks[locale] || [];
         callbacks[locale].push(callback);
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function localizeRelaxed(i18nValue, optionalFallbackValue) {
         if (!i18nValue || primitives[typeof i18nValue === 'undefined' ? 'undefined' : _typeof(i18nValue)]) {
            // value is not internationalized
            return i18nValue;
         }

         var tag = tags[locale];
         var tagParts = tag ? tag.replace(/-/g, '_').split('_') : [];
         while (tagParts.length > 0) {
            var currentLocaleTag = tagParts.join('-');
            var value = localizeStrict(i18nValue, undefined, currentLocaleTag);
            if (value !== undefined) {
               return value;
            }
            tagParts.pop();
         }

         return fallback ? localizeStrict(i18nValue, optionalFallbackValue, fallback) : optionalFallbackValue;
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////

      function localizeStrict(i18nValue, optionalFallbackValue) {
         var languageTag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : tags[locale];

         if (!i18nValue || primitives[typeof i18nValue === 'undefined' ? 'undefined' : _typeof(i18nValue)]) {
            // value is not internationalized
            return i18nValue;
         }
         if (!languageTag) {
            return optionalFallbackValue;
         }

         // Try one direct lookup before scanning the input keys,
         // assuming that language-tags are written in consistent style.
         var value = i18nValue[languageTag];
         if (value !== undefined) {
            return value;
         }

         var lookupKey = normalize(languageTag);
         var availableTags = Object.keys(i18nValue);
         var n = availableTags.length;
         for (var i = 0; i < n; ++i) {
            var t = availableTags[i];
            if (normalize(t) === lookupKey) {
               return i18nValue[t];
            }
         }

         return optionalFallbackValue;
      }
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function handleLocaleChange(_ref) {
      var locale = _ref.locale,
          languageTag = _ref.languageTag;

      var newTag = normalize(languageTag);
      if (newTag === tags[locale]) {
         return;
      }
      tags[locale] = newTag;
      callbacks[locale] = callbacks[locale] || [];
      callbacks[locale].forEach(function (f) {
         f(languageTag);
      });
   }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function memoize(f) {
   var cache = {};
   return function (key) {
      var value = cache[key];
      if (value === undefined) {
         value = f(key);
         cache[key] = value;
      }
      return value;
   };
}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */

/**
 * Factory for i18n widget service instances.
 *
 * @module widget_services_visibility
 */

// <-- temporary guard until https://github.com/LaxarJS/laxar-dox/issues/21 is fixed
var noDeliveryToSender = { deliverToSender: false };
var noOp = function noOp() {};

/**
 * Creates a widget-specific helper for `didChangeAreaVisibility` events.
 *
 * @param {AxContext} context
 *    the widget context/scope that the handler should work with. It uses the `eventBus` property there
 *    with which it can do the event handling. The visibility handler will set the boolean context property
 *    `isVisible` which can be used to determine the visibility state of the entire widget, e.g. for use in
 *    templates.
 *
 * @param {AxAreaHelper} areaHelper
 *    an area helper to qualify/unqualify names for this widget's areas
 *
 * @return {AxVisibility}
 *    a visibility handler instance
 */
function create(context, areaHelper) {

   /**
    * @constructor
    * @name AxVisibility
    */
   var api = {
      /**
       * Query the current visibility state.
       *
       * @return {Boolean}
       *    this current visibility status as determined through eventBus events
       *
       * @memberof AxVisibility
       */
      isVisible: function isVisible() {
         return areaHelper.isVisible(context.widget.area);
      },
      onChange: onChange,
      onHide: onHide,
      onShow: onShow,
      release: release,
      track: track,
      unsubscribe: unsubscribe,
      updateAreaVisibility: updateAreaVisibility,
      updateWidgetVisibility: updateWidgetVisibility
   };

   var isVisible = api.isVisible();

   var eventBus = context.eventBus;

   // state used for tracking the widget visibility

   var trackingProperty = void 0;
   var showListeners = [];
   var hideListeners = [];
   var unsubscribeToChanges = noOp;

   // state used for setting the visibility of the widget and its areas
   var visibilityByArea = {};
   var overrideByArea = {};
   var unsubscribeToAreaRequests = noOp;

   return api;

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Registers a callback to be run when this widget becomes hidden.
    *
    * @param {Function} callback
    *    a callback to be invoked whenever the widget becomes visible, with a boolean argument indicating
    *    the new visibility state (`false`). The callback will *not* be invoked for the start value (`false`).
    *
    * @return {AxVisibility}
    *    this instance for chaining
    *
    * @memberof AxVisibility
    */
   function onHide(callback) {
      hideListeners.push(callback);
      updateChangeSubscription();
      return api;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Registers a callback to be run when this widget becomes visbile.
    *
    * @param {Function} callback
    *    a callback to be invoked whenever the widget becomes visible, with a boolean argument indicating
    *    the new visibility state (`true`).
    *
    * @return {AxVisibility}
    *    this instance for chaining
    *
    * @memberof AxVisibility
    */
   function onShow(callback) {
      showListeners.push(callback);
      updateChangeSubscription();
      return api;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Registers a callback for changes to this widget's visibility.
    *
    * @param {Function} callback
    *    a callback to be invoked whenever the widget visibility changes, with a boolean argument indicating
    *    the new visibility state. The callback will *not* be invoked for the start value (`false`).
    *
    * @return {AxVisibility}
    *    this instance for chaining
    *
    * @memberof AxVisibility
    */
   function onChange(callback) {
      showListeners.push(callback);
      hideListeners.push(callback);
      updateChangeSubscription();
      return api;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Starts tracking visibility as a property on the context.
    *
    * Calling this repeatedly with different property names will stop previous properties from receiving
    * further updates, but will not remove previously set tracking properties from the context object.
    *
    * @param {String} property
    *    the name of the context property to maintain
    *
    * @return {AxVisibility}
    *    this instance for chaining
    *
    * @memberof AxVisibility
    */
   function track() {
      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'isVisible';

      trackingProperty = property;
      if (property !== null) {
         context[property] = isVisible;
      }
      updateChangeSubscription();
      return api;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Triggers a visibility change to the given area. The visibility of the area and its nested areas is
    * re-evaluated over the event bus. Use this to implement e.g. tabbing/accordion/expander widgets.
    *
    * @param {Object} visibilityByLocalArea
    *   A mapping of local area names (without the widget ID) to their new visibility state (Boolean).
    *   Areas that are omitted here are left as is. Areas that have not been set at all just assume the
    *   visibility state of the containing area.
    * @param {Object} [optionalOptions]
    *   Additional options
    * @param {Object} [optionalOptions.overrideContainer]
    *   Allows the specified areas to become visible even if the widget's container area is not visible.
    *
    * @return {Promise}
    *    a promise that is resolved (without a value) when the visibility change was applied
    *
    * @memberof AxVisibility
    */
   function updateAreaVisibility(visibilityByLocalArea) {
      var optionalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _optionalOptions$over = optionalOptions.overrideContainer,
          overrideContainer = _optionalOptions$over === undefined ? false : _optionalOptions$over;


      if (unsubscribeToAreaRequests === noOp) {
         var requestEvent = 'changeAreaVisibilityRequest.' + context.widget.id;
         unsubscribeToAreaRequests = eventBus.subscribe(requestEvent, responder(isAreaVisible));
      }

      var promises = Object.keys(visibilityByLocalArea).map(function (name) {
         var oldVisible = visibilityByArea[name];
         var oldOverride = overrideByArea[name];
         var visible = visibilityByArea[name] = visibilityByLocalArea[name];
         if (overrideContainer) {
            overrideByArea[name] = overrideContainer;
         } else if (oldOverride) {
            delete overrideByArea[name];
         }
         if (oldVisible !== visible || oldOverride !== overrideByArea[name]) {
            var area = areaHelper.fullName(name);
            var eventName = 'changeAreaVisibilityRequest.' + area + '.' + visible;
            return eventBus.publishAndGatherReplies(eventName, { area: area, visible: visible }, noDeliveryToSender);
         }
         return Promise.resolve();
      });

      return Promise.all(promises).then(noOp);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /* @private helper for updateAreaVisibility */
   function isAreaVisible(localAreaName, containerVisible) {
      var areaVisible = visibilityByArea[localAreaName];
      if (areaVisible === undefined) {
         return containerVisible;
      }
      return areaVisible && (containerVisible || overrideByArea[localAreaName]);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Triggers a visibility change the widget itself and all its areas, always overriding its container
    * visibility with the given value.
    * This simplifies implementing popup/popover/layer widgets, which always live in an invisible container
    * area, but need to show/hide all their owned areas.
    *
    * To control the visibility of individual areas, use #updateAreaVisibility
    *
    * @param {Boolean} visible
    *   The new visibility state of the widget.
    *
    * @return {AxVisibility}
    *    this instance for chaining
    *
    * @memberof AxVisibility
    */
   function updateWidgetVisibility(visible) {
      var widget = context.widget.id;
      var eventName = 'changeWidgetVisibilityRequest.' + widget + '.' + visible;
      return eventBus.publishAndGatherReplies(eventName, { widget: widget, visible: visible }, noDeliveryToSender);
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Remove the given callback (registered through one or more of the on... methods) from any subscriptions.
    *
    * @param {Function} callback
    *    a callback that was previously registered using any of the `on...` methods.
    *    It will be removed from all registrations. Passing an unknown callback has no effect.
    *
    * @return {AxVisibility}
    *    this instance for chaining
    *
    * @memberof AxVisibility
    */
   function unsubscribe(callback) {
      [showListeners, hideListeners].forEach(remove);

      function remove(array) {
         var index = array.indexOf(callback);
         if (index === -1) {
            return;
         }
         array.splice(index, 1);
         remove(array);
      }
      return api;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function release() {
      unsubscribeToAreaRequests();
      unsubscribeToChanges();
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function updateChangeSubscription() {
      var needsSubscription = trackingProperty || showListeners.length + hideListeners.length;
      if (needsSubscription && unsubscribeToChanges === noOp) {
         unsubscribeToChanges = eventBus.subscribe('didChangeAreaVisibility.' + context.widget.area, function (_ref) {
            var visible = _ref.visible;

            if (visible === isVisible) {
               return;
            }
            isVisible = visible;
            if (trackingProperty) {
               context[trackingProperty] = visible;
            }
            (visible ? showListeners : hideListeners).forEach(function (f) {
               return f(visible);
            });
         });
      } else if (unsubscribeToChanges && !needsSubscription) {
         unsubscribeToChanges();
         unsubscribeToChanges = noOp;
      }
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   function responder(callback) {
      return function (_ref2) {
         var area = _ref2.area,
             containerVisible = _ref2.visible;

         var visible = callback(areaHelper.localName(area), containerVisible);
         if (visible === true || visible === false) {
            var didEvent = 'didChangeAreaVisibility.' + area + '.' + visible;
            eventBus.publish(didEvent, { area: area, visible: visible }, noDeliveryToSender);
         }
      };
   }
}

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FLAT */
/* unused harmony export COMPACT */
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * A module for compatibility with old LaxarJS tooling.
 *
 * @module pages
 */

var FLAT = 'FLAT';
var COMPACT = 'COMPACT';

function create(tooling) {
   var listeners = [];
   var pageInfo = void 0;

   function onChange(event) {
      pageInfo = getPageInfo(event);
      listeners.forEach(function (callback) {
         callback(pageInfo);
      });
   }

   /**
    * @constructor
    * @name PagesTooling
    */
   return {
      /**
       * Start collecting page/composition data.
       * @memberof PagesTooling
       */
      enable: function enable() {
         tooling.unsubscribe(onChange);
         tooling.onChange(onChange);
      },


      /**
       * Stop collecting page/composition data.
       * @memberof PagesTooling
       */
      disable: function disable() {
         tooling.unsubscribe(onChange);
      },


      /**
       * Access the current page information.
       * Everything is returned as a copy, sothis object cannot be used to modify the host application.
       *
       * @return {Object}
       *   the current page information, with the following properties:
       *    - `pageDefinitions` {Object}
       *       both the original as well as the expanded/flattened page model for each available page
       *    - `compositionDefinitions` {Object}
       *       both the original as well as the expanded/flattened composition model for each composition of
       *       any available page
       *    - `widgetDescriptors` {Object}
       *       the widget descriptor for each widget that was referenced
       *    - `pageReference` {String}
       *       the reference for the current page, to lookup page/composition definitions
       * @memberof PagesTooling
       */
      current: function current() {
         return pageInfo;
      },


      /**
       * Add a listener function to be notified whenever the page information changes.
       * As a side-effect, this also automatically enables collecting page/composition data.
       * Each listener will be delivered its own copy of the page information.
       *
       * @param {Function} callback
       *    The listener to add. Will be called with the current page information whenever that changes.
       * @memberof PagesTooling
       */
      addListener: function addListener(callback) {
         listeners.push(callback);
      },


      /**
       * Remove a page information listener function.
       *
       * @param {Function} callback
       *    The listener to remove
       * @memberof PagesTooling
       */
      removeListener: function removeListener(callback) {
         var index = void 0;
         while ((index = listeners.indexOf(callback)) >= 0) {
            listeners.splice(index, 1);
         }
      }
   };
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Generate the "old" page info object from the debug info in the onChange event.
 *
 * @param {String} event
 *   the data received from the toolings onChange handler
 *
 * @return {Object} the page information
 * @private
 */
function getPageInfo(event) {
   var pageDefinitions = {};
   var compositionDefinitions = {};
   var widgetDescriptors = {};

   var pageReference = void 0;

   Object.keys(event.pages).forEach(function (ref) {
      var page = event.pages[ref];

      pageReference = ref;
      pageDefinitions[ref] = definitions(page);
      compositionDefinitions[ref] = {};

      page.compositions.forEach(function (composition) {
         compositionDefinitions[ref][composition.id] = definitions(composition);
      });
   });

   Object.keys(event.widgets).forEach(function (ref) {
      var widget = event.widgets[ref];

      widgetDescriptors[ref] = widget.DESC;
   });

   return {
      pageDefinitions: pageDefinitions,
      pageReference: pageReference,
      compositionDefinitions: compositionDefinitions,
      widgetDescriptors: widgetDescriptors
   };

   function definitions(info) {
      var _ref;

      return _ref = {}, _defineProperty(_ref, FLAT, info.FLAT), _defineProperty(_ref, COMPACT, info.COMPACT), _ref;
   }
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utilities_assert__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utilities_object__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages__ = __webpack_require__(31);
/* harmony export (immutable) */ __webpack_exports__["a"] = create;
/**
 * Copyright 2016 aixigo AG
 * Released under the MIT license.
 * http://laxarjs.org/license
 */
/**
 * Accepts static debug information from `laxar-loader/debug-info` and listens on the debug event bus to
 * supply development tools with the current state of the LaxarJS instance and bootstrapping items:
 *
 * @module tooling
 */





// eslint-disable-next-line valid-jsdoc
/** Exposes inspection data from laxarjs services to development tools */
function create(debugEventBus, log) {

   var debugInfoQueue = []; // a list of callbacks waiting for whenDebugInfoAvailable()
   var loadDebugInfo = void 0; // the debug info loader registered with registerDebugInfo()
   var debugInfo = void 0; // the actual debug info object loaded by loadDebugInfo( debugInfo => {} )

   var instanceListeners = [];
   var itemListeners = {};

   /**
    * @constructor
    * @name AxTooling
    */
   var api = Object.assign({
      forItem: forItem
   }, createToolingApi(instanceListeners), {

      registerDebugInfo: registerDebugInfo,
      registerItem: registerItem
   });

   addPagesTooling(api);

   return api;

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Get an {@link #AxTooling} interface for the given bootstrapping item.
    *
    * @param {ItemMeta} itemMeta
    *    an object identifying the bootstrapping item
    * @return {AxTooling}
    *    a tooling API for the given bootstrapping item
    * @memberof AxTooling
    */
   function forItem(_ref) {
      var instance = _ref.instance,
          item = _ref.item;

      var key = instance + '.' + item;
      if (!(key in itemListeners)) {
         log.warn('LaxarJS tooling: Not enabled for bootstrap item \'' + item + '\' in instance \'' + instance + '\'');
         return createToolingApi([]);
      }

      var api = createToolingApi(itemListeners[key]);
      addPagesTooling(api);
      return api;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Register a debug info object or callback with the tooling instance. Debug information can be generated
    * with `laxar-loader/debug-info` and may be in the form a function accepting a callback.
    * If debug information is needed, the function will be called to load it asynchronously.
    *
    * @param {Object|Function} debugInfo
    *    a debug information callback or object
    * @memberof AxTooling
    */
   function registerDebugInfo(debugInfo) {
      if (typeof debugInfo === 'function') {
         loadDebugInfo = debugInfo;
      } else {
         loadDebugInfo = function loadDebugInfo(callback) {
            callback(debugInfo);
         };
      }

      whenDebugInfoAvailable();
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Register a bootstrapping item with the tooling instance.
    *
    * @param {ItemMeta} itemMeta
    *    an object identifying the bootstrapping item
    * @memberof AxTooling
    */
   function registerItem(_ref2) {
      var instance = _ref2.instance,
          item = _ref2.item;

      var key = instance + '.' + item;
      var pending = [];

      var state = {
         pages: addLoadingStateHandler('page', instance, item, pending, onChange),
         widgets: addLoadingStateHandler('widget', instance, item, pending, onChange)
      };

      itemListeners[key] = [];

      function onChange() {
         if (instanceListeners.length > 0 || itemListeners[key].length > 0) {
            whenDebugInfoAvailable(function (debugInfo) {
               var event = {
                  instance: instance,
                  item: item,
                  pages: getActiveItems('pages', state.pages),
                  widgets: getActiveItems('widgets', state.widgets)
               };

               instanceListeners.forEach(callListener);
               itemListeners[key].forEach(callListener);

               function getActiveItems(category, refs) {
                  if (!debugInfo.aliases) {
                     return {};
                  }

                  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utilities_object__["tabulate"])(function (ref) {
                     var index = debugInfo.aliases[category][ref];
                     if (index === undefined) {
                        var message = ref + ' not present in ' + category + ' debug information';
                        log.info(message);
                        return { info: message };
                     }
                     return debugInfo[category][index];
                  }, refs);
               }

               function callListener(listener) {
                  listener(event);
               }
            });
         }
      }
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Create debugEventBus subscriptions for the load events related to the given type of artifact and scoped
    * to the given instance and item.
    *
    * @param {String} type
    *    the type of load event (page, widget, etc.) to subscribe to
    * @param {String} instance
    *    the instance name
    * @param {String} item
    *    the bootstrapping item id
    * @param {Array} pending
    *    an array to use for managing pending events
    * @param {Function} onChange
    *    a function to call when a change occurred and there are no more pending events
    * @return {Array}
    *    an array that will be updated with the currently active items of the given type in the given
    *    bootstrapping item.
    * @private
    */
   function addLoadingStateHandler(type, instance, item, pending, onChange) {
      var subtopic = type + '.' + instance + '.' + item;
      var active = [];

      var willLoad = 'willLoad.' + subtopic;
      var didLoad = 'didLoad.' + subtopic;
      var willUnload = 'willUnload.' + subtopic;
      var didUnload = 'didUnload.' + subtopic;

      debugEventBus.subscribe(willLoad, function (_ref3) {
         var ref = _ref3[type];

         pending.push(didLoad + ':' + ref);
      });
      debugEventBus.subscribe(didLoad, function (_ref4) {
         var ref = _ref4[type];

         remove(pending, didLoad + ':' + ref);
         active.push(ref);
         if (pending.length === 0) {
            onChange();
         }
      });
      debugEventBus.subscribe(willUnload, function (_ref5) {
         var ref = _ref5[type];

         pending.push(didUnload + ':' + ref);
      });
      debugEventBus.subscribe(didUnload, function (_ref6) {
         var ref = _ref6[type];

         remove(pending, didUnload + ':' + ref);
         remove(active, ref);
         if (pending.length === 0) {
            onChange();
         }
      });

      return active;
   }

   ///////////////////////////////////////////////////////////////////////////////////////////////////////////

   /**
    * Register a function to be called when debug info is available and trigger loading the debug information
    * if not present. If no callback was given, just re-check if the debug info was registered and possibly
    * handle queued callbacks.
    *
    * @param {Function} [callback]
    *    a function to be called with the debug information object
    * @private
    */
   function whenDebugInfoAvailable(callback) {
      if (callback) {
         if (debugInfo) {
            callback(debugInfo);
         } else {
            debugInfoQueue.push(callback);
         }
      }

      if (loadDebugInfo && debugInfoQueue.length > 0) {
         loadDebugInfo(function (info) {
            debugInfo = info;
            if (debugInfo.info && !debugInfo.aliases) {
               // debug info not available, but an informative message in .info
               log.info(debugInfo.info);
            } else {
               debugInfoQueue.splice(0).forEach(function (callback) {
                  callback(debugInfo);
               });
            }
         });
         loadDebugInfo = null;
      }
   }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function createToolingApi(listeners) {
   __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utilities_assert__["a" /* default */])(listeners).hasType(Array);

   return {
      /**
       * Register a function to be called when the composition of active observed items changes.
       *
       * @param {Function} callback
       *    a function to call with updated debug information
       * @return {AxTooling}
       *    the tooling instance
       * @memberof AxTooling
       */
      onChange: function onChange(callback) {
         listeners.push(callback);
         return this;
      },


      /**
       * Unsubscribe a registered {@link #AxTooling.onChange} callback
       *
       * @param {Function} callback
       *    a function that was previously passed to {@link #AxTooling.onChange}
       * @return {AxTooling}
       *    the tooling instance
       * @memberof AxTooling
       */
      unsubscribe: function unsubscribe(callback) {
         remove(listeners, callback);
         return this;
      },


      /**
       * A {@link PagesTooling} interface to the {@link AxTooling} instance.
       *
       * @type {PagesTooling}
       * @memberof AxTooling
       * @deprecated
       */
      pages: null,

      release: function release() {}
   };
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * Add a getter to create the old interface on demand.
 *
 * @param {AxTooling} api
 *    the tooling instance to enrich with the pages tooling
 * @private
 */
function addPagesTooling(api) {
   var pagesTooling = void 0;
   Object.defineProperty(api, 'pages', {
      get: function get() {
         if (!pagesTooling) {
            pagesTooling = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__pages__["a" /* create */])(api);
            pagesTooling.enable();
            api.destroy = function () {
               pagesTooling.disable();
            };
         }
         return pagesTooling;
      }
   });
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////

function remove(array, item) {
   var index = array.indexOf(item);
   if (index >= 0) {
      array.splice(index, 1);
   }
}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_33__;

/***/ })
/******/ ]);
});
//# sourceMappingURL=laxar.js.map


// WEBPACK FOOTER //
// ./~/laxar/dist/laxar.js